{
  "version": "6.4.0",
  "generated": "2026-02-01T09:38:44.875Z",
  "categories": [
    "Actions",
    "Business",
    "Communication",
    "Files & Folders",
    "Media",
    "Navigation",
    "Other",
    "Security",
    "Shopping",
    "Social & Brands",
    "Status & Alerts",
    "Text & Formatting",
    "Transportation",
    "UI & Interface",
    "Weather"
  ],
  "styles": {
    "solid": {
      "prefix": "fas",
      "label": "Solid"
    },
    "regular": {
      "prefix": "far",
      "label": "Regular"
    },
    "brands": {
      "prefix": "fab",
      "label": "Brands"
    }
  },
  "icons": [
    {
      "name": "0",
      "label": "0",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Zero",
        "nada",
        "none",
        "zero",
        "zilch"
      ],
      "unicode": "30"
    },
    {
      "name": "1",
      "label": "1",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit One",
        "one"
      ],
      "unicode": "31"
    },
    {
      "name": "2",
      "label": "2",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Two",
        "two"
      ],
      "unicode": "32"
    },
    {
      "name": "3",
      "label": "3",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Three",
        "three"
      ],
      "unicode": "33"
    },
    {
      "name": "4",
      "label": "4",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Four",
        "four"
      ],
      "unicode": "34"
    },
    {
      "name": "42-group",
      "label": "42.group",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e080"
    },
    {
      "name": "5",
      "label": "5",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Five",
        "five"
      ],
      "unicode": "35"
    },
    {
      "name": "500px",
      "label": "500px",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f26e"
    },
    {
      "name": "6",
      "label": "6",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Six",
        "six"
      ],
      "unicode": "36"
    },
    {
      "name": "7",
      "label": "7",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Seven",
        "seven"
      ],
      "unicode": "37"
    },
    {
      "name": "8",
      "label": "8",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Eight",
        "eight"
      ],
      "unicode": "38"
    },
    {
      "name": "9",
      "label": "9",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Digit Nine",
        "nine"
      ],
      "unicode": "39"
    },
    {
      "name": "a",
      "label": "A",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter A",
        "Latin Small Letter A",
        "letter"
      ],
      "unicode": "41"
    },
    {
      "name": "accessible-icon",
      "label": "Accessible Icon",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "accessibility",
        "disabled",
        "handicap",
        "person",
        "uer",
        "wheelchair",
        "wheelchair-alt"
      ],
      "unicode": "f368"
    },
    {
      "name": "accusoft",
      "label": "Accusoft",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f369"
    },
    {
      "name": "address-book",
      "label": "Address Book",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "contact",
        "directory",
        "employee",
        "index",
        "little black book",
        "portfolio",
        "rolodex",
        "uer",
        "username"
      ],
      "unicode": "f2b9"
    },
    {
      "name": "address-card",
      "label": "Address Card",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "about",
        "contact",
        "employee",
        "id",
        "identification",
        "portfolio",
        "postcard",
        "profile",
        "registration",
        "uer",
        "username"
      ],
      "unicode": "f2bb"
    },
    {
      "name": "adn",
      "label": "App.net",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f170"
    },
    {
      "name": "adversal",
      "label": "Adversal",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f36a"
    },
    {
      "name": "affiliatetheme",
      "label": "affiliatetheme",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f36b"
    },
    {
      "name": "airbnb",
      "label": "Airbnb",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f834"
    },
    {
      "name": "algolia",
      "label": "Algolia",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f36c"
    },
    {
      "name": "align-center",
      "label": "Align Center",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "format",
        "middle",
        "paragraph",
        "text"
      ],
      "unicode": "f037"
    },
    {
      "name": "align-justify",
      "label": "Align Justify",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "format",
        "paragraph",
        "text"
      ],
      "unicode": "f039"
    },
    {
      "name": "align-left",
      "label": "Align Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "format",
        "paragraph",
        "text"
      ],
      "unicode": "f036"
    },
    {
      "name": "align-right",
      "label": "Align Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "format",
        "paragraph",
        "text"
      ],
      "unicode": "f038"
    },
    {
      "name": "alipay",
      "label": "Alipay",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f642"
    },
    {
      "name": "amazon",
      "label": "Amazon",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f270"
    },
    {
      "name": "amazon-pay",
      "label": "Amazon Pay",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f42c"
    },
    {
      "name": "amilia",
      "label": "Amilia",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f36d"
    },
    {
      "name": "anchor",
      "label": "Anchor",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Transportation"
      ],
      "search": [
        "anchor",
        "berth",
        "boat",
        "dock",
        "embed",
        "link",
        "maritime",
        "moor",
        "port",
        "secure",
        "ship",
        "tool"
      ],
      "unicode": "f13d"
    },
    {
      "name": "anchor-circle-check",
      "label": "Anchor Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "enable",
        "marina",
        "not affected",
        "ok",
        "okay",
        "port",
        "validate",
        "working"
      ],
      "unicode": "e4aa"
    },
    {
      "name": "anchor-circle-exclamation",
      "label": "Anchor Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "failed",
        "marina",
        "port"
      ],
      "unicode": "e4ab"
    },
    {
      "name": "anchor-circle-xmark",
      "label": "Anchor Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "destroy",
        "marina",
        "port",
        "uncheck"
      ],
      "unicode": "e4ac"
    },
    {
      "name": "anchor-lock",
      "label": "Anchor Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "closed",
        "lockdown",
        "marina",
        "padlock",
        "port",
        "privacy",
        "quarantine"
      ],
      "unicode": "e4ad"
    },
    {
      "name": "android",
      "label": "Android",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "robot"
      ],
      "unicode": "f17b"
    },
    {
      "name": "angellist",
      "label": "AngelList",
      "styles": [
        "brands"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [],
      "unicode": "f209"
    },
    {
      "name": "angle-down",
      "label": "Angle Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Transportation"
      ],
      "search": [
        "Down Arrowhead",
        "arrow",
        "caret",
        "download",
        "expand",
        "insert"
      ],
      "unicode": "f107"
    },
    {
      "name": "angle-left",
      "label": "Angle Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "Single Left-Pointing Angle Quotation Mark",
        "arrow",
        "back",
        "caret",
        "less",
        "previous"
      ],
      "unicode": "f104"
    },
    {
      "name": "angle-right",
      "label": "Angle Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "Single Right-Pointing Angle Quotation Mark",
        "arrow",
        "care",
        "forward",
        "more",
        "next"
      ],
      "unicode": "f105"
    },
    {
      "name": "angle-up",
      "label": "Angle Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Transportation"
      ],
      "search": [
        "Up Arrowhead",
        "arrow",
        "caret",
        "collapse",
        "upgrade",
        "upload"
      ],
      "unicode": "f106"
    },
    {
      "name": "angles-down",
      "label": "Angles Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Transportation"
      ],
      "search": [
        "arrows",
        "caret",
        "download",
        "expand"
      ],
      "unicode": "f103"
    },
    {
      "name": "angles-left",
      "label": "Angles Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Text & Formatting",
        "Transportation"
      ],
      "search": [
        "Left-Pointing Double Angle Quotation Mark",
        "arrows",
        "back",
        "caret",
        "laquo",
        "previous",
        "quote"
      ],
      "unicode": "f100"
    },
    {
      "name": "angles-right",
      "label": "Angles Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Text & Formatting",
        "Transportation"
      ],
      "search": [
        "Right-Pointing Double Angle Quotation Mark",
        "arrows",
        "caret",
        "forward",
        "more",
        "next",
        "quote",
        "raquo"
      ],
      "unicode": "f101"
    },
    {
      "name": "angles-up",
      "label": "Angles Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Transportation"
      ],
      "search": [
        "arrows",
        "caret",
        "collapse",
        "upload"
      ],
      "unicode": "f102"
    },
    {
      "name": "angrycreative",
      "label": "Angry Creative",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f36e"
    },
    {
      "name": "angular",
      "label": "Angular",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f420"
    },
    {
      "name": "ankh",
      "label": "Ankh",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Ankh",
        "amulet",
        "copper",
        "coptic christianity",
        "copts",
        "crux ansata",
        "egypt",
        "venus"
      ],
      "unicode": "f644"
    },
    {
      "name": "app-store",
      "label": "App Store",
      "styles": [
        "brands"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [],
      "unicode": "f36f"
    },
    {
      "name": "app-store-ios",
      "label": "iOS App Store",
      "styles": [
        "brands"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [],
      "unicode": "f370"
    },
    {
      "name": "apper",
      "label": "Apper Systems AB",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f371"
    },
    {
      "name": "apple",
      "label": "Apple",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "fruit",
        "ios",
        "mac",
        "operating system",
        "os",
        "osx"
      ],
      "unicode": "f179"
    },
    {
      "name": "apple-pay",
      "label": "Apple Pay",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f415"
    },
    {
      "name": "apple-whole",
      "label": "Apple Whole",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "apple",
        "fall",
        "fruit",
        "fuji",
        "green",
        "green apple",
        "macintosh",
        "orchard",
        "red",
        "red apple",
        "seasonal",
        "vegan"
      ],
      "unicode": "f5d1"
    },
    {
      "name": "archway",
      "label": "Archway",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "arc",
        "monument",
        "road",
        "street",
        "tunnel"
      ],
      "unicode": "f557"
    },
    {
      "name": "arrow-down",
      "label": "Arrow Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "Downwards Arrow",
        "download"
      ],
      "unicode": "f063"
    },
    {
      "name": "arrow-down-1-9",
      "label": "Arrow Down 1 9",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "numbers",
        "order",
        "sort-numeric-asc"
      ],
      "unicode": "f162"
    },
    {
      "name": "arrow-down-9-1",
      "label": "Arrow Down 9 1",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "numbers",
        "order",
        "sort-numeric-asc"
      ],
      "unicode": "f886"
    },
    {
      "name": "arrow-down-a-z",
      "label": "Arrow Down A Z",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "alphabetical",
        "arrange",
        "filter",
        "order",
        "sort-alpha-asc"
      ],
      "unicode": "f15d"
    },
    {
      "name": "arrow-down-long",
      "label": "Arrow Down Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "download",
        "long-arrow-down"
      ],
      "unicode": "f175"
    },
    {
      "name": "arrow-down-short-wide",
      "label": "Arrow Down Short Wide",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "order",
        "sort-amount-asc"
      ],
      "unicode": "f884"
    },
    {
      "name": "arrow-down-up-across-line",
      "label": "Arrow Down Up Across Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "border",
        "crossing",
        "transfer"
      ],
      "unicode": "e4af"
    },
    {
      "name": "arrow-down-up-lock",
      "label": "Arrow Down Up Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Security"
      ],
      "search": [
        "border",
        "closed",
        "crossing",
        "lockdown",
        "padlock",
        "privacy",
        "quarantine",
        "transfer"
      ],
      "unicode": "e4b0"
    },
    {
      "name": "arrow-down-wide-short",
      "label": "Arrow Down Wide Short",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "number",
        "order",
        "sort-amount-asc"
      ],
      "unicode": "f160"
    },
    {
      "name": "arrow-down-z-a",
      "label": "Arrow Down Z A",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "alphabetical",
        "arrange",
        "filter",
        "order",
        "sort-alpha-asc"
      ],
      "unicode": "f881"
    },
    {
      "name": "arrow-left",
      "label": "Arrow Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Leftwards Arrow",
        "back",
        "previous"
      ],
      "unicode": "f060"
    },
    {
      "name": "arrow-left-long",
      "label": "Arrow Left Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "back",
        "long-arrow-left",
        "previous"
      ],
      "unicode": "f177"
    },
    {
      "name": "arrow-pointer",
      "label": "Arrow Pointer",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "cursor",
        "select"
      ],
      "unicode": "f245"
    },
    {
      "name": "arrow-right",
      "label": "Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Rightwards Arrow",
        "forward",
        "next"
      ],
      "unicode": "f061"
    },
    {
      "name": "arrow-right-arrow-left",
      "label": "Arrow Right Arrow Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Rightwards Arrow Over Leftwards Arrow",
        "arrow",
        "arrows",
        "reciprocate",
        "return",
        "swap",
        "transfer"
      ],
      "unicode": "f0ec"
    },
    {
      "name": "arrow-right-from-bracket",
      "label": "Arrow Right From Bracket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "exit",
        "leave",
        "log out",
        "logout"
      ],
      "unicode": "f08b"
    },
    {
      "name": "arrow-right-long",
      "label": "Arrow Right Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "forward",
        "long-arrow-right",
        "next"
      ],
      "unicode": "f178"
    },
    {
      "name": "arrow-right-to-bracket",
      "label": "Arrow Right To Bracket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "enter",
        "insert",
        "join",
        "log in",
        "login",
        "sign in",
        "sign up",
        "sign-in",
        "signin",
        "signup"
      ],
      "unicode": "f090"
    },
    {
      "name": "arrow-right-to-city",
      "label": "Arrow Right To City",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "building",
        "city",
        "exodus",
        "insert",
        "rural",
        "urban"
      ],
      "unicode": "e4b3"
    },
    {
      "name": "arrow-rotate-left",
      "label": "Arrow Rotate Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions",
        "Business",
        "Security"
      ],
      "search": [
        "Anticlockwise Open Circle Arrow",
        "back",
        "control z",
        "exchange",
        "oops",
        "return",
        "rotate",
        "swap"
      ],
      "unicode": "f0e2"
    },
    {
      "name": "arrow-rotate-right",
      "label": "Arrow Rotate Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions",
        "Business",
        "Security"
      ],
      "search": [
        "Clockwise Open Circle Arrow",
        "forward",
        "refresh",
        "reload",
        "renew",
        "repeat",
        "retry"
      ],
      "unicode": "f01e"
    },
    {
      "name": "arrow-trend-down",
      "label": "Arrow Trend Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "line",
        "stocks",
        "trend"
      ],
      "unicode": "e097"
    },
    {
      "name": "arrow-trend-up",
      "label": "Arrow Trend Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "line",
        "stocks",
        "trend"
      ],
      "unicode": "e098"
    },
    {
      "name": "arrow-turn-down",
      "label": "Arrow Turn Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow"
      ],
      "unicode": "f149"
    },
    {
      "name": "arrow-turn-up",
      "label": "Arrow Turn Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow"
      ],
      "unicode": "f148"
    },
    {
      "name": "arrow-up",
      "label": "Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "Upwards Arrow",
        "forward",
        "upgrade",
        "upload"
      ],
      "unicode": "f062"
    },
    {
      "name": "arrow-up-1-9",
      "label": "Arrow Up 1 9",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "numbers",
        "order",
        "sort-numeric-desc"
      ],
      "unicode": "f163"
    },
    {
      "name": "arrow-up-9-1",
      "label": "Arrow Up 9 1",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "numbers",
        "order",
        "sort-numeric-desc"
      ],
      "unicode": "f887"
    },
    {
      "name": "arrow-up-a-z",
      "label": "Arrow Up A Z",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "alphabetical",
        "arrange",
        "filter",
        "order",
        "sort-alpha-desc"
      ],
      "unicode": "f15e"
    },
    {
      "name": "arrow-up-from-bracket",
      "label": "Arrow Up From Bracket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "share",
        "transfer",
        "upgrade",
        "upload"
      ],
      "unicode": "e09a"
    },
    {
      "name": "arrow-up-from-ground-water",
      "label": "Arrow Up From Ground Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "groundwater",
        "spring",
        "upgrade",
        "water supply",
        "water table"
      ],
      "unicode": "e4b5"
    },
    {
      "name": "arrow-up-from-water-pump",
      "label": "Arrow Up From Water Pump",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "flood",
        "groundwater",
        "pump",
        "submersible",
        "sump pump",
        "upgrade"
      ],
      "unicode": "e4b6"
    },
    {
      "name": "arrow-up-long",
      "label": "Arrow Up Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "long-arrow-up",
        "upload"
      ],
      "unicode": "f176"
    },
    {
      "name": "arrow-up-right-dots",
      "label": "Arrow Up Right Dots",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "growth",
        "increase",
        "population",
        "upgrade"
      ],
      "unicode": "e4b7"
    },
    {
      "name": "arrow-up-right-from-square",
      "label": "Arrow Up Right From Square",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "new",
        "open",
        "send",
        "share",
        "upgrade"
      ],
      "unicode": "f08e"
    },
    {
      "name": "arrow-up-short-wide",
      "label": "Arrow Up Short Wide",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "order",
        "sort-amount-desc"
      ],
      "unicode": "f885"
    },
    {
      "name": "arrow-up-wide-short",
      "label": "Arrow Up Wide Short",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "filter",
        "order",
        "sort-amount-desc",
        "upgrade"
      ],
      "unicode": "f161"
    },
    {
      "name": "arrow-up-z-a",
      "label": "Arrow Up Z A",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "alphabetical",
        "arrange",
        "filter",
        "order",
        "sort-alpha-desc"
      ],
      "unicode": "f882"
    },
    {
      "name": "arrows-down-to-line",
      "label": "Arrows Down To Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "insert",
        "scale down",
        "sink"
      ],
      "unicode": "e4b8"
    },
    {
      "name": "arrows-down-to-people",
      "label": "Arrows Down To People",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "affected",
        "focus",
        "insert",
        "targeted",
        "together",
        "uer"
      ],
      "unicode": "e4b9"
    },
    {
      "name": "arrows-left-right",
      "label": "Arrows Left Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "expand",
        "horizontal",
        "landscape",
        "resize",
        "wide"
      ],
      "unicode": "f07e"
    },
    {
      "name": "arrows-left-right-to-line",
      "label": "Arrows Left Right To Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "analysis",
        "expand",
        "gap"
      ],
      "unicode": "e4ba"
    },
    {
      "name": "arrows-rotate",
      "label": "Arrows Rotate",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Business",
        "Security"
      ],
      "search": [
        "Clockwise Right and Left Semicircle Arrows",
        "clockwise",
        "exchange",
        "modify",
        "refresh",
        "reload",
        "renew",
        "retry",
        "rotate",
        "swap"
      ],
      "unicode": "f021"
    },
    {
      "name": "arrows-spin",
      "label": "Arrows Spin",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "cycle",
        "rotate",
        "spin",
        "whirl"
      ],
      "unicode": "e4bb"
    },
    {
      "name": "arrows-split-up-and-left",
      "label": "Arrows Split Up And Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "agile",
        "split"
      ],
      "unicode": "e4bc"
    },
    {
      "name": "arrows-to-circle",
      "label": "Arrows To Circle",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "center",
        "concentrate",
        "coordinate",
        "coordination",
        "focal point",
        "focus",
        "insert"
      ],
      "unicode": "e4bd"
    },
    {
      "name": "arrows-to-dot",
      "label": "Arrows To Dot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "assembly point",
        "center",
        "condense",
        "focus",
        "insert",
        "minimize"
      ],
      "unicode": "e4be"
    },
    {
      "name": "arrows-to-eye",
      "label": "Arrows To Eye",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Security"
      ],
      "search": [
        "center",
        "coordinated assessment",
        "focus"
      ],
      "unicode": "e4bf"
    },
    {
      "name": "arrows-turn-right",
      "label": "Arrows Turn Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrows"
      ],
      "unicode": "e4c0"
    },
    {
      "name": "arrows-turn-to-dots",
      "label": "Arrows Turn To Dots",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "destination",
        "insert",
        "nexus"
      ],
      "unicode": "e4c1"
    },
    {
      "name": "arrows-up-down",
      "label": "Arrows Up Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "expand",
        "portrait",
        "resize",
        "tall",
        "vertical"
      ],
      "unicode": "f07d"
    },
    {
      "name": "arrows-up-down-left-right",
      "label": "Arrows Up Down Left Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "arrows",
        "bigger",
        "enlarge",
        "expand",
        "fullscreen",
        "move",
        "position",
        "reorder",
        "resize"
      ],
      "unicode": "f047"
    },
    {
      "name": "arrows-up-to-line",
      "label": "Arrows Up To Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "rise",
        "scale up",
        "upgrade"
      ],
      "unicode": "e4c2"
    },
    {
      "name": "artstation",
      "label": "Artstation",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f77a"
    },
    {
      "name": "asterisk",
      "label": "Asterisk",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "Asterisk",
        "Heavy Asterisk",
        "annotation",
        "details",
        "reference",
        "required",
        "star"
      ],
      "unicode": "2a"
    },
    {
      "name": "asymmetrik",
      "label": "Asymmetrik, Ltd.",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f372"
    },
    {
      "name": "at",
      "label": "At",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "Commercial At",
        "address",
        "author",
        "e-mail",
        "email",
        "fluctuate",
        "handle"
      ],
      "unicode": "40"
    },
    {
      "name": "atlassian",
      "label": "Atlassian",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f77b"
    },
    {
      "name": "atom",
      "label": "Atom",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "atheism",
        "atheist",
        "atom",
        "atom symbol",
        "chemistry",
        "electron",
        "ion",
        "isotope",
        "knowledge",
        "neutron",
        "nuclear",
        "proton",
        "science"
      ],
      "unicode": "f5d2"
    },
    {
      "name": "audible",
      "label": "Audible",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f373"
    },
    {
      "name": "audio-description",
      "label": "Audio Description",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "blind",
        "narration",
        "video",
        "visual"
      ],
      "unicode": "f29e"
    },
    {
      "name": "austral-sign",
      "label": "Austral Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Austral Sign",
        "currency"
      ],
      "unicode": "e0a9"
    },
    {
      "name": "autoprefixer",
      "label": "Autoprefixer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f41c"
    },
    {
      "name": "avianex",
      "label": "avianex",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f374"
    },
    {
      "name": "aviato",
      "label": "Aviato",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f421"
    },
    {
      "name": "award",
      "label": "Award",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "guarantee",
        "honor",
        "praise",
        "prize",
        "recognition",
        "ribbon",
        "trophy",
        "warranty"
      ],
      "unicode": "f559"
    },
    {
      "name": "aws",
      "label": "Amazon Web Services (AWS)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f375"
    },
    {
      "name": "b",
      "label": "B",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter B",
        "Latin Small Letter B",
        "letter"
      ],
      "unicode": "42"
    },
    {
      "name": "baby",
      "label": "Baby",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "uer",
        "users-people"
      ],
      "unicode": "f77c"
    },
    {
      "name": "baby-carriage",
      "label": "Baby Carriage",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "buggy",
        "carrier",
        "infant",
        "push",
        "stroller",
        "transportation",
        "walk",
        "wheels"
      ],
      "unicode": "f77d"
    },
    {
      "name": "backward",
      "label": "Backward",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Weather"
      ],
      "search": [
        "arrow",
        "double",
        "fast reverse button",
        "previous",
        "rewind"
      ],
      "unicode": "f04a"
    },
    {
      "name": "backward-fast",
      "label": "Backward Fast",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Weather"
      ],
      "search": [
        "arrow",
        "beginning",
        "first",
        "last track button",
        "previous",
        "previous scene",
        "previous track",
        "quick",
        "rewind",
        "start",
        "triangle"
      ],
      "unicode": "f049"
    },
    {
      "name": "backward-step",
      "label": "Backward Step",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Weather"
      ],
      "search": [
        "beginning",
        "first",
        "previous",
        "rewind",
        "start"
      ],
      "unicode": "f048"
    },
    {
      "name": "bacon",
      "label": "Bacon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bacon",
        "blt",
        "breakfast",
        "food",
        "ham",
        "lard",
        "meat",
        "pancetta",
        "pork",
        "rasher"
      ],
      "unicode": "f7e5"
    },
    {
      "name": "bacteria",
      "label": "Bacteria",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "antibiotic",
        "antibody",
        "covid-19",
        "health",
        "organism",
        "sick"
      ],
      "unicode": "e059"
    },
    {
      "name": "bacterium",
      "label": "Bacterium",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "antibiotic",
        "antibody",
        "covid-19",
        "germ",
        "health",
        "organism",
        "sick"
      ],
      "unicode": "e05a"
    },
    {
      "name": "bag-shopping",
      "label": "Bag Shopping",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Shopping"
      ],
      "search": [
        "buy",
        "checkout",
        "grocery",
        "payment",
        "purchase"
      ],
      "unicode": "f290"
    },
    {
      "name": "bahai",
      "label": "Bahai",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "bahai",
        "bahá'í",
        "star"
      ],
      "unicode": "f666"
    },
    {
      "name": "baht-sign",
      "label": "Baht Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "currency"
      ],
      "unicode": "e0ac"
    },
    {
      "name": "ban",
      "label": "Ban",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Actions",
        "Media",
        "Security"
      ],
      "search": [
        "404",
        "abort",
        "ban",
        "block",
        "cancel",
        "delete",
        "deny",
        "disabled",
        "entry",
        "failed",
        "forbidden",
        "hide",
        "no",
        "not",
        "not found",
        "prohibit",
        "prohibited",
        "remove",
        "stop",
        "trash"
      ],
      "unicode": "f05e"
    },
    {
      "name": "ban-smoking",
      "label": "Ban Smoking",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "ban",
        "cancel",
        "deny",
        "disabled",
        "forbidden",
        "no",
        "no smoking",
        "non-smoking",
        "not",
        "prohibited",
        "smoking"
      ],
      "unicode": "f54d"
    },
    {
      "name": "bandage",
      "label": "Bandage",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "adhesive bandage",
        "bandage",
        "boo boo",
        "first aid",
        "modify",
        "ouch"
      ],
      "unicode": "f462"
    },
    {
      "name": "bandcamp",
      "label": "Bandcamp",
      "styles": [
        "brands"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [],
      "unicode": "f2d5"
    },
    {
      "name": "bangladeshi-taka-sign",
      "label": "Bangladeshi Taka Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "bdt",
        "currency",
        "tk"
      ],
      "unicode": "e2e6"
    },
    {
      "name": "barcode",
      "label": "Barcode",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "info",
        "laser",
        "price",
        "scan",
        "upc"
      ],
      "unicode": "f02a"
    },
    {
      "name": "bars",
      "label": "Bars",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "checklist",
        "drag",
        "hamburger",
        "list",
        "menu",
        "nav",
        "navigation",
        "ol",
        "reorder",
        "settings",
        "todo",
        "ul"
      ],
      "unicode": "f0c9"
    },
    {
      "name": "bars-progress",
      "label": "Bars Progress",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "checklist",
        "downloading",
        "downloads",
        "loading",
        "poll",
        "progress",
        "project management",
        "settings",
        "to do"
      ],
      "unicode": "f828"
    },
    {
      "name": "bars-staggered",
      "label": "Bars Staggered",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business",
        "Text & Formatting",
        "Shopping"
      ],
      "search": [
        "flow",
        "list",
        "timeline"
      ],
      "unicode": "f550"
    },
    {
      "name": "baseball",
      "label": "Baseball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ball",
        "baseball",
        "foul",
        "glove",
        "hardball",
        "league",
        "leather",
        "mlb",
        "softball",
        "sport",
        "underarm"
      ],
      "unicode": "f433"
    },
    {
      "name": "baseball-bat-ball",
      "label": "Baseball Bat Ball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bat",
        "league",
        "mlb",
        "slugger",
        "softball",
        "sport"
      ],
      "unicode": "f432"
    },
    {
      "name": "basket-shopping",
      "label": "Basket Shopping",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Shopping"
      ],
      "search": [
        "buy",
        "checkout",
        "grocery",
        "payment",
        "purchase"
      ],
      "unicode": "f291"
    },
    {
      "name": "basketball",
      "label": "Basketball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "ball",
        "basketball",
        "dribble",
        "dunk",
        "hoop",
        "nba"
      ],
      "unicode": "f434"
    },
    {
      "name": "bath",
      "label": "Bath",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bath",
        "bathtub",
        "clean",
        "shower",
        "tub",
        "wash"
      ],
      "unicode": "f2cd"
    },
    {
      "name": "battery-empty",
      "label": "Battery Empty",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "charge",
        "dead",
        "power",
        "status"
      ],
      "unicode": "f244"
    },
    {
      "name": "battery-full",
      "label": "Battery Full",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "batter",
        "battery",
        "charge",
        "power",
        "status"
      ],
      "unicode": "f240"
    },
    {
      "name": "battery-half",
      "label": "Battery Half",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "charge",
        "power",
        "status"
      ],
      "unicode": "f242"
    },
    {
      "name": "battery-quarter",
      "label": "Battery Quarter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "charge",
        "low",
        "power",
        "status"
      ],
      "unicode": "f243"
    },
    {
      "name": "battery-three-quarters",
      "label": "Battery Three Quarters",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "charge",
        "power",
        "status"
      ],
      "unicode": "f241"
    },
    {
      "name": "battle-net",
      "label": "Battle.net",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f835"
    },
    {
      "name": "bed",
      "label": "Bed",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "hospital",
        "hotel",
        "lodging",
        "mattress",
        "patient",
        "person in bed",
        "rest",
        "sleep",
        "travel",
        "uer"
      ],
      "unicode": "f236"
    },
    {
      "name": "bed-pulse",
      "label": "Bed Pulse",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "EKG",
        "bed",
        "electrocardiogram",
        "health",
        "hospital",
        "life",
        "patient",
        "vital"
      ],
      "unicode": "f487"
    },
    {
      "name": "beer-mug-empty",
      "label": "Beer Mug Empty",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "ale",
        "bar",
        "beverage",
        "brew",
        "brewery",
        "drink",
        "foam",
        "lager",
        "liquor",
        "mug",
        "stein"
      ],
      "unicode": "f0fc"
    },
    {
      "name": "behance",
      "label": "Behance",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1b4"
    },
    {
      "name": "bell",
      "label": "Bell",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "alarm",
        "alert",
        "bel",
        "bell",
        "chime",
        "notification",
        "reminder",
        "request"
      ],
      "unicode": "f0f3"
    },
    {
      "name": "bell-concierge",
      "label": "Bell Concierge",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "attention",
        "bell",
        "bellhop",
        "bellhop bell",
        "hotel",
        "receptionist",
        "request",
        "service",
        "support"
      ],
      "unicode": "f562"
    },
    {
      "name": "bell-slash",
      "label": "Bell Slash",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "alert",
        "bell",
        "bell with slash",
        "cancel",
        "disabled",
        "forbidden",
        "mute",
        "notification",
        "off",
        "quiet",
        "reminder",
        "silent"
      ],
      "unicode": "f1f6"
    },
    {
      "name": "bezier-curve",
      "label": "Bezier Curve",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "curves",
        "illustrator",
        "lines",
        "path",
        "vector"
      ],
      "unicode": "f55b"
    },
    {
      "name": "bicycle",
      "label": "Bicycle",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "bicycle",
        "bike",
        "gears",
        "pedal",
        "transportation",
        "vehicle"
      ],
      "unicode": "f206"
    },
    {
      "name": "bilibili",
      "label": "Bilibili",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e3d9"
    },
    {
      "name": "bimobject",
      "label": "BIMobject",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f378"
    },
    {
      "name": "binoculars",
      "label": "Binoculars",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "glasses",
        "inspection",
        "magnifier",
        "magnify",
        "scenic",
        "spyglass",
        "view"
      ],
      "unicode": "f1e5"
    },
    {
      "name": "biohazard",
      "label": "Biohazard",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "biohazard",
        "covid-19",
        "danger",
        "dangerous",
        "epidemic",
        "hazmat",
        "medical",
        "pandemic",
        "radioactive",
        "sign",
        "toxic",
        "waste",
        "zombie"
      ],
      "unicode": "f780"
    },
    {
      "name": "bitbucket",
      "label": "Bitbucket",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "atlassian",
        "bitbucket-square",
        "git"
      ],
      "unicode": "f171"
    },
    {
      "name": "bitcoin",
      "label": "Bitcoin",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f379"
    },
    {
      "name": "bitcoin-sign",
      "label": "Bitcoin Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Bitcoin Sign",
        "currency"
      ],
      "unicode": "e0b4"
    },
    {
      "name": "bity",
      "label": "Bity",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f37a"
    },
    {
      "name": "black-tie",
      "label": "Font Awesome Black Tie",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "administrator"
      ],
      "unicode": "f27e"
    },
    {
      "name": "blackberry",
      "label": "BlackBerry",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f37b"
    },
    {
      "name": "blender",
      "label": "Blender",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cocktail",
        "milkshake",
        "mixer",
        "puree",
        "smoothie"
      ],
      "unicode": "f517"
    },
    {
      "name": "blender-phone",
      "label": "Blender Phone",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "appliance",
        "cocktail",
        "fantasy",
        "milkshake",
        "mixer",
        "puree",
        "silly",
        "smoothie"
      ],
      "unicode": "f6b6"
    },
    {
      "name": "blog",
      "label": "Blog",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "journal",
        "log",
        "online",
        "personal",
        "post",
        "web 2.0",
        "wordpress",
        "writing"
      ],
      "unicode": "f781"
    },
    {
      "name": "blogger",
      "label": "Blogger",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f37c"
    },
    {
      "name": "blogger-b",
      "label": "Blogger B",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f37d"
    },
    {
      "name": "bluesky",
      "label": "Bluesky",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "social network"
      ],
      "unicode": "e671"
    },
    {
      "name": "bluetooth",
      "label": "Bluetooth",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "signal"
      ],
      "unicode": "f293"
    },
    {
      "name": "bluetooth-b",
      "label": "Bluetooth",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f294"
    },
    {
      "name": "bold",
      "label": "Bold",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "emphasis",
        "format",
        "text"
      ],
      "unicode": "f032"
    },
    {
      "name": "bolt",
      "label": "Bolt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping",
        "Weather"
      ],
      "search": [
        "charge",
        "danger",
        "electric",
        "electricity",
        "flash",
        "high voltage",
        "lightning",
        "voltage",
        "weather",
        "zap"
      ],
      "unicode": "f0e7"
    },
    {
      "name": "bolt-lightning",
      "label": "Bolt Lightning",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "electricity",
        "flash",
        "lightning",
        "weather",
        "zap"
      ],
      "unicode": "e0b7"
    },
    {
      "name": "bomb",
      "label": "Bomb",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "bomb",
        "comic",
        "error",
        "explode",
        "fuse",
        "grenade",
        "warning"
      ],
      "unicode": "f1e2"
    },
    {
      "name": "bone",
      "label": "Bone",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bone",
        "calcium",
        "dog",
        "skeletal",
        "skeleton",
        "tibia"
      ],
      "unicode": "f5d7"
    },
    {
      "name": "bong",
      "label": "Bong",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "aparatus",
        "cannabis",
        "marijuana",
        "pipe",
        "smoke",
        "smoking"
      ],
      "unicode": "f55c"
    },
    {
      "name": "book",
      "label": "Book",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "book",
        "cover",
        "decorated",
        "diary",
        "documentation",
        "journal",
        "knowledge",
        "library",
        "notebook",
        "notebook with decorative cover",
        "read",
        "research",
        "scholar"
      ],
      "unicode": "f02d"
    },
    {
      "name": "book-atlas",
      "label": "Book Atlas",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Business"
      ],
      "search": [
        "book",
        "directions",
        "geography",
        "globe",
        "knowledge",
        "library",
        "map",
        "research",
        "travel",
        "wayfinding"
      ],
      "unicode": "f558"
    },
    {
      "name": "book-bible",
      "label": "Book Bible",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "book",
        "catholicism",
        "christianity",
        "god",
        "holy"
      ],
      "unicode": "f647"
    },
    {
      "name": "book-bookmark",
      "label": "Book Bookmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "knowledge",
        "library",
        "research"
      ],
      "unicode": "e0bb"
    },
    {
      "name": "book-journal-whills",
      "label": "Book Journal Whills",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "book",
        "force",
        "jedi",
        "sith",
        "star wars",
        "yoda"
      ],
      "unicode": "f66a"
    },
    {
      "name": "book-medical",
      "label": "Book Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "diary",
        "documentation",
        "health",
        "history",
        "journal",
        "library",
        "read",
        "record",
        "research"
      ],
      "unicode": "f7e6"
    },
    {
      "name": "book-open",
      "label": "Book Open",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "Book",
        "book",
        "flyer",
        "knowledge",
        "library",
        "notebook",
        "open",
        "open book",
        "pamphlet",
        "reading",
        "research"
      ],
      "unicode": "f518"
    },
    {
      "name": "book-open-reader",
      "label": "Book Open Reader",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "flyer",
        "library",
        "notebook",
        "open book",
        "pamphlet",
        "reading",
        "research"
      ],
      "unicode": "f5da"
    },
    {
      "name": "book-quran",
      "label": "Book Quran",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "book",
        "islam",
        "muslim",
        "religion"
      ],
      "unicode": "f687"
    },
    {
      "name": "book-skull",
      "label": "Book Skull",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "Dungeons & Dragons",
        "crossbones",
        "d&d",
        "dark arts",
        "death",
        "dnd",
        "documentation",
        "evil",
        "fantasy",
        "halloween",
        "holiday",
        "library",
        "necronomicon",
        "read",
        "research",
        "skull",
        "spell"
      ],
      "unicode": "f6b7"
    },
    {
      "name": "book-tanakh",
      "label": "Book Tanakh",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "book",
        "jewish",
        "judaism",
        "religion"
      ],
      "unicode": "f827"
    },
    {
      "name": "bookmark",
      "label": "Bookmark",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "bookmark",
        "favorite",
        "library",
        "mark",
        "marker",
        "read",
        "remember",
        "research",
        "save"
      ],
      "unicode": "f02e"
    },
    {
      "name": "bootstrap",
      "label": "Bootstrap",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f836"
    },
    {
      "name": "border-all",
      "label": "Border All",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "cell",
        "grid",
        "outline",
        "stroke",
        "table"
      ],
      "unicode": "f84c"
    },
    {
      "name": "border-none",
      "label": "Border None",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "cell",
        "grid",
        "outline",
        "stroke",
        "table"
      ],
      "unicode": "f850"
    },
    {
      "name": "border-top-left",
      "label": "Border Top Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cell",
        "outline",
        "stroke",
        "table"
      ],
      "unicode": "f853"
    },
    {
      "name": "bore-hole",
      "label": "Bore Hole",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bore",
        "bury",
        "drill",
        "hole"
      ],
      "unicode": "e4c3"
    },
    {
      "name": "bots",
      "label": "Bots",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e340"
    },
    {
      "name": "bottle-droplet",
      "label": "Bottle Droplet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "drink",
        "oil",
        "olive oil",
        "wine"
      ],
      "unicode": "e4c4"
    },
    {
      "name": "bottle-water",
      "label": "Bottle Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "h2o",
        "plastic",
        "water"
      ],
      "unicode": "e4c5"
    },
    {
      "name": "bowl-food",
      "label": "Bowl Food",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "catfood",
        "dogfood",
        "food",
        "rice"
      ],
      "unicode": "e4c6"
    },
    {
      "name": "bowl-rice",
      "label": "Bowl Rice",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "boiled",
        "cooked",
        "cooked rice",
        "rice",
        "steamed"
      ],
      "unicode": "e2eb"
    },
    {
      "name": "bowling-ball",
      "label": "Bowling Ball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alley",
        "candlepin",
        "gutter",
        "lane",
        "strike",
        "tenpin"
      ],
      "unicode": "f436"
    },
    {
      "name": "box",
      "label": "Box",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "archive",
        "box",
        "container",
        "package",
        "parcel",
        "storage"
      ],
      "unicode": "f466"
    },
    {
      "name": "box-archive",
      "label": "Box Archive",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "box",
        "package",
        "save",
        "storage"
      ],
      "unicode": "f187"
    },
    {
      "name": "box-open",
      "label": "Box Open",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "archive",
        "container",
        "package",
        "storage",
        "unpack"
      ],
      "unicode": "f49e"
    },
    {
      "name": "box-tissue",
      "label": "Box Tissue",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cough",
        "covid-19",
        "kleenex",
        "mucus",
        "nose",
        "sneeze",
        "snot"
      ],
      "unicode": "e05b"
    },
    {
      "name": "boxes-packing",
      "label": "Boxes Packing",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "archive",
        "box",
        "package",
        "storage",
        "supplies"
      ],
      "unicode": "e4c7"
    },
    {
      "name": "boxes-stacked",
      "label": "Boxes Stacked",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "archives",
        "inventory",
        "storage",
        "warehouse"
      ],
      "unicode": "f468"
    },
    {
      "name": "braille",
      "label": "Braille",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alphabet",
        "blind",
        "dots",
        "raised",
        "vision"
      ],
      "unicode": "f2a1"
    },
    {
      "name": "brain",
      "label": "Brain",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Weather"
      ],
      "search": [
        "brain",
        "cerebellum",
        "gray matter",
        "intellect",
        "intelligent",
        "knowledge",
        "medulla oblongata",
        "mind",
        "noodle",
        "scholar",
        "wit"
      ],
      "unicode": "f5dc"
    },
    {
      "name": "brave",
      "label": "Brave",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e63c"
    },
    {
      "name": "brave-reverse",
      "label": "Brave Reverse",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e63d"
    },
    {
      "name": "brazilian-real-sign",
      "label": "Brazilian Real Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "brazilian real sign",
        "currency"
      ],
      "unicode": "e46c"
    },
    {
      "name": "bread-slice",
      "label": "Bread Slice",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "bake",
        "bakery",
        "baking",
        "dough",
        "flour",
        "gluten",
        "grain",
        "sandwich",
        "sourdough",
        "toast",
        "wheat",
        "yeast"
      ],
      "unicode": "f7ec"
    },
    {
      "name": "bridge",
      "label": "Bridge",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bridge",
        "road"
      ],
      "unicode": "e4c8"
    },
    {
      "name": "bridge-circle-check",
      "label": "Bridge Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "bridge",
        "enable",
        "not affected",
        "ok",
        "okay",
        "road",
        "validate",
        "working"
      ],
      "unicode": "e4c9"
    },
    {
      "name": "bridge-circle-exclamation",
      "label": "Bridge Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "bridge",
        "failed",
        "road"
      ],
      "unicode": "e4ca"
    },
    {
      "name": "bridge-circle-xmark",
      "label": "Bridge Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "bridge",
        "destroy",
        "road",
        "uncheck"
      ],
      "unicode": "e4cb"
    },
    {
      "name": "bridge-lock",
      "label": "Bridge Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "bridge",
        "closed",
        "lockdown",
        "padlock",
        "privacy",
        "quarantine",
        "road"
      ],
      "unicode": "e4cc"
    },
    {
      "name": "bridge-water",
      "label": "Bridge Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bridge",
        "road"
      ],
      "unicode": "e4ce"
    },
    {
      "name": "briefcase",
      "label": "Briefcase",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping",
        "Transportation"
      ],
      "search": [
        "bag",
        "briefcas",
        "briefcase",
        "business",
        "luggage",
        "offer",
        "office",
        "portfolio",
        "work"
      ],
      "unicode": "f0b1"
    },
    {
      "name": "briefcase-medical",
      "label": "Briefcase Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "doctor",
        "emt",
        "first aid",
        "health"
      ],
      "unicode": "f469"
    },
    {
      "name": "broom",
      "label": "Broom",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation",
        "Weather"
      ],
      "search": [
        "broom",
        "clean",
        "cleaning",
        "firebolt",
        "fly",
        "halloween",
        "nimbus 2000",
        "quidditch",
        "sweep",
        "sweeping",
        "witch"
      ],
      "unicode": "f51a"
    },
    {
      "name": "broom-ball",
      "label": "Broom Ball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ball",
        "bludger",
        "broom",
        "golden snitch",
        "harry potter",
        "hogwarts",
        "quaffle",
        "sport",
        "wizard"
      ],
      "unicode": "f458"
    },
    {
      "name": "brush",
      "label": "Brush",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "art",
        "bristles",
        "color",
        "handle",
        "maintenance",
        "modify",
        "paint"
      ],
      "unicode": "f55d"
    },
    {
      "name": "btc",
      "label": "BTC",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f15a"
    },
    {
      "name": "bucket",
      "label": "Bucket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bucket",
        "pail",
        "sandcastle"
      ],
      "unicode": "e4cf"
    },
    {
      "name": "buffer",
      "label": "Buffer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f837"
    },
    {
      "name": "bug",
      "label": "Bug",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "beetle",
        "error",
        "glitch",
        "insect",
        "repair",
        "report"
      ],
      "unicode": "f188"
    },
    {
      "name": "bug-slash",
      "label": "Bug Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "beetle",
        "disabled",
        "fix",
        "glitch",
        "insect",
        "optimize",
        "repair",
        "report",
        "warning"
      ],
      "unicode": "e490"
    },
    {
      "name": "bugs",
      "label": "Bugs",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bedbug",
        "infestation",
        "lice",
        "plague",
        "ticks"
      ],
      "unicode": "e4d0"
    },
    {
      "name": "building",
      "label": "Building",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Business",
        "Transportation"
      ],
      "search": [
        "apartment",
        "building",
        "business",
        "city",
        "company",
        "office",
        "office building",
        "urban",
        "work"
      ],
      "unicode": "f1ad"
    },
    {
      "name": "building-circle-arrow-right",
      "label": "Building Circle Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Business"
      ],
      "search": [
        "building",
        "city",
        "distribution center",
        "office"
      ],
      "unicode": "e4d1"
    },
    {
      "name": "building-circle-check",
      "label": "Building Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "building",
        "city",
        "enable",
        "not affected",
        "office",
        "ok",
        "okay",
        "validate",
        "working"
      ],
      "unicode": "e4d2"
    },
    {
      "name": "building-circle-exclamation",
      "label": "Building Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "affected",
        "building",
        "city",
        "failed",
        "office"
      ],
      "unicode": "e4d3"
    },
    {
      "name": "building-circle-xmark",
      "label": "Building Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "building",
        "city",
        "destroy",
        "office",
        "uncheck"
      ],
      "unicode": "e4d4"
    },
    {
      "name": "building-columns",
      "label": "Building Columns",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "bank",
        "building",
        "college",
        "education",
        "institution",
        "museum",
        "students"
      ],
      "unicode": "f19c"
    },
    {
      "name": "building-flag",
      "label": "Building Flag",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "city",
        "diplomat",
        "embassy",
        "flag",
        "headquarters",
        "united nations"
      ],
      "unicode": "e4d5"
    },
    {
      "name": "building-lock",
      "label": "Building Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Security"
      ],
      "search": [
        "building",
        "city",
        "closed",
        "lock",
        "lockdown",
        "padlock",
        "privacy",
        "quarantine",
        "secure"
      ],
      "unicode": "e4d6"
    },
    {
      "name": "building-ngo",
      "label": "Building Ngo",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "city",
        "non governmental organization",
        "office"
      ],
      "unicode": "e4d7"
    },
    {
      "name": "building-shield",
      "label": "Building Shield",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Security"
      ],
      "search": [
        "building",
        "city",
        "police",
        "protect",
        "safety"
      ],
      "unicode": "e4d8"
    },
    {
      "name": "building-un",
      "label": "Building Un",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "city",
        "office",
        "united nations"
      ],
      "unicode": "e4d9"
    },
    {
      "name": "building-user",
      "label": "Building User",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "apartment",
        "building",
        "city",
        "employee",
        "uer"
      ],
      "unicode": "e4da"
    },
    {
      "name": "building-wheat",
      "label": "Building Wheat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "agriculture",
        "building",
        "city",
        "usda"
      ],
      "unicode": "e4db"
    },
    {
      "name": "bullhorn",
      "label": "Bullhorn",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "Bullhorn",
        "announcement",
        "broadcast",
        "loud",
        "louder",
        "loudspeaker",
        "megaphone",
        "public address",
        "request",
        "share"
      ],
      "unicode": "f0a1"
    },
    {
      "name": "bullseye",
      "label": "Bullseye",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "archery",
        "goal",
        "objective",
        "strategy",
        "target"
      ],
      "unicode": "f140"
    },
    {
      "name": "burger",
      "label": "Burger",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bacon",
        "beef",
        "burger",
        "burger king",
        "cheeseburger",
        "fast food",
        "grill",
        "ground beef",
        "mcdonalds",
        "sandwich"
      ],
      "unicode": "f805"
    },
    {
      "name": "buromobelexperte",
      "label": "Büromöbel-Experte GmbH & Co. KG.",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f37f"
    },
    {
      "name": "burst",
      "label": "Burst",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "boom",
        "crash",
        "explosion"
      ],
      "unicode": "e4dc"
    },
    {
      "name": "bus",
      "label": "Bus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "bus",
        "oncoming",
        "oncoming bus",
        "public transportation",
        "transportation",
        "travel",
        "vehicle"
      ],
      "unicode": "f207"
    },
    {
      "name": "bus-simple",
      "label": "Bus Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "mta",
        "public transportation",
        "transportation",
        "travel",
        "vehicle"
      ],
      "unicode": "f55e"
    },
    {
      "name": "business-time",
      "label": "Business Time",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Security",
        "Transportation"
      ],
      "search": [
        "alarm",
        "briefcase",
        "business socks",
        "clock",
        "flight of the conchords",
        "portfolio",
        "reminder",
        "wednesday"
      ],
      "unicode": "f64a"
    },
    {
      "name": "buy-n-large",
      "label": "Buy n Large",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f8a6"
    },
    {
      "name": "buysellads",
      "label": "BuySellAds",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f20d"
    },
    {
      "name": "c",
      "label": "C",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter C",
        "Latin Small Letter C",
        "letter"
      ],
      "unicode": "43"
    },
    {
      "name": "cable-car",
      "label": "Cable Car",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "aerial tramway",
        "cable",
        "gondola",
        "lift",
        "mountain",
        "mountain cableway",
        "tram",
        "tramway",
        "trolley"
      ],
      "unicode": "f7da"
    },
    {
      "name": "cake-candles",
      "label": "Cake Candles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "anniversary",
        "bakery",
        "birthday",
        "birthday cake",
        "cake",
        "candles",
        "celebration",
        "dessert",
        "frosting",
        "holiday",
        "party",
        "pastry",
        "sweet"
      ],
      "unicode": "f1fd"
    },
    {
      "name": "calculator",
      "label": "Calculator",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Pocket Calculator",
        "abacus",
        "addition",
        "arithmetic",
        "counting",
        "math",
        "multiplication",
        "subtraction"
      ],
      "unicode": "f1ec"
    },
    {
      "name": "calendar",
      "label": "Calendar",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "calendar",
        "calendar-o",
        "date",
        "day",
        "event",
        "month",
        "schedule",
        "tear-off calendar",
        "time",
        "when",
        "year"
      ],
      "unicode": "f133"
    },
    {
      "name": "calendar-check",
      "label": "Calendar Check",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "accept",
        "agree",
        "appointment",
        "confirm",
        "correct",
        "date",
        "day",
        "done",
        "enable",
        "event",
        "month",
        "ok",
        "schedule",
        "select",
        "success",
        "tick",
        "time",
        "todo",
        "validate",
        "warranty",
        "when",
        "working",
        "year"
      ],
      "unicode": "f274"
    },
    {
      "name": "calendar-day",
      "label": "Calendar Day",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "date",
        "day",
        "detail",
        "event",
        "focus",
        "month",
        "schedule",
        "single day",
        "time",
        "today",
        "when",
        "year"
      ],
      "unicode": "f783"
    },
    {
      "name": "calendar-days",
      "label": "Calendar Days",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "calendar",
        "date",
        "day",
        "event",
        "month",
        "schedule",
        "time",
        "when",
        "year"
      ],
      "unicode": "f073"
    },
    {
      "name": "calendar-minus",
      "label": "Calendar Minus",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Business"
      ],
      "search": [
        "calendar",
        "date",
        "day",
        "delete",
        "event",
        "month",
        "negative",
        "remove",
        "schedule",
        "time",
        "when",
        "year"
      ],
      "unicode": "f272"
    },
    {
      "name": "calendar-plus",
      "label": "Calendar Plus",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Business"
      ],
      "search": [
        "add",
        "calendar",
        "create",
        "date",
        "day",
        "event",
        "month",
        "new",
        "positive",
        "schedule",
        "time",
        "when",
        "year"
      ],
      "unicode": "f271"
    },
    {
      "name": "calendar-week",
      "label": "Calendar Week",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "date",
        "day",
        "detail",
        "event",
        "focus",
        "month",
        "schedule",
        "single week",
        "time",
        "today",
        "when",
        "year"
      ],
      "unicode": "f784"
    },
    {
      "name": "calendar-xmark",
      "label": "Calendar Xmark",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Actions",
        "Business",
        "Files & Folders"
      ],
      "search": [
        "archive",
        "calendar",
        "date",
        "day",
        "delete",
        "event",
        "month",
        "remove",
        "schedule",
        "time",
        "uncheck",
        "when",
        "x",
        "year"
      ],
      "unicode": "f273"
    },
    {
      "name": "camera",
      "label": "Camera",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "image",
        "img",
        "lens",
        "photo",
        "picture",
        "record",
        "shutter",
        "video"
      ],
      "unicode": "f030"
    },
    {
      "name": "camera-retro",
      "label": "Camera Retro",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "camera",
        "image",
        "img",
        "lens",
        "photo",
        "picture",
        "record",
        "shutter",
        "video"
      ],
      "unicode": "f083"
    },
    {
      "name": "camera-rotate",
      "label": "Camera Rotate",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "flip",
        "front-facing",
        "img",
        "photo",
        "selfie"
      ],
      "unicode": "e0d8"
    },
    {
      "name": "campground",
      "label": "Campground",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "camping",
        "fall",
        "outdoors",
        "teepee",
        "tent",
        "tipi"
      ],
      "unicode": "f6bb"
    },
    {
      "name": "canadian-maple-leaf",
      "label": "Canadian Maple Leaf",
      "styles": [
        "brands"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "canada",
        "flag",
        "flora",
        "nature",
        "plant"
      ],
      "unicode": "f785"
    },
    {
      "name": "candy-cane",
      "label": "Candy Cane",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "candy",
        "christmas",
        "holiday",
        "mint",
        "peppermint",
        "striped",
        "xmas"
      ],
      "unicode": "f786"
    },
    {
      "name": "cannabis",
      "label": "Cannabis",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bud",
        "chronic",
        "drugs",
        "endica",
        "endo",
        "ganja",
        "marijuana",
        "mary jane",
        "pot",
        "reefer",
        "sativa",
        "spliff",
        "weed",
        "whacky-tabacky"
      ],
      "unicode": "f55f"
    },
    {
      "name": "capsules",
      "label": "Capsules",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drugs",
        "medicine",
        "pills",
        "prescription"
      ],
      "unicode": "f46b"
    },
    {
      "name": "car",
      "label": "Car",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "auto",
        "automobile",
        "car",
        "oncoming",
        "oncoming automobile",
        "sedan",
        "transportation",
        "travel",
        "vehicle"
      ],
      "unicode": "f1b9"
    },
    {
      "name": "car-battery",
      "label": "Car Battery",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "auto",
        "electric",
        "mechanic",
        "power"
      ],
      "unicode": "f5df"
    },
    {
      "name": "car-burst",
      "label": "Car Burst",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "accident",
        "auto",
        "automobile",
        "insurance",
        "sedan",
        "transportation",
        "vehicle",
        "wreck"
      ],
      "unicode": "f5e1"
    },
    {
      "name": "car-on",
      "label": "Car On",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "alarm",
        "car",
        "carjack",
        "warning"
      ],
      "unicode": "e4dd"
    },
    {
      "name": "car-rear",
      "label": "Car Rear",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "auto",
        "automobile",
        "sedan",
        "transportation",
        "travel",
        "vehicle"
      ],
      "unicode": "f5de"
    },
    {
      "name": "car-side",
      "label": "Car Side",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "auto",
        "automobile",
        "car",
        "sedan",
        "transportation",
        "travel",
        "vehicle"
      ],
      "unicode": "f5e4"
    },
    {
      "name": "car-tunnel",
      "label": "Car Tunnel",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "road",
        "tunnel"
      ],
      "unicode": "e4de"
    },
    {
      "name": "caravan",
      "label": "Caravan",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "camper",
        "motor home",
        "rv",
        "trailer",
        "travel"
      ],
      "unicode": "f8ff"
    },
    {
      "name": "caret-down",
      "label": "Caret Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "dropdown",
        "expand",
        "menu",
        "more",
        "triangle"
      ],
      "unicode": "f0d7"
    },
    {
      "name": "caret-left",
      "label": "Caret Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "back",
        "previous",
        "triangle"
      ],
      "unicode": "f0d9"
    },
    {
      "name": "caret-right",
      "label": "Caret Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "forward",
        "next",
        "triangle"
      ],
      "unicode": "f0da"
    },
    {
      "name": "caret-up",
      "label": "Caret Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "collapse",
        "triangle",
        "upgrade"
      ],
      "unicode": "f0d8"
    },
    {
      "name": "carrot",
      "label": "Carrot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "bugs bunny",
        "carrot",
        "food",
        "orange",
        "vegan",
        "vegetable"
      ],
      "unicode": "f787"
    },
    {
      "name": "cart-arrow-down",
      "label": "Cart Arrow Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Shopping",
        "Transportation"
      ],
      "search": [
        "download",
        "insert",
        "save",
        "shopping"
      ],
      "unicode": "f218"
    },
    {
      "name": "cart-flatbed",
      "label": "Cart Flatbed",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping",
        "Transportation"
      ],
      "search": [
        "carry",
        "inventory",
        "shipping",
        "transport"
      ],
      "unicode": "f474"
    },
    {
      "name": "cart-flatbed-suitcase",
      "label": "Cart Flatbed Suitcase",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping",
        "Transportation"
      ],
      "search": [
        "airport",
        "bag",
        "baggage",
        "suitcase",
        "travel"
      ],
      "unicode": "f59d"
    },
    {
      "name": "cart-plus",
      "label": "Cart Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Shopping",
        "Transportation"
      ],
      "search": [
        "add",
        "create",
        "new",
        "positive",
        "shopping"
      ],
      "unicode": "f217"
    },
    {
      "name": "cart-shopping",
      "label": "Cart Shopping",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Shopping",
        "Transportation"
      ],
      "search": [
        "buy",
        "cart",
        "checkout",
        "grocery",
        "payment",
        "purchase",
        "shopping",
        "shopping cart",
        "trolley"
      ],
      "unicode": "f07a"
    },
    {
      "name": "cash-register",
      "label": "Cash Register",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Shopping"
      ],
      "search": [
        "buy",
        "cha-ching",
        "change",
        "checkout",
        "commerce",
        "leaerboard",
        "machine",
        "pay",
        "payment",
        "purchase",
        "store"
      ],
      "unicode": "f788"
    },
    {
      "name": "cat",
      "label": "Cat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cat",
        "feline",
        "halloween",
        "holiday",
        "kitten",
        "kitty",
        "meow",
        "pet"
      ],
      "unicode": "f6be"
    },
    {
      "name": "cc-amazon-pay",
      "label": "Amazon Pay Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f42d"
    },
    {
      "name": "cc-amex",
      "label": "Cc Amex",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "amex"
      ],
      "unicode": "f1f3"
    },
    {
      "name": "cc-apple-pay",
      "label": "Apple Pay Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f416"
    },
    {
      "name": "cc-diners-club",
      "label": "Diner's Club Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f24c"
    },
    {
      "name": "cc-discover",
      "label": "Discover Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1f2"
    },
    {
      "name": "cc-jcb",
      "label": "JCB Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f24b"
    },
    {
      "name": "cc-mastercard",
      "label": "MasterCard Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [],
      "unicode": "f1f1"
    },
    {
      "name": "cc-paypal",
      "label": "Paypal Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1f4"
    },
    {
      "name": "cc-stripe",
      "label": "Stripe Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1f5"
    },
    {
      "name": "cc-visa",
      "label": "Visa Credit Card",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1f0"
    },
    {
      "name": "cedi-sign",
      "label": "Cedi Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Cedi Sign",
        "currency"
      ],
      "unicode": "e0df"
    },
    {
      "name": "cent-sign",
      "label": "Cent Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Cent Sign",
        "currency"
      ],
      "unicode": "e3f5"
    },
    {
      "name": "centercode",
      "label": "Centercode",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f380"
    },
    {
      "name": "centos",
      "label": "Centos",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "linux",
        "operating system",
        "os"
      ],
      "unicode": "f789"
    },
    {
      "name": "certificate",
      "label": "Certificate",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "badge",
        "guarantee",
        "star",
        "verified"
      ],
      "unicode": "f0a3"
    },
    {
      "name": "chair",
      "label": "Chair",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "chair",
        "furniture",
        "seat",
        "sit"
      ],
      "unicode": "f6c0"
    },
    {
      "name": "chalkboard",
      "label": "Chalkboard",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "blackboard",
        "learning",
        "school",
        "teaching",
        "whiteboard",
        "writing"
      ],
      "unicode": "f51b"
    },
    {
      "name": "chalkboard-user",
      "label": "Chalkboard User",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "blackboard",
        "instructor",
        "learning",
        "professor",
        "school",
        "uer",
        "whiteboard",
        "writing"
      ],
      "unicode": "f51c"
    },
    {
      "name": "champagne-glasses",
      "label": "Champagne Glasses",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "bar",
        "beverage",
        "celebrate",
        "celebration",
        "champagne",
        "clink",
        "clinking glasses",
        "drink",
        "glass",
        "holiday",
        "new year's eve",
        "party",
        "toast"
      ],
      "unicode": "f79f"
    },
    {
      "name": "charging-station",
      "label": "Charging Station",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "electric",
        "ev",
        "tesla",
        "vehicle"
      ],
      "unicode": "f5e7"
    },
    {
      "name": "chart-area",
      "label": "Chart Area",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "analytics",
        "area",
        "chart",
        "graph",
        "performance",
        "revenue",
        "statistics"
      ],
      "unicode": "f1fe"
    },
    {
      "name": "chart-bar",
      "label": "Chart Bar",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "analytics",
        "bar",
        "chart",
        "graph",
        "performance",
        "statistics"
      ],
      "unicode": "f080"
    },
    {
      "name": "chart-column",
      "label": "Chart Column",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "bar",
        "bar chart",
        "chart",
        "graph",
        "performance",
        "revenue",
        "statistics",
        "track",
        "trend"
      ],
      "unicode": "e0e3"
    },
    {
      "name": "chart-diagram",
      "label": "Chart Diagram",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "algorithm",
        "analytics",
        "flow",
        "graph"
      ],
      "unicode": "e695"
    },
    {
      "name": "chart-gantt",
      "label": "Chart Gantt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "chart",
        "graph",
        "performance",
        "statistics",
        "track",
        "trend"
      ],
      "unicode": "e0e4"
    },
    {
      "name": "chart-line",
      "label": "Chart Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "activity",
        "analytics",
        "chart",
        "dashboard",
        "gain",
        "graph",
        "increase",
        "line",
        "performance",
        "revenue",
        "statistics"
      ],
      "unicode": "f201"
    },
    {
      "name": "chart-pie",
      "label": "Chart Pie",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "analytics",
        "chart",
        "diagram",
        "graph",
        "performance",
        "pie",
        "revenue",
        "statistics"
      ],
      "unicode": "f200"
    },
    {
      "name": "chart-simple",
      "label": "Chart Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "analytics",
        "bar",
        "chart",
        "column",
        "graph",
        "performance",
        "revenue",
        "row",
        "statistics",
        "trend"
      ],
      "unicode": "e473"
    },
    {
      "name": "check",
      "label": "Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Check Mark",
        "accept",
        "agree",
        "check",
        "check mark",
        "checkmark",
        "confirm",
        "correct",
        "coupon",
        "done",
        "enable",
        "mark",
        "notice",
        "notification",
        "notify",
        "ok",
        "select",
        "success",
        "tick",
        "todo",
        "true",
        "validate",
        "working",
        "yes",
        "✓"
      ],
      "unicode": "f00c"
    },
    {
      "name": "check-double",
      "label": "Check Double",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "accept",
        "agree",
        "checkmark",
        "confirm",
        "correct",
        "coupon",
        "done",
        "enable",
        "notice",
        "notification",
        "notify",
        "ok",
        "select",
        "select all",
        "success",
        "tick",
        "todo",
        "validate",
        "working"
      ],
      "unicode": "f560"
    },
    {
      "name": "check-to-slot",
      "label": "Check To Slot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "accept",
        "cast",
        "election",
        "enable",
        "politics",
        "positive",
        "validate",
        "voting",
        "working",
        "yes"
      ],
      "unicode": "f772"
    },
    {
      "name": "cheese",
      "label": "Cheese",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cheddar",
        "curd",
        "gouda",
        "melt",
        "parmesan",
        "sandwich",
        "swiss",
        "wedge"
      ],
      "unicode": "f7ef"
    },
    {
      "name": "chess",
      "label": "Chess",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "board",
        "castle",
        "checkmate",
        "game",
        "king",
        "rook",
        "strategy",
        "tournament"
      ],
      "unicode": "f439"
    },
    {
      "name": "chess-bishop",
      "label": "Chess Bishop",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Black Chess Bishop",
        "board",
        "checkmate",
        "game",
        "strategy"
      ],
      "unicode": "f43a"
    },
    {
      "name": "chess-board",
      "label": "Chess Board",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "board",
        "checkmate",
        "game",
        "strategy"
      ],
      "unicode": "f43c"
    },
    {
      "name": "chess-king",
      "label": "Chess King",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Black Chess King",
        "board",
        "checkmate",
        "game",
        "strategy"
      ],
      "unicode": "f43f"
    },
    {
      "name": "chess-knight",
      "label": "Chess Knight",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Black Chess Knight",
        "board",
        "checkmate",
        "game",
        "horse",
        "strategy"
      ],
      "unicode": "f441"
    },
    {
      "name": "chess-pawn",
      "label": "Chess Pawn",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Actions"
      ],
      "search": [
        "board",
        "checkmate",
        "chess",
        "chess pawn",
        "dupe",
        "expendable",
        "game",
        "strategy"
      ],
      "unicode": "f443"
    },
    {
      "name": "chess-queen",
      "label": "Chess Queen",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Black Chess Queen",
        "board",
        "checkmate",
        "game",
        "strategy"
      ],
      "unicode": "f445"
    },
    {
      "name": "chess-rook",
      "label": "Chess Rook",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Black Chess Rook",
        "board",
        "castle",
        "checkmate",
        "game",
        "strategy"
      ],
      "unicode": "f447"
    },
    {
      "name": "chevron-down",
      "label": "Chevron Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "arrow",
        "download",
        "expand",
        "insert"
      ],
      "unicode": "f078"
    },
    {
      "name": "chevron-left",
      "label": "Chevron Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Left-Pointing Angle Bracket",
        "arrow",
        "back",
        "bracket",
        "previous"
      ],
      "unicode": "f053"
    },
    {
      "name": "chevron-right",
      "label": "Chevron Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Right-Pointing Angle Bracket",
        "arrow",
        "bracket",
        "forward",
        "next"
      ],
      "unicode": "f054"
    },
    {
      "name": "chevron-up",
      "label": "Chevron Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "arrow",
        "collapse",
        "upgrade",
        "upload"
      ],
      "unicode": "f077"
    },
    {
      "name": "child",
      "label": "Child",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "boy",
        "girl",
        "kid",
        "toddler",
        "uer",
        "young",
        "youth"
      ],
      "unicode": "f1ae"
    },
    {
      "name": "child-combatant",
      "label": "Child Combatant",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "combatant"
      ],
      "unicode": "e4e0"
    },
    {
      "name": "child-dress",
      "label": "Child Dress",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "boy",
        "girl",
        "kid",
        "toddler",
        "uer",
        "young",
        "youth"
      ],
      "unicode": "e59c"
    },
    {
      "name": "child-reaching",
      "label": "Child Reaching",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "boy",
        "girl",
        "kid",
        "toddler",
        "uer",
        "young",
        "youth"
      ],
      "unicode": "e59d"
    },
    {
      "name": "children",
      "label": "Children",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "boy",
        "child",
        "girl",
        "kid",
        "kids",
        "together",
        "uer",
        "young",
        "youth"
      ],
      "unicode": "e4e1"
    },
    {
      "name": "chrome",
      "label": "Chrome",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "browser"
      ],
      "unicode": "f268"
    },
    {
      "name": "chromecast",
      "label": "Chromecast",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f838"
    },
    {
      "name": "church",
      "label": "Church",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "Christian",
        "building",
        "cathedral",
        "chapel",
        "church",
        "community",
        "cross",
        "religion"
      ],
      "unicode": "f51d"
    },
    {
      "name": "circle",
      "label": "Circle",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "Black Circle",
        "Black Large Circle",
        "black circle",
        "blue",
        "blue circle",
        "brown",
        "brown circle",
        "chart",
        "circle",
        "circle-thin",
        "diameter",
        "dot",
        "ellipse",
        "fill",
        "geometric",
        "green",
        "green circle",
        "notification",
        "orange",
        "orange circle",
        "progress",
        "purple",
        "purple circle",
        "red",
        "red circle",
        "round",
        "white circle",
        "yellow",
        "yellow circle"
      ],
      "unicode": "f111"
    },
    {
      "name": "circle-arrow-down",
      "label": "Circle Arrow Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "download"
      ],
      "unicode": "f0ab"
    },
    {
      "name": "circle-arrow-left",
      "label": "Circle Arrow Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "back",
        "previous"
      ],
      "unicode": "f0a8"
    },
    {
      "name": "circle-arrow-right",
      "label": "Circle Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "forward",
        "next"
      ],
      "unicode": "f0a9"
    },
    {
      "name": "circle-arrow-up",
      "label": "Circle Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "upgrade",
        "upload"
      ],
      "unicode": "f0aa"
    },
    {
      "name": "circle-check",
      "label": "Circle Check",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "accept",
        "affected",
        "agree",
        "clear",
        "confirm",
        "correct",
        "coupon",
        "done",
        "enable",
        "ok",
        "select",
        "success",
        "tick",
        "todo",
        "validate",
        "working",
        "yes"
      ],
      "unicode": "f058"
    },
    {
      "name": "circle-chevron-down",
      "label": "Circle Chevron Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "arrow",
        "download",
        "dropdown",
        "menu",
        "more"
      ],
      "unicode": "f13a"
    },
    {
      "name": "circle-chevron-left",
      "label": "Circle Chevron Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "arrow",
        "back",
        "previous"
      ],
      "unicode": "f137"
    },
    {
      "name": "circle-chevron-right",
      "label": "Circle Chevron Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "arrow",
        "forward",
        "next"
      ],
      "unicode": "f138"
    },
    {
      "name": "circle-chevron-up",
      "label": "Circle Chevron Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "arrow",
        "collapse",
        "upgrade",
        "upload"
      ],
      "unicode": "f139"
    },
    {
      "name": "circle-dollar-to-slot",
      "label": "Circle Dollar To Slot",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "contribute",
        "generosity",
        "gift",
        "give",
        "premium"
      ],
      "unicode": "f4b9"
    },
    {
      "name": "circle-dot",
      "label": "Circle Dot",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "bullseye",
        "button",
        "geometric",
        "notification",
        "radio",
        "radio button",
        "target"
      ],
      "unicode": "f192"
    },
    {
      "name": "circle-down",
      "label": "Circle Down",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "arrow-circle-o-down",
        "download"
      ],
      "unicode": "f358"
    },
    {
      "name": "circle-exclamation",
      "label": "Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affect",
        "alert",
        "attention",
        "damage",
        "danger",
        "error",
        "failed",
        "important",
        "notice",
        "notification",
        "notify",
        "problem",
        "required",
        "warning"
      ],
      "unicode": "f06a"
    },
    {
      "name": "circle-h",
      "label": "Circle H",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "Circled Latin Capital Letter H",
        "clinic",
        "covid-19",
        "emergency",
        "letter",
        "map"
      ],
      "unicode": "f47e"
    },
    {
      "name": "circle-half-stroke",
      "label": "Circle Half Stroke",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "Circle with Left Half Black",
        "adjust",
        "chart",
        "contrast",
        "dark",
        "fill",
        "light",
        "pie",
        "progress",
        "saturation"
      ],
      "unicode": "f042"
    },
    {
      "name": "circle-info",
      "label": "Circle Info",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "details",
        "help",
        "information",
        "more",
        "support"
      ],
      "unicode": "f05a"
    },
    {
      "name": "circle-left",
      "label": "Circle Left",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "arrow-circle-o-left",
        "back",
        "previous"
      ],
      "unicode": "f359"
    },
    {
      "name": "circle-minus",
      "label": "Circle Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "delete",
        "hide",
        "negative",
        "remove",
        "shape",
        "trash"
      ],
      "unicode": "f056"
    },
    {
      "name": "circle-nodes",
      "label": "Circle Nodes",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "cluster",
        "connect",
        "network"
      ],
      "unicode": "e4e2"
    },
    {
      "name": "circle-notch",
      "label": "Circle Notch",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "circle-o-notch",
        "diameter",
        "dot",
        "ellipse",
        "round",
        "spinner"
      ],
      "unicode": "f1ce"
    },
    {
      "name": "circle-pause",
      "label": "Circle Pause",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Media"
      ],
      "search": [
        "hold",
        "wait"
      ],
      "unicode": "f28b"
    },
    {
      "name": "circle-play",
      "label": "Circle Play",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Media"
      ],
      "search": [
        "audio",
        "music",
        "playing",
        "sound",
        "start",
        "video"
      ],
      "unicode": "f144"
    },
    {
      "name": "circle-plus",
      "label": "Circle Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "add",
        "create",
        "expand",
        "new",
        "positive",
        "shape"
      ],
      "unicode": "f055"
    },
    {
      "name": "circle-question",
      "label": "Circle Question",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "faq",
        "help",
        "information",
        "support",
        "unknown"
      ],
      "unicode": "f059"
    },
    {
      "name": "circle-radiation",
      "label": "Circle Radiation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "danger",
        "dangerous",
        "deadly",
        "hazard",
        "nuclear",
        "radioactive",
        "sign",
        "warning"
      ],
      "unicode": "f7ba"
    },
    {
      "name": "circle-right",
      "label": "Circle Right",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "arrow-circle-o-right",
        "forward",
        "next"
      ],
      "unicode": "f35a"
    },
    {
      "name": "circle-stop",
      "label": "Circle Stop",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Media",
        "Security"
      ],
      "search": [
        "block",
        "box",
        "circle",
        "square"
      ],
      "unicode": "f28d"
    },
    {
      "name": "circle-up",
      "label": "Circle Up",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "arrow-circle-o-up",
        "upgrade"
      ],
      "unicode": "f35b"
    },
    {
      "name": "circle-user",
      "label": "Circle User",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "employee",
        "uer",
        "username",
        "users-people"
      ],
      "unicode": "f2bd"
    },
    {
      "name": "circle-xmark",
      "label": "Circle Xmark",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "close",
        "cross",
        "destroy",
        "exit",
        "incorrect",
        "notice",
        "notification",
        "notify",
        "problem",
        "uncheck",
        "wrong",
        "x"
      ],
      "unicode": "f057"
    },
    {
      "name": "city",
      "label": "City",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business",
        "Transportation",
        "Weather"
      ],
      "search": [
        "buildings",
        "busy",
        "city",
        "cityscape",
        "skyscrapers",
        "urban",
        "windows"
      ],
      "unicode": "f64f"
    },
    {
      "name": "clapperboard",
      "label": "Clapperboard",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "camera",
        "clapper",
        "clapper board",
        "director",
        "film",
        "movie",
        "record"
      ],
      "unicode": "e131"
    },
    {
      "name": "clipboard",
      "label": "Clipboard",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "clipboar",
        "clipboard",
        "copy",
        "notepad",
        "notes",
        "paste",
        "record"
      ],
      "unicode": "f328"
    },
    {
      "name": "clipboard-check",
      "label": "Clipboard Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "accept",
        "agree",
        "confirm",
        "coupon",
        "done",
        "enable",
        "ok",
        "select",
        "success",
        "tick",
        "todo",
        "validate",
        "working",
        "yes"
      ],
      "unicode": "f46c"
    },
    {
      "name": "clipboard-list",
      "label": "Clipboard List",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "cheatsheet",
        "checklist",
        "completed",
        "done",
        "finished",
        "intinerary",
        "ol",
        "schedule",
        "summary",
        "survey",
        "tick",
        "todo",
        "ul",
        "wishlist"
      ],
      "unicode": "f46d"
    },
    {
      "name": "clipboard-question",
      "label": "Clipboard Question",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "assistance",
        "faq",
        "interview",
        "query",
        "question"
      ],
      "unicode": "e4e3"
    },
    {
      "name": "clipboard-user",
      "label": "Clipboard User",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "attendance",
        "employee",
        "record",
        "roster",
        "staff",
        "uer"
      ],
      "unicode": "f7f3"
    },
    {
      "name": "clock",
      "label": "Clock",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Actions",
        "Business",
        "Security"
      ],
      "search": [
        "00",
        "4",
        "4:00",
        "clock",
        "date",
        "four",
        "four o’clock",
        "hour",
        "late",
        "minute",
        "o'clock",
        "o’clock",
        "pending",
        "schedule",
        "ticking",
        "time",
        "timer",
        "timestamp",
        "watch"
      ],
      "unicode": "f017"
    },
    {
      "name": "clock-rotate-left",
      "label": "Clock Rotate Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Business",
        "Security",
        "Weather"
      ],
      "search": [
        "Rewind",
        "clock",
        "pending",
        "reverse",
        "time",
        "time machine",
        "time travel",
        "waiting"
      ],
      "unicode": "f1da"
    },
    {
      "name": "clone",
      "label": "Clone",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "arrange",
        "copy",
        "duplicate",
        "paste"
      ],
      "unicode": "f24d"
    },
    {
      "name": "closed-captioning",
      "label": "Closed Captioning",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media",
        "Text & Formatting"
      ],
      "search": [
        "cc",
        "deaf",
        "hearing",
        "subtitle",
        "subtitling",
        "text",
        "video"
      ],
      "unicode": "f20a"
    },
    {
      "name": "cloud",
      "label": "Cloud",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Weather"
      ],
      "search": [
        "atmosphere",
        "cloud",
        "fog",
        "overcast",
        "save",
        "upload",
        "weather"
      ],
      "unicode": "f0c2"
    },
    {
      "name": "cloud-arrow-down",
      "label": "Cloud Arrow Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Weather"
      ],
      "search": [
        "download",
        "export",
        "save"
      ],
      "unicode": "f0ed"
    },
    {
      "name": "cloud-arrow-up",
      "label": "Cloud Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Weather"
      ],
      "search": [
        "import",
        "save",
        "upgrade",
        "upload"
      ],
      "unicode": "f0ee"
    },
    {
      "name": "cloud-bolt",
      "label": "Cloud Bolt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "bolt",
        "cloud",
        "cloud with lightning",
        "lightning",
        "precipitation",
        "rain",
        "storm",
        "weather"
      ],
      "unicode": "f76c"
    },
    {
      "name": "cloud-meatball",
      "label": "Cloud Meatball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "FLDSMDFR",
        "food",
        "spaghetti",
        "storm"
      ],
      "unicode": "f73b"
    },
    {
      "name": "cloud-moon",
      "label": "Cloud Moon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "crescent",
        "evening",
        "lunar",
        "night",
        "partly cloudy",
        "sky"
      ],
      "unicode": "f6c3"
    },
    {
      "name": "cloud-moon-rain",
      "label": "Cloud Moon Rain",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "crescent",
        "evening",
        "lunar",
        "night",
        "partly cloudy",
        "precipitation",
        "rain",
        "sky",
        "storm"
      ],
      "unicode": "f73c"
    },
    {
      "name": "cloud-rain",
      "label": "Cloud Rain",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "Rain",
        "cloud",
        "cloud with rain",
        "precipitation",
        "rain",
        "sky",
        "storm"
      ],
      "unicode": "f73d"
    },
    {
      "name": "cloud-showers-heavy",
      "label": "Cloud Showers Heavy",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "precipitation",
        "rain",
        "sky",
        "storm"
      ],
      "unicode": "f740"
    },
    {
      "name": "cloud-showers-water",
      "label": "Cloud Showers Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cloud",
        "deluge",
        "flood",
        "rain",
        "storm",
        "surge"
      ],
      "unicode": "e4e4"
    },
    {
      "name": "cloud-sun",
      "label": "Cloud Sun",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Weather"
      ],
      "search": [
        "clear",
        "cloud",
        "day",
        "daytime",
        "fall",
        "outdoors",
        "overcast",
        "partly cloudy",
        "sun",
        "sun behind cloud"
      ],
      "unicode": "f6c4"
    },
    {
      "name": "cloud-sun-rain",
      "label": "Cloud Sun Rain",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cloud",
        "day",
        "overcast",
        "precipitation",
        "rain",
        "storm",
        "summer",
        "sun",
        "sun behind rain cloud",
        "sunshower"
      ],
      "unicode": "f743"
    },
    {
      "name": "cloudflare",
      "label": "Cloudflare",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "e07d"
    },
    {
      "name": "cloudscale",
      "label": "cloudscale.ch",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "f383"
    },
    {
      "name": "cloudsmith",
      "label": "Cloudsmith",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "f384"
    },
    {
      "name": "cloudversify",
      "label": "cloudversify",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "f385"
    },
    {
      "name": "clover",
      "label": "Clover",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "4",
        "charm",
        "clover",
        "four",
        "four leaf clover",
        "four-leaf clover",
        "leaf",
        "leprechaun",
        "luck",
        "lucky"
      ],
      "unicode": "e139"
    },
    {
      "name": "cmplid",
      "label": "Cmplid",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e360"
    },
    {
      "name": "code",
      "label": "Code",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "brackets",
        "code",
        "development",
        "html",
        "mysql",
        "sql"
      ],
      "unicode": "f121"
    },
    {
      "name": "code-branch",
      "label": "Code Branch",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "branch",
        "git",
        "github",
        "mysql",
        "rebase",
        "sql",
        "svn",
        "vcs",
        "version"
      ],
      "unicode": "f126"
    },
    {
      "name": "code-commit",
      "label": "Code Commit",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "commit",
        "git",
        "github",
        "hash",
        "rebase",
        "svn",
        "vcs",
        "version"
      ],
      "unicode": "f386"
    },
    {
      "name": "code-compare",
      "label": "Code Compare",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "compare",
        "git",
        "github",
        "svn",
        "version"
      ],
      "unicode": "e13a"
    },
    {
      "name": "code-fork",
      "label": "Code Fork",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "fork",
        "git",
        "github",
        "svn",
        "version"
      ],
      "unicode": "e13b"
    },
    {
      "name": "code-merge",
      "label": "Code Merge",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "git",
        "github",
        "merge",
        "pr",
        "rebase",
        "svn",
        "vcs",
        "version"
      ],
      "unicode": "f387"
    },
    {
      "name": "code-pull-request",
      "label": "Code Pull Request",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "git",
        "github",
        "pr",
        "svn",
        "version"
      ],
      "unicode": "e13c"
    },
    {
      "name": "codepen",
      "label": "Codepen",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions"
      ],
      "search": [],
      "unicode": "f1cb"
    },
    {
      "name": "codiepie",
      "label": "Codie Pie",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f284"
    },
    {
      "name": "coins",
      "label": "Coins",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Business"
      ],
      "search": [
        "currency",
        "dime",
        "financial",
        "gold",
        "money",
        "penny",
        "premium"
      ],
      "unicode": "f51e"
    },
    {
      "name": "colon-sign",
      "label": "Colon Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Colon Sign",
        "currency"
      ],
      "unicode": "e140"
    },
    {
      "name": "comment",
      "label": "Comment",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "Right Speech Bubble",
        "answer",
        "bubble",
        "chat",
        "commenting",
        "conversation",
        "conversation",
        "discussion",
        "feedback",
        "message",
        "note",
        "notification",
        "sms",
        "speech",
        "talk",
        "talking",
        "texting"
      ],
      "unicode": "f075"
    },
    {
      "name": "comment-dollar",
      "label": "Comment Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Communication",
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "answer",
        "bubble",
        "chat",
        "commenting",
        "conversation",
        "feedback",
        "message",
        "money",
        "note",
        "notification",
        "pay",
        "salary",
        "sms",
        "speech",
        "spend",
        "texting",
        "transfer"
      ],
      "unicode": "f651"
    },
    {
      "name": "comment-dots",
      "label": "Comment Dots",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "answer",
        "balloon",
        "bubble",
        "chat",
        "comic",
        "commenting",
        "conversation",
        "dialog",
        "feedback",
        "message",
        "more",
        "note",
        "notification",
        "reply",
        "request",
        "sms",
        "speech",
        "speech balloon",
        "texting"
      ],
      "unicode": "f4ad"
    },
    {
      "name": "comment-medical",
      "label": "Comment Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "advice",
        "answer",
        "bubble",
        "chat",
        "commenting",
        "conversation",
        "diagnose",
        "feedback",
        "message",
        "note",
        "notification",
        "prescription",
        "sms",
        "speech",
        "texting"
      ],
      "unicode": "f7f5"
    },
    {
      "name": "comment-nodes",
      "label": "Comment Nodes",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "ai",
        "artificial intelligence",
        "cluster",
        "language",
        "model",
        "network",
        "neuronal"
      ],
      "unicode": "e696"
    },
    {
      "name": "comment-slash",
      "label": "Comment Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "answer",
        "bubble",
        "cancel",
        "chat",
        "commenting",
        "conversation",
        "disabled",
        "feedback",
        "message",
        "mute",
        "note",
        "notification",
        "quiet",
        "sms",
        "speech",
        "texting"
      ],
      "unicode": "f4b3"
    },
    {
      "name": "comment-sms",
      "label": "Comment Sms",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "answer",
        "chat",
        "conversation",
        "message",
        "mobile",
        "notification",
        "phone",
        "sms",
        "texting"
      ],
      "unicode": "f7cd"
    },
    {
      "name": "comments",
      "label": "Comments",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "Two Speech Bubbles",
        "answer",
        "bubble",
        "chat",
        "commenting",
        "conversation",
        "conversation",
        "discussion",
        "feedback",
        "message",
        "note",
        "notification",
        "sms",
        "speech",
        "talk",
        "talking",
        "texting"
      ],
      "unicode": "f086"
    },
    {
      "name": "comments-dollar",
      "label": "Comments Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Communication",
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "answer",
        "bubble",
        "chat",
        "commenting",
        "conversation",
        "feedback",
        "message",
        "money",
        "note",
        "notification",
        "pay",
        "salary",
        "sms",
        "speech",
        "spend",
        "texting",
        "transfer"
      ],
      "unicode": "f653"
    },
    {
      "name": "compact-disc",
      "label": "Compact Disc",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "Optical Disc Icon",
        "album",
        "blu-ray",
        "bluray",
        "cd",
        "computer",
        "disc",
        "disk",
        "dvd",
        "media",
        "movie",
        "music",
        "optical",
        "optical disk",
        "record",
        "video",
        "vinyl"
      ],
      "unicode": "f51f"
    },
    {
      "name": "compass",
      "label": "Compass",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "compass",
        "directions",
        "directory",
        "location",
        "magnetic",
        "menu",
        "navigation",
        "orienteering",
        "safari",
        "travel"
      ],
      "unicode": "f14e"
    },
    {
      "name": "compass-drafting",
      "label": "Compass Drafting",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "design",
        "map",
        "mechanical drawing",
        "plot",
        "plotting"
      ],
      "unicode": "f568"
    },
    {
      "name": "compress",
      "label": "Compress",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "collapse",
        "fullscreen",
        "minimize",
        "move",
        "resize",
        "shrink",
        "smaller"
      ],
      "unicode": "f066"
    },
    {
      "name": "computer",
      "label": "Computer",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "computer",
        "desktop",
        "display",
        "monitor",
        "tower"
      ],
      "unicode": "e4e5"
    },
    {
      "name": "computer-mouse",
      "label": "Computer Mouse",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "click",
        "computer",
        "computer mouse",
        "cursor",
        "input",
        "peripheral"
      ],
      "unicode": "f8cc"
    },
    {
      "name": "confluence",
      "label": "Confluence",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "atlassian"
      ],
      "unicode": "f78d"
    },
    {
      "name": "connectdevelop",
      "label": "Connect Develop",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f20e"
    },
    {
      "name": "contao",
      "label": "Contao",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f26d"
    },
    {
      "name": "cookie",
      "label": "Cookie",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "baked good",
        "chips",
        "chocolate",
        "cookie",
        "dessert",
        "eat",
        "snack",
        "sweet",
        "treat"
      ],
      "unicode": "f563"
    },
    {
      "name": "cookie-bite",
      "label": "Cookie Bite",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "baked good",
        "bitten",
        "chips",
        "chocolate",
        "eat",
        "snack",
        "sweet",
        "treat"
      ],
      "unicode": "f564"
    },
    {
      "name": "copy",
      "label": "Copy",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "clone",
        "duplicate",
        "file",
        "files-o",
        "paper",
        "paste"
      ],
      "unicode": "f0c5"
    },
    {
      "name": "copyright",
      "label": "Copyright",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "brand",
        "c",
        "copyright",
        "mark",
        "register",
        "trademark"
      ],
      "unicode": "f1f9"
    },
    {
      "name": "cotton-bureau",
      "label": "Cotton Bureau",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clothing",
        "t-shirts",
        "tshirts"
      ],
      "unicode": "f89e"
    },
    {
      "name": "couch",
      "label": "Couch",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "chair",
        "cushion",
        "furniture",
        "relax",
        "sofa"
      ],
      "unicode": "f4b8"
    },
    {
      "name": "cow",
      "label": "Cow",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "agriculture",
        "animal",
        "beef",
        "bovine",
        "co",
        "cow",
        "farm",
        "fauna",
        "livestock",
        "mammal",
        "milk",
        "moo"
      ],
      "unicode": "f6c8"
    },
    {
      "name": "cpanel",
      "label": "cPanel",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f388"
    },
    {
      "name": "creative-commons",
      "label": "Creative Commons",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f25e"
    },
    {
      "name": "creative-commons-by",
      "label": "Creative Commons Attribution",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4e7"
    },
    {
      "name": "creative-commons-nc",
      "label": "Creative Commons Noncommercial",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4e8"
    },
    {
      "name": "creative-commons-nc-eu",
      "label": "Creative Commons Noncommercial (Euro Sign)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4e9"
    },
    {
      "name": "creative-commons-nc-jp",
      "label": "Creative Commons Noncommercial (Yen Sign)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4ea"
    },
    {
      "name": "creative-commons-nd",
      "label": "Creative Commons No Derivative Works",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4eb"
    },
    {
      "name": "creative-commons-pd",
      "label": "Creative Commons Public Domain",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4ec"
    },
    {
      "name": "creative-commons-pd-alt",
      "label": "Alternate Creative Commons Public Domain",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4ed"
    },
    {
      "name": "creative-commons-remix",
      "label": "Creative Commons Remix",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4ee"
    },
    {
      "name": "creative-commons-sa",
      "label": "Creative Commons Share Alike",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4ef"
    },
    {
      "name": "creative-commons-sampling",
      "label": "Creative Commons Sampling",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f0"
    },
    {
      "name": "creative-commons-sampling-plus",
      "label": "Creative Commons Sampling +",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions"
      ],
      "search": [],
      "unicode": "f4f1"
    },
    {
      "name": "creative-commons-share",
      "label": "Creative Commons Share",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f2"
    },
    {
      "name": "creative-commons-zero",
      "label": "Creative Commons CC0",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f3"
    },
    {
      "name": "credit-card",
      "label": "Credit Card",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Actions",
        "Business",
        "Shopping",
        "Transportation"
      ],
      "search": [
        "buy",
        "card",
        "checkout",
        "credit",
        "credit card",
        "credit-card-alt",
        "debit",
        "money",
        "payment",
        "purchase"
      ],
      "unicode": "f09d"
    },
    {
      "name": "critical-role",
      "label": "Critical Role",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "d&d",
        "dnd",
        "fantasy",
        "game",
        "gaming",
        "tabletop"
      ],
      "unicode": "f6c9"
    },
    {
      "name": "crop",
      "label": "Crop",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "frame",
        "mask",
        "modify",
        "resize",
        "shrink"
      ],
      "unicode": "f125"
    },
    {
      "name": "crop-simple",
      "label": "Crop Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "frame",
        "mask",
        "modify",
        "resize",
        "shrink"
      ],
      "unicode": "f565"
    },
    {
      "name": "cross",
      "label": "Cross",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Christian",
        "Heavy Latin Cross",
        "catholicism",
        "christianity",
        "church",
        "cross",
        "jesus",
        "latin cross",
        "religion"
      ],
      "unicode": "f654"
    },
    {
      "name": "crosshairs",
      "label": "Crosshairs",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "aim",
        "bullseye",
        "gpd",
        "picker",
        "position"
      ],
      "unicode": "f05b"
    },
    {
      "name": "crow",
      "label": "Crow",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bird",
        "bullfrog",
        "fauna",
        "halloween",
        "holiday",
        "toad"
      ],
      "unicode": "f520"
    },
    {
      "name": "crown",
      "label": "Crown",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "award",
        "clothing",
        "crown",
        "favorite",
        "king",
        "queen",
        "royal",
        "tiara",
        "vip"
      ],
      "unicode": "f521"
    },
    {
      "name": "crutch",
      "label": "Crutch",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cane",
        "injury",
        "mobility",
        "wheelchair"
      ],
      "unicode": "f7f7"
    },
    {
      "name": "cruzeiro-sign",
      "label": "Cruzeiro Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Cruzeiro Sign",
        "currency"
      ],
      "unicode": "e152"
    },
    {
      "name": "css",
      "label": "Css",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "rebecca purple"
      ],
      "unicode": "e6a2"
    },
    {
      "name": "css3",
      "label": "CSS 3 Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "code"
      ],
      "unicode": "f13c"
    },
    {
      "name": "css3-alt",
      "label": "Alternate CSS3 Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f38b"
    },
    {
      "name": "cube",
      "label": "Cube",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "3d",
        "block",
        "dice",
        "package",
        "square",
        "tesseract"
      ],
      "unicode": "f1b2"
    },
    {
      "name": "cubes",
      "label": "Cubes",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "3d",
        "block",
        "dice",
        "package",
        "pyramid",
        "square",
        "stack",
        "tesseract"
      ],
      "unicode": "f1b3"
    },
    {
      "name": "cubes-stacked",
      "label": "Cubes Stacked",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "blocks",
        "cubes",
        "sugar"
      ],
      "unicode": "e4e6"
    },
    {
      "name": "cuttlefish",
      "label": "Cuttlefish",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f38c"
    },
    {
      "name": "d",
      "label": "D",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter D",
        "Latin Small Letter D",
        "letter"
      ],
      "unicode": "44"
    },
    {
      "name": "d-and-d",
      "label": "Dungeons & Dragons",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f38d"
    },
    {
      "name": "d-and-d-beyond",
      "label": "D&D Beyond",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "d&d",
        "dnd",
        "fantasy",
        "gaming",
        "tabletop"
      ],
      "unicode": "f6ca"
    },
    {
      "name": "dailymotion",
      "label": "dailymotion",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e052"
    },
    {
      "name": "dart-lang",
      "label": "Dart Lang",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e693"
    },
    {
      "name": "dashcube",
      "label": "DashCube",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f210"
    },
    {
      "name": "database",
      "label": "Database",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "development",
        "directory",
        "memory",
        "mysql",
        "sql",
        "storage"
      ],
      "unicode": "f1c0"
    },
    {
      "name": "debian",
      "label": "Debian",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e60b"
    },
    {
      "name": "deezer",
      "label": "Deezer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e077"
    },
    {
      "name": "delete-left",
      "label": "Delete Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "Erase to the Left",
        "command",
        "delete",
        "erase",
        "keyboard",
        "undo"
      ],
      "unicode": "f55a"
    },
    {
      "name": "delicious",
      "label": "Delicious",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a5"
    },
    {
      "name": "democrat",
      "label": "Democrat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "american",
        "democratic party",
        "donkey",
        "election",
        "left",
        "left-wing",
        "liberal",
        "politics",
        "usa"
      ],
      "unicode": "f747"
    },
    {
      "name": "deploydog",
      "label": "deploy.dog",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f38e"
    },
    {
      "name": "deskpro",
      "label": "Deskpro",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f38f"
    },
    {
      "name": "desktop",
      "label": "Desktop",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "cpu",
        "demo",
        "desktop",
        "desktop computer",
        "device",
        "imac",
        "machine",
        "monitor",
        "pc",
        "screen"
      ],
      "unicode": "f390"
    },
    {
      "name": "dev",
      "label": "DEV",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f6cc"
    },
    {
      "name": "deviantart",
      "label": "deviantART",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1bd"
    },
    {
      "name": "dharmachakra",
      "label": "Dharmachakra",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Buddhist",
        "buddhism",
        "buddhist",
        "dharma",
        "religion",
        "wheel",
        "wheel of dharma"
      ],
      "unicode": "f655"
    },
    {
      "name": "dhl",
      "label": "DHL",
      "styles": [
        "brands"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "Dalsey",
        "Hillblom and Lynn",
        "german",
        "package",
        "shipping"
      ],
      "unicode": "f790"
    },
    {
      "name": "diagram-next",
      "label": "Diagram Next",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "cells",
        "chart",
        "gantt",
        "row",
        "subtask",
        "successor",
        "table"
      ],
      "unicode": "e476"
    },
    {
      "name": "diagram-predecessor",
      "label": "Diagram Predecessor",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "cells",
        "chart",
        "gantt",
        "predecessor",
        "previous",
        "row",
        "subtask",
        "table"
      ],
      "unicode": "e477"
    },
    {
      "name": "diagram-project",
      "label": "Diagram Project",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "chart",
        "graph",
        "network",
        "pert",
        "statistics"
      ],
      "unicode": "f542"
    },
    {
      "name": "diagram-successor",
      "label": "Diagram Successor",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "cells",
        "chart",
        "gantt",
        "next",
        "row",
        "subtask",
        "successor",
        "table"
      ],
      "unicode": "e47a"
    },
    {
      "name": "diamond",
      "label": "Diamond",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "ace",
        "card",
        "cards",
        "diamond suit",
        "game",
        "gem",
        "gemstone",
        "poker",
        "suit"
      ],
      "unicode": "f219"
    },
    {
      "name": "diamond-turn-right",
      "label": "Diamond Turn Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "map",
        "navigation",
        "sign",
        "turn"
      ],
      "unicode": "f5eb"
    },
    {
      "name": "diaspora",
      "label": "Diaspora",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f791"
    },
    {
      "name": "dice",
      "label": "Dice",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "chance",
        "dice",
        "die",
        "gambling",
        "game",
        "game die",
        "roll"
      ],
      "unicode": "f522"
    },
    {
      "name": "dice-d20",
      "label": "Dice D20",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "chance",
        "d&d",
        "dnd",
        "fantasy",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f6cf"
    },
    {
      "name": "dice-d6",
      "label": "Dice D6",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "chance",
        "d&d",
        "dnd",
        "fantasy",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f6d1"
    },
    {
      "name": "dice-five",
      "label": "Dice Five",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Die Face-5",
        "chance",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f523"
    },
    {
      "name": "dice-four",
      "label": "Dice Four",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Die Face-4",
        "chance",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f524"
    },
    {
      "name": "dice-one",
      "label": "Dice One",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Die Face-1",
        "chance",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f525"
    },
    {
      "name": "dice-six",
      "label": "Dice Six",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Die Face-6",
        "chance",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f526"
    },
    {
      "name": "dice-three",
      "label": "Dice Three",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Die Face-3",
        "chance",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f527"
    },
    {
      "name": "dice-two",
      "label": "Dice Two",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Die Face-2",
        "chance",
        "gambling",
        "game",
        "roll"
      ],
      "unicode": "f528"
    },
    {
      "name": "digg",
      "label": "Digg Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a6"
    },
    {
      "name": "digital-ocean",
      "label": "Digital Ocean",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f391"
    },
    {
      "name": "discord",
      "label": "Discord",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f392"
    },
    {
      "name": "discourse",
      "label": "Discourse",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f393"
    },
    {
      "name": "disease",
      "label": "Disease",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bacteria",
        "cancer",
        "coronavirus",
        "covid-19",
        "flu",
        "illness",
        "infection",
        "pandemic",
        "sickness",
        "virus"
      ],
      "unicode": "f7fa"
    },
    {
      "name": "display",
      "label": "Display",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "Screen",
        "computer",
        "desktop",
        "imac"
      ],
      "unicode": "e163"
    },
    {
      "name": "divide",
      "label": "Divide",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Division Sign",
        "arithmetic",
        "calculus",
        "divide",
        "division",
        "math",
        "sign",
        "÷"
      ],
      "unicode": "f529"
    },
    {
      "name": "dna",
      "label": "Dna",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "biologist",
        "dna",
        "double helix",
        "evolution",
        "gene",
        "genetic",
        "genetics",
        "helix",
        "life",
        "molecule",
        "protein"
      ],
      "unicode": "f471"
    },
    {
      "name": "dochub",
      "label": "DocHub",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f394"
    },
    {
      "name": "docker",
      "label": "Docker",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f395"
    },
    {
      "name": "dog",
      "label": "Dog",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "animal",
        "canine",
        "dog",
        "fauna",
        "mammal",
        "pet",
        "pooch",
        "puppy",
        "woof"
      ],
      "unicode": "f6d3"
    },
    {
      "name": "dollar-sign",
      "label": "Dollar Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "Dollar Sign",
        "coupon",
        "currency",
        "dollar",
        "heavy dollar sign",
        "investment",
        "money",
        "premium",
        "revenue",
        "salary"
      ],
      "unicode": "24"
    },
    {
      "name": "dolly",
      "label": "Dolly",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "carry",
        "shipping",
        "transport"
      ],
      "unicode": "f472"
    },
    {
      "name": "dong-sign",
      "label": "Dong Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dong Sign",
        "currency"
      ],
      "unicode": "e169"
    },
    {
      "name": "door-closed",
      "label": "Door Closed",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "doo",
        "door",
        "enter",
        "exit",
        "locked",
        "privacy"
      ],
      "unicode": "f52a"
    },
    {
      "name": "door-open",
      "label": "Door Open",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "enter",
        "exit",
        "welcome"
      ],
      "unicode": "f52b"
    },
    {
      "name": "dove",
      "label": "Dove",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bird",
        "dove",
        "fauna",
        "fly",
        "flying",
        "peace",
        "war"
      ],
      "unicode": "f4ba"
    },
    {
      "name": "down-left-and-up-right-to-center",
      "label": "Down Left And Up Right To Center",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "collapse",
        "fullscreen",
        "minimize",
        "move",
        "resize",
        "scale",
        "shrink",
        "size",
        "smaller"
      ],
      "unicode": "f422"
    },
    {
      "name": "down-long",
      "label": "Down Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "download",
        "long-arrow-down"
      ],
      "unicode": "f309"
    },
    {
      "name": "download",
      "label": "Download",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "export",
        "hard drive",
        "insert",
        "save",
        "transfer"
      ],
      "unicode": "f019"
    },
    {
      "name": "draft2digital",
      "label": "Draft2digital",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f396"
    },
    {
      "name": "dragon",
      "label": "Dragon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "Dungeons & Dragons",
        "d&d",
        "dnd",
        "dragon",
        "fairy tale",
        "fantasy",
        "fire",
        "lizard",
        "serpent"
      ],
      "unicode": "f6d5"
    },
    {
      "name": "draw-polygon",
      "label": "Draw Polygon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "anchors",
        "lines",
        "object",
        "render",
        "shape"
      ],
      "unicode": "f5ee"
    },
    {
      "name": "dribbble",
      "label": "Dribbble",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f17d"
    },
    {
      "name": "dropbox",
      "label": "Dropbox",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f16b"
    },
    {
      "name": "droplet",
      "label": "Droplet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "blood",
        "cold",
        "color",
        "comic",
        "drop",
        "droplet",
        "raindrop",
        "sweat",
        "waterdrop"
      ],
      "unicode": "f043"
    },
    {
      "name": "droplet-slash",
      "label": "Droplet Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "blood",
        "color",
        "disabled",
        "drop",
        "droplet",
        "raindrop",
        "waterdrop"
      ],
      "unicode": "f5c7"
    },
    {
      "name": "drum",
      "label": "Drum",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "drum",
        "drumsticks",
        "instrument",
        "music",
        "percussion",
        "snare",
        "sound"
      ],
      "unicode": "f569"
    },
    {
      "name": "drum-steelpan",
      "label": "Drum Steelpan",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "calypso",
        "instrument",
        "music",
        "percussion",
        "reggae",
        "snare",
        "sound",
        "steel",
        "tropical"
      ],
      "unicode": "f56a"
    },
    {
      "name": "drumstick-bite",
      "label": "Drumstick Bite",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "bone",
        "chicken",
        "leg",
        "meat",
        "poultry",
        "turkey"
      ],
      "unicode": "f6d7"
    },
    {
      "name": "drupal",
      "label": "Drupal Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a9"
    },
    {
      "name": "dumbbell",
      "label": "Dumbbell",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "exercise",
        "gym",
        "strength",
        "weight",
        "weight-lifting",
        "workout"
      ],
      "unicode": "f44b"
    },
    {
      "name": "dumpster",
      "label": "Dumpster",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "alley",
        "bin",
        "commercial",
        "trash",
        "waste"
      ],
      "unicode": "f793"
    },
    {
      "name": "dumpster-fire",
      "label": "Dumpster Fire",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "alley",
        "bin",
        "commercial",
        "danger",
        "dangerous",
        "euphemism",
        "flame",
        "heat",
        "hot",
        "trash",
        "waste"
      ],
      "unicode": "f794"
    },
    {
      "name": "dungeon",
      "label": "Dungeon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "Dungeons & Dragons",
        "building",
        "d&d",
        "dnd",
        "door",
        "entrance",
        "fantasy",
        "gate"
      ],
      "unicode": "f6d9"
    },
    {
      "name": "dyalog",
      "label": "Dyalog",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f399"
    },
    {
      "name": "e",
      "label": "E",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter E",
        "Latin Small Letter E",
        "letter"
      ],
      "unicode": "45"
    },
    {
      "name": "ear-deaf",
      "label": "Ear Deaf",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ear",
        "hearing",
        "sign language"
      ],
      "unicode": "f2a4"
    },
    {
      "name": "ear-listen",
      "label": "Ear Listen",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "amplify",
        "audio",
        "deaf",
        "ear",
        "headset",
        "hearing",
        "sound"
      ],
      "unicode": "f2a2"
    },
    {
      "name": "earlybirds",
      "label": "Earlybirds",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f39a"
    },
    {
      "name": "earth-africa",
      "label": "Earth Africa",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "africa",
        "all",
        "country",
        "earth",
        "europe",
        "global",
        "globe",
        "gps",
        "language",
        "localize",
        "location",
        "map",
        "online",
        "place",
        "planet",
        "translate",
        "travel",
        "world"
      ],
      "unicode": "f57c"
    },
    {
      "name": "earth-americas",
      "label": "Earth Americas",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "all",
        "america",
        "country",
        "earth",
        "global",
        "globe",
        "gps",
        "language",
        "localize",
        "location",
        "map",
        "online",
        "place",
        "planet",
        "translate",
        "travel",
        "world"
      ],
      "unicode": "f57d"
    },
    {
      "name": "earth-asia",
      "label": "Earth Asia",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "all",
        "asia",
        "australia",
        "country",
        "earth",
        "global",
        "globe",
        "gps",
        "language",
        "localize",
        "location",
        "map",
        "online",
        "place",
        "planet",
        "translate",
        "travel",
        "world"
      ],
      "unicode": "f57e"
    },
    {
      "name": "earth-europe",
      "label": "Earth Europe",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "all",
        "country",
        "earth",
        "europe",
        "global",
        "globe",
        "gps",
        "language",
        "localize",
        "location",
        "map",
        "online",
        "place",
        "planet",
        "translate",
        "travel",
        "world"
      ],
      "unicode": "f7a2"
    },
    {
      "name": "earth-oceania",
      "label": "Earth Oceania",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "all",
        "australia",
        "country",
        "earth",
        "global",
        "globe",
        "gps",
        "language",
        "localize",
        "location",
        "map",
        "melanesia",
        "micronesia",
        "new zealand",
        "online",
        "place",
        "planet",
        "polynesia",
        "translate",
        "travel",
        "world"
      ],
      "unicode": "e47b"
    },
    {
      "name": "ebay",
      "label": "eBay",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f4"
    },
    {
      "name": "edge",
      "label": "Edge Browser",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "browser",
        "ie"
      ],
      "unicode": "f282"
    },
    {
      "name": "edge-legacy",
      "label": "Edge Legacy Browser",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e078"
    },
    {
      "name": "egg",
      "label": "Egg",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "breakfast",
        "chicken",
        "easter",
        "egg",
        "food",
        "shell",
        "yolk"
      ],
      "unicode": "f7fb"
    },
    {
      "name": "eject",
      "label": "Eject",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "abort",
        "cancel",
        "cd",
        "discharge",
        "eject",
        "eject button"
      ],
      "unicode": "f052"
    },
    {
      "name": "elementor",
      "label": "Elementor",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f430"
    },
    {
      "name": "elevator",
      "label": "Elevator",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "accessibility",
        "elevator",
        "hoist",
        "lift",
        "uer",
        "users-people"
      ],
      "unicode": "e16d"
    },
    {
      "name": "ellipsis",
      "label": "Ellipsis",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting"
      ],
      "search": [
        "dots",
        "drag",
        "kebab",
        "list",
        "menu",
        "nav",
        "navigation",
        "ol",
        "pacman",
        "reorder",
        "settings",
        "three dots",
        "ul"
      ],
      "unicode": "f141"
    },
    {
      "name": "ellipsis-vertical",
      "label": "Ellipsis Vertical",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting"
      ],
      "search": [
        "bullet",
        "dots",
        "drag",
        "kebab",
        "list",
        "menu",
        "nav",
        "navigation",
        "ol",
        "reorder",
        "settings",
        "three dots",
        "ul"
      ],
      "unicode": "f142"
    },
    {
      "name": "ello",
      "label": "Ello",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5f1"
    },
    {
      "name": "ember",
      "label": "Ember",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f423"
    },
    {
      "name": "empire",
      "label": "Galactic Empire",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d1"
    },
    {
      "name": "envelope",
      "label": "Envelope",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "Back of Envelope",
        "e-mail",
        "email",
        "envelope",
        "letter",
        "mail",
        "message",
        "newsletter",
        "notification",
        "offer",
        "support"
      ],
      "unicode": "f0e0"
    },
    {
      "name": "envelope-circle-check",
      "label": "Envelope Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Communication"
      ],
      "search": [
        "check",
        "email",
        "enable",
        "envelope",
        "mail",
        "not affected",
        "ok",
        "okay",
        "read",
        "sent",
        "validate",
        "working"
      ],
      "unicode": "e4e8"
    },
    {
      "name": "envelope-open",
      "label": "Envelope Open",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Communication"
      ],
      "search": [
        "e-mail",
        "email",
        "letter",
        "mail",
        "message",
        "newsletter",
        "notification",
        "offer",
        "support"
      ],
      "unicode": "f2b6"
    },
    {
      "name": "envelope-open-text",
      "label": "Envelope Open Text",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "e-mail",
        "email",
        "letter",
        "mail",
        "message",
        "newsletter",
        "notification",
        "offer",
        "support"
      ],
      "unicode": "f658"
    },
    {
      "name": "envelopes-bulk",
      "label": "Envelopes Bulk",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "archive",
        "envelope",
        "letter",
        "newsletter",
        "offer",
        "post office",
        "postal",
        "postcard",
        "send",
        "stamp",
        "usps"
      ],
      "unicode": "f674"
    },
    {
      "name": "envira",
      "label": "Envira Gallery",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "leaf"
      ],
      "unicode": "f299"
    },
    {
      "name": "equals",
      "label": "Equals",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Equals Sign",
        "arithmetic",
        "even",
        "match",
        "math"
      ],
      "unicode": "3d"
    },
    {
      "name": "eraser",
      "label": "Eraser",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "art",
        "delete",
        "remove",
        "rubber"
      ],
      "unicode": "f12d"
    },
    {
      "name": "erlang",
      "label": "Erlang",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f39d"
    },
    {
      "name": "ethereum",
      "label": "Ethereum",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f42e"
    },
    {
      "name": "ethernet",
      "label": "Ethernet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cable",
        "cat 5",
        "cat 6",
        "connection",
        "hardware",
        "internet",
        "network",
        "wired"
      ],
      "unicode": "f796"
    },
    {
      "name": "etsy",
      "label": "Etsy",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2d7"
    },
    {
      "name": "euro-sign",
      "label": "Euro Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Euro Sign",
        "currency"
      ],
      "unicode": "f153"
    },
    {
      "name": "evernote",
      "label": "Evernote",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f839"
    },
    {
      "name": "exclamation",
      "label": "Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "!",
        "Exclamation Mark",
        "alert",
        "attention",
        "danger",
        "error",
        "exclamation",
        "failed",
        "important",
        "mark",
        "notice",
        "notification",
        "notify",
        "outlined",
        "problem",
        "punctuation",
        "red exclamation mark",
        "required",
        "warning",
        "white exclamation mark"
      ],
      "unicode": "21"
    },
    {
      "name": "expand",
      "label": "Expand",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrows",
        "bigger",
        "enlarge",
        "expand",
        "fullscreen",
        "maximize",
        "resize",
        "resize",
        "scale",
        "size",
        "viewfinder"
      ],
      "unicode": "f065"
    },
    {
      "name": "expeditedssl",
      "label": "ExpeditedSSL",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions"
      ],
      "search": [],
      "unicode": "f23e"
    },
    {
      "name": "explosion",
      "label": "Explosion",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "blast",
        "blowup",
        "boom",
        "crash",
        "detonation",
        "explosion"
      ],
      "unicode": "e4e9"
    },
    {
      "name": "eye",
      "label": "Eye",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "body",
        "eye",
        "look",
        "optic",
        "see",
        "seen",
        "show",
        "sight",
        "views",
        "visible"
      ],
      "unicode": "f06e"
    },
    {
      "name": "eye-dropper",
      "label": "Eye Dropper",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "beaker",
        "clone",
        "color",
        "copy",
        "eyedropper",
        "pipette"
      ],
      "unicode": "f1fb"
    },
    {
      "name": "eye-low-vision",
      "label": "Eye Low Vision",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "blind",
        "eye",
        "sight"
      ],
      "unicode": "f2a8"
    },
    {
      "name": "eye-slash",
      "label": "Eye Slash",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "blind",
        "disabled",
        "hide",
        "show",
        "toggle",
        "unseen",
        "views",
        "visible",
        "visiblity"
      ],
      "unicode": "f070"
    },
    {
      "name": "f",
      "label": "F",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter F",
        "Latin Small Letter F",
        "letter"
      ],
      "unicode": "46"
    },
    {
      "name": "face-angry",
      "label": "Face Angry",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "angry",
        "angry face",
        "disapprove",
        "emoticon",
        "face",
        "mad",
        "upset"
      ],
      "unicode": "f556"
    },
    {
      "name": "face-dizzy",
      "label": "Face Dizzy",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "dazed",
        "dead",
        "disapprove",
        "emoticon",
        "face"
      ],
      "unicode": "f567"
    },
    {
      "name": "face-flushed",
      "label": "Face Flushed",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "dazed",
        "embarrassed",
        "emoticon",
        "face",
        "flushed",
        "flushed face"
      ],
      "unicode": "f579"
    },
    {
      "name": "face-frown",
      "label": "Face Frown",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "disapprove",
        "emoticon",
        "face",
        "frown",
        "frowning face",
        "rating",
        "sad",
        "uer"
      ],
      "unicode": "f119"
    },
    {
      "name": "face-frown-open",
      "label": "Face Frown Open",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "disapprove",
        "emoticon",
        "face",
        "frown",
        "frowning face with open mouth",
        "mouth",
        "open",
        "rating",
        "sad"
      ],
      "unicode": "f57a"
    },
    {
      "name": "face-grimace",
      "label": "Face Grimace",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cringe",
        "emoticon",
        "face",
        "grimace",
        "grimacing face",
        "teeth"
      ],
      "unicode": "f57f"
    },
    {
      "name": "face-grin",
      "label": "Face Grin",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emoticon",
        "face",
        "grin",
        "grinning face",
        "laugh",
        "smile"
      ],
      "unicode": "f580"
    },
    {
      "name": "face-grin-beam",
      "label": "Face Grin Beam",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "emoticon",
        "eye",
        "face",
        "grinning face with smiling eyes",
        "laugh",
        "mouth",
        "open",
        "smile"
      ],
      "unicode": "f582"
    },
    {
      "name": "face-grin-beam-sweat",
      "label": "Face Grin Beam Sweat",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "cold",
        "embarass",
        "emoticon",
        "face",
        "grinning face with sweat",
        "open",
        "smile",
        "sweat"
      ],
      "unicode": "f583"
    },
    {
      "name": "face-grin-hearts",
      "label": "Face Grin Hearts",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "emoticon",
        "eye",
        "face",
        "love",
        "smile",
        "smiling face with heart-eyes"
      ],
      "unicode": "f584"
    },
    {
      "name": "face-grin-squint",
      "label": "Face Grin Squint",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emoticon",
        "face",
        "grinning squinting face",
        "laugh",
        "mouth",
        "satisfied",
        "smile"
      ],
      "unicode": "f585"
    },
    {
      "name": "face-grin-squint-tears",
      "label": "Face Grin Squint Tears",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emoticon",
        "face",
        "floor",
        "happy",
        "laugh",
        "rolling",
        "rolling on the floor laughing",
        "smile"
      ],
      "unicode": "f586"
    },
    {
      "name": "face-grin-stars",
      "label": "Face Grin Stars",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Security",
        "Transportation"
      ],
      "search": [
        "emoticon",
        "eyes",
        "face",
        "grinning",
        "quality",
        "star",
        "star-struck",
        "starry-eyed",
        "vip"
      ],
      "unicode": "f587"
    },
    {
      "name": "face-grin-tears",
      "label": "Face Grin Tears",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "LOL",
        "emoticon",
        "face",
        "face with tears of joy",
        "joy",
        "laugh",
        "tear"
      ],
      "unicode": "f588"
    },
    {
      "name": "face-grin-tongue",
      "label": "Face Grin Tongue",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "LOL",
        "emoticon",
        "face",
        "face with tongue",
        "tongue"
      ],
      "unicode": "f589"
    },
    {
      "name": "face-grin-tongue-squint",
      "label": "Face Grin Tongue Squint",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "LOL",
        "emoticon",
        "eye",
        "face",
        "horrible",
        "squinting face with tongue",
        "taste",
        "tongue"
      ],
      "unicode": "f58a"
    },
    {
      "name": "face-grin-tongue-wink",
      "label": "Face Grin Tongue Wink",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "LOL",
        "emoticon",
        "eye",
        "face",
        "joke",
        "tongue",
        "wink",
        "winking face with tongue"
      ],
      "unicode": "f58b"
    },
    {
      "name": "face-grin-wide",
      "label": "Face Grin Wide",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "emoticon",
        "face",
        "grinning face with big eyes",
        "laugh",
        "mouth",
        "open",
        "smile"
      ],
      "unicode": "f581"
    },
    {
      "name": "face-grin-wink",
      "label": "Face Grin Wink",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emoticon",
        "face",
        "flirt",
        "laugh",
        "smile"
      ],
      "unicode": "f58c"
    },
    {
      "name": "face-kiss",
      "label": "Face Kiss",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "beso",
        "emoticon",
        "face",
        "kiss",
        "kissing face",
        "love",
        "smooch"
      ],
      "unicode": "f596"
    },
    {
      "name": "face-kiss-beam",
      "label": "Face Kiss Beam",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "beso",
        "emoticon",
        "eye",
        "face",
        "kiss",
        "kissing face with smiling eyes",
        "love",
        "smile",
        "smooch"
      ],
      "unicode": "f597"
    },
    {
      "name": "face-kiss-wink-heart",
      "label": "Face Kiss Wink Heart",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "beso",
        "emoticon",
        "face",
        "face blowing a kiss",
        "kiss",
        "love",
        "smooch"
      ],
      "unicode": "f598"
    },
    {
      "name": "face-laugh",
      "label": "Face Laugh",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "LOL",
        "emoticon",
        "face",
        "laugh",
        "smile"
      ],
      "unicode": "f599"
    },
    {
      "name": "face-laugh-beam",
      "label": "Face Laugh Beam",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "LOL",
        "beaming face with smiling eyes",
        "emoticon",
        "eye",
        "face",
        "grin",
        "happy",
        "smile"
      ],
      "unicode": "f59a"
    },
    {
      "name": "face-laugh-squint",
      "label": "Face Laugh Squint",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "LOL",
        "emoticon",
        "face",
        "happy",
        "smile"
      ],
      "unicode": "f59b"
    },
    {
      "name": "face-laugh-wink",
      "label": "Face Laugh Wink",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "LOL",
        "emoticon",
        "face",
        "happy",
        "smile"
      ],
      "unicode": "f59c"
    },
    {
      "name": "face-meh",
      "label": "Face Meh",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "deadpan",
        "default",
        "emoticon",
        "face",
        "meh",
        "neutral",
        "neutral face",
        "rating",
        "uer"
      ],
      "unicode": "f11a"
    },
    {
      "name": "face-meh-blank",
      "label": "Face Meh Blank",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emoticon",
        "face",
        "face without mouth",
        "mouth",
        "neutral",
        "quiet",
        "rating",
        "silent"
      ],
      "unicode": "f5a4"
    },
    {
      "name": "face-rolling-eyes",
      "label": "Face Rolling Eyes",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "emoticon",
        "eyeroll",
        "eyes",
        "face",
        "face with rolling eyes",
        "neutral",
        "rating",
        "rolling"
      ],
      "unicode": "f5a5"
    },
    {
      "name": "face-sad-cry",
      "label": "Face Sad Cry",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cry",
        "emoticon",
        "face",
        "loudly crying face",
        "sad",
        "sob",
        "tear",
        "tears"
      ],
      "unicode": "f5b3"
    },
    {
      "name": "face-sad-tear",
      "label": "Face Sad Tear",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cry",
        "crying face",
        "emoticon",
        "face",
        "sad",
        "tear",
        "tears"
      ],
      "unicode": "f5b4"
    },
    {
      "name": "face-smile",
      "label": "Face Smile",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "approve",
        "default",
        "emoticon",
        "face",
        "happy",
        "rating",
        "satisfied",
        "slightly smiling face",
        "smile",
        "uer"
      ],
      "unicode": "f118"
    },
    {
      "name": "face-smile-beam",
      "label": "Face Smile Beam",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "blush",
        "emoticon",
        "eye",
        "face",
        "happy",
        "positive",
        "smile",
        "smiling face with smiling eyes"
      ],
      "unicode": "f5b8"
    },
    {
      "name": "face-smile-wink",
      "label": "Face Smile Wink",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emoticon",
        "face",
        "happy",
        "hint",
        "joke",
        "wink",
        "winking face"
      ],
      "unicode": "f4da"
    },
    {
      "name": "face-surprise",
      "label": "Face Surprise",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "emoticon",
        "face",
        "face with open mouth",
        "mouth",
        "open",
        "shocked",
        "sympathy"
      ],
      "unicode": "f5c2"
    },
    {
      "name": "face-tired",
      "label": "Face Tired",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "angry",
        "emoticon",
        "face",
        "grumpy",
        "tired",
        "tired face",
        "upset"
      ],
      "unicode": "f5c8"
    },
    {
      "name": "facebook",
      "label": "Facebook",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "fabook",
        "facebook-official",
        "fb",
        "social network"
      ],
      "unicode": "f09a"
    },
    {
      "name": "facebook-f",
      "label": "Facebook F",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "fabook",
        "facebook",
        "fb"
      ],
      "unicode": "f39e"
    },
    {
      "name": "facebook-messenger",
      "label": "Facebook Messenger",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "fabook",
        "fb"
      ],
      "unicode": "f39f"
    },
    {
      "name": "fan",
      "label": "Fan",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ac",
        "air conditioning",
        "blade",
        "blower",
        "cool",
        "hot"
      ],
      "unicode": "f863"
    },
    {
      "name": "fantasy-flight-games",
      "label": "Fantasy Flight-games",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "d&d",
        "dnd",
        "fantasy",
        "game",
        "gaming",
        "tabletop"
      ],
      "unicode": "f6dc"
    },
    {
      "name": "faucet",
      "label": "Faucet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "covid-19",
        "drinking",
        "drip",
        "house",
        "hygiene",
        "kitchen",
        "potable",
        "potable water",
        "sanitation",
        "sink",
        "water"
      ],
      "unicode": "e005"
    },
    {
      "name": "faucet-drip",
      "label": "Faucet Drip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drinking",
        "drip",
        "house",
        "hygiene",
        "kitchen",
        "potable",
        "potable water",
        "sanitation",
        "sink",
        "water"
      ],
      "unicode": "e006"
    },
    {
      "name": "fax",
      "label": "Fax",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Transportation"
      ],
      "search": [
        "Fax Icon",
        "business",
        "communicate",
        "copy",
        "facsimile",
        "fax",
        "fax machine",
        "send"
      ],
      "unicode": "f1ac"
    },
    {
      "name": "feather",
      "label": "Feather",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bird",
        "feather",
        "flight",
        "light",
        "plucked",
        "plumage",
        "quill",
        "write"
      ],
      "unicode": "f52d"
    },
    {
      "name": "feather-pointed",
      "label": "Feather Pointed",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bird",
        "light",
        "plucked",
        "quill",
        "write"
      ],
      "unicode": "f56b"
    },
    {
      "name": "fedex",
      "label": "FedEx",
      "styles": [
        "brands"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "Federal Express",
        "package",
        "shipping"
      ],
      "unicode": "f797"
    },
    {
      "name": "fedora",
      "label": "Fedora",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "linux",
        "operating system",
        "os"
      ],
      "unicode": "f798"
    },
    {
      "name": "ferry",
      "label": "Ferry",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "barge",
        "boat",
        "carry",
        "ferryboat",
        "ship"
      ],
      "unicode": "e4ea"
    },
    {
      "name": "figma",
      "label": "Figma",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "app",
        "design",
        "interface"
      ],
      "unicode": "f799"
    },
    {
      "name": "file",
      "label": "File",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "Empty Document",
        "cv",
        "document",
        "new",
        "page",
        "page facing up",
        "pdf",
        "resume"
      ],
      "unicode": "f15b"
    },
    {
      "name": "file-arrow-down",
      "label": "File Arrow Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "archive",
        "document",
        "export",
        "insert",
        "save"
      ],
      "unicode": "f56d"
    },
    {
      "name": "file-arrow-up",
      "label": "File Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "document",
        "import",
        "page",
        "save",
        "upgrade"
      ],
      "unicode": "f574"
    },
    {
      "name": "file-audio",
      "label": "File Audio",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media",
        "Files & Folders"
      ],
      "search": [
        "document",
        "mp3",
        "music",
        "page",
        "play",
        "sound"
      ],
      "unicode": "f1c7"
    },
    {
      "name": "file-circle-check",
      "label": "File Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Files & Folders"
      ],
      "search": [
        "document",
        "enable",
        "file",
        "not affected",
        "ok",
        "okay",
        "paper",
        "validate",
        "working"
      ],
      "unicode": "e5a0"
    },
    {
      "name": "file-circle-exclamation",
      "label": "File Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Files & Folders"
      ],
      "search": [
        "document",
        "failed",
        "file",
        "paper"
      ],
      "unicode": "e4eb"
    },
    {
      "name": "file-circle-minus",
      "label": "File Circle Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "document",
        "file",
        "paper"
      ],
      "unicode": "e4ed"
    },
    {
      "name": "file-circle-plus",
      "label": "File Circle Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "add",
        "document",
        "file",
        "new",
        "page",
        "paper",
        "pdf"
      ],
      "unicode": "e494"
    },
    {
      "name": "file-circle-question",
      "label": "File Circle Question",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Files & Folders"
      ],
      "search": [
        "document",
        "file",
        "paper"
      ],
      "unicode": "e4ef"
    },
    {
      "name": "file-circle-xmark",
      "label": "File Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Files & Folders"
      ],
      "search": [
        "document",
        "file",
        "paper",
        "uncheck"
      ],
      "unicode": "e5a1"
    },
    {
      "name": "file-code",
      "label": "File Code",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "css",
        "development",
        "document",
        "html",
        "mysql",
        "sql"
      ],
      "unicode": "f1c9"
    },
    {
      "name": "file-contract",
      "label": "File Contract",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Files & Folders"
      ],
      "search": [
        "agreement",
        "binding",
        "document",
        "legal",
        "signature",
        "username"
      ],
      "unicode": "f56c"
    },
    {
      "name": "file-csv",
      "label": "File Csv",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "document",
        "excel",
        "numbers",
        "spreadsheets",
        "table"
      ],
      "unicode": "f6dd"
    },
    {
      "name": "file-excel",
      "label": "File Excel",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "csv",
        "document",
        "numbers",
        "spreadsheets",
        "table"
      ],
      "unicode": "f1c3"
    },
    {
      "name": "file-export",
      "label": "File Export",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "download",
        "save"
      ],
      "unicode": "f56e"
    },
    {
      "name": "file-fragment",
      "label": "File Fragment",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders",
        "Security"
      ],
      "search": [
        "block",
        "data",
        "partial",
        "piece"
      ],
      "unicode": "e697"
    },
    {
      "name": "file-half-dashed",
      "label": "File Half Dashed",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "data",
        "fragment",
        "partial",
        "piece"
      ],
      "unicode": "e698"
    },
    {
      "name": "file-image",
      "label": "File Image",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media",
        "Files & Folders"
      ],
      "search": [
        "Document with Picture",
        "document",
        "image",
        "img",
        "jpg",
        "photo",
        "png"
      ],
      "unicode": "f1c5"
    },
    {
      "name": "file-import",
      "label": "File Import",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "copy",
        "document",
        "insert",
        "send",
        "upload"
      ],
      "unicode": "f56f"
    },
    {
      "name": "file-invoice",
      "label": "File Invoice",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Files & Folders"
      ],
      "search": [
        "account",
        "bill",
        "charge",
        "document",
        "payment",
        "receipt"
      ],
      "unicode": "f570"
    },
    {
      "name": "file-invoice-dollar",
      "label": "File Invoice Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Files & Folders"
      ],
      "search": [
        "$",
        "account",
        "bill",
        "charge",
        "document",
        "dollar-sign",
        "money",
        "payment",
        "receipt",
        "revenue",
        "salary",
        "usd"
      ],
      "unicode": "f571"
    },
    {
      "name": "file-lines",
      "label": "File Lines",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Files & Folders",
        "Text & Formatting"
      ],
      "search": [
        "Document",
        "Document with Text",
        "document",
        "file-text",
        "invoice",
        "new",
        "page",
        "pdf"
      ],
      "unicode": "f15c"
    },
    {
      "name": "file-medical",
      "label": "File Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "document",
        "health",
        "history",
        "prescription",
        "record"
      ],
      "unicode": "f477"
    },
    {
      "name": "file-pdf",
      "label": "File Pdf",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "acrobat",
        "document",
        "preview",
        "save"
      ],
      "unicode": "f1c1"
    },
    {
      "name": "file-pen",
      "label": "File Pen",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "edit",
        "memo",
        "modify",
        "pen",
        "pencil",
        "update",
        "write"
      ],
      "unicode": "f31c"
    },
    {
      "name": "file-powerpoint",
      "label": "File Powerpoint",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media",
        "Files & Folders",
        "Security"
      ],
      "search": [
        "display",
        "document",
        "keynote",
        "presentation"
      ],
      "unicode": "f1c4"
    },
    {
      "name": "file-prescription",
      "label": "File Prescription",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "document",
        "drugs",
        "medical",
        "medicine",
        "rx"
      ],
      "unicode": "f572"
    },
    {
      "name": "file-shield",
      "label": "File Shield",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders",
        "Security"
      ],
      "search": [
        "antivirus",
        "data",
        "document",
        "protect",
        "safe",
        "safety",
        "secure"
      ],
      "unicode": "e4f0"
    },
    {
      "name": "file-signature",
      "label": "File Signature",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Files & Folders"
      ],
      "search": [
        "John Hancock",
        "contract",
        "document",
        "name",
        "username"
      ],
      "unicode": "f573"
    },
    {
      "name": "file-video",
      "label": "File Video",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media",
        "Files & Folders"
      ],
      "search": [
        "document",
        "m4v",
        "movie",
        "mp4",
        "play"
      ],
      "unicode": "f1c8"
    },
    {
      "name": "file-waveform",
      "label": "File Waveform",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "document",
        "health",
        "history",
        "prescription",
        "record"
      ],
      "unicode": "f478"
    },
    {
      "name": "file-word",
      "label": "File Word",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Files & Folders",
        "Text & Formatting"
      ],
      "search": [
        "document",
        "edit",
        "page",
        "text",
        "writing"
      ],
      "unicode": "f1c2"
    },
    {
      "name": "file-zipper",
      "label": "File Zipper",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        ".zip",
        "bundle",
        "compress",
        "compression",
        "download",
        "zip"
      ],
      "unicode": "f1c6"
    },
    {
      "name": "files-pinwheel",
      "label": "Files Pinwheel",
      "styles": [
        "brands"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [],
      "unicode": "e69f"
    },
    {
      "name": "fill",
      "label": "Fill",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bucket",
        "color",
        "paint",
        "paint bucket"
      ],
      "unicode": "f575"
    },
    {
      "name": "fill-drip",
      "label": "Fill Drip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bucket",
        "color",
        "drop",
        "paint",
        "paint bucket",
        "spill"
      ],
      "unicode": "f576"
    },
    {
      "name": "film",
      "label": "Film",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "cinema",
        "film",
        "film frames",
        "frames",
        "movie",
        "strip",
        "video"
      ],
      "unicode": "f008"
    },
    {
      "name": "filter",
      "label": "Filter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "funnel",
        "options",
        "separate",
        "sort"
      ],
      "unicode": "f0b0"
    },
    {
      "name": "filter-circle-dollar",
      "label": "Filter Circle Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "filter",
        "money",
        "options",
        "premium",
        "separate",
        "sort"
      ],
      "unicode": "f662"
    },
    {
      "name": "filter-circle-xmark",
      "label": "Filter Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "cancel",
        "funnel",
        "options",
        "remove",
        "separate",
        "sort",
        "uncheck"
      ],
      "unicode": "e17b"
    },
    {
      "name": "fingerprint",
      "label": "Fingerprint",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "human",
        "id",
        "identification",
        "lock",
        "privacy",
        "smudge",
        "touch",
        "unique",
        "unlock"
      ],
      "unicode": "f577"
    },
    {
      "name": "fire",
      "label": "Fire",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "burn",
        "caliente",
        "fire",
        "flame",
        "heat",
        "hot",
        "popular",
        "tool"
      ],
      "unicode": "f06d"
    },
    {
      "name": "fire-burner",
      "label": "Fire Burner",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cook",
        "fire",
        "flame",
        "kitchen",
        "stove"
      ],
      "unicode": "e4f1"
    },
    {
      "name": "fire-extinguisher",
      "label": "Fire Extinguisher",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "burn",
        "caliente",
        "extinguish",
        "fire",
        "fire extinguisher",
        "fire fighter",
        "flame",
        "heat",
        "hot",
        "quench",
        "rescue"
      ],
      "unicode": "f134"
    },
    {
      "name": "fire-flame-curved",
      "label": "Fire Flame Curved",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "burn",
        "caliente",
        "flame",
        "heat",
        "hot",
        "popular"
      ],
      "unicode": "f7e4"
    },
    {
      "name": "fire-flame-simple",
      "label": "Fire Flame Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "caliente",
        "energy",
        "fire",
        "flame",
        "gas",
        "heat",
        "hot"
      ],
      "unicode": "f46a"
    },
    {
      "name": "firefox",
      "label": "Firefox",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "browser"
      ],
      "unicode": "f269"
    },
    {
      "name": "firefox-browser",
      "label": "Firefox Browser",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "browser"
      ],
      "unicode": "e007"
    },
    {
      "name": "first-order",
      "label": "First Order",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2b0"
    },
    {
      "name": "first-order-alt",
      "label": "Alternate First Order",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f50a"
    },
    {
      "name": "firstdraft",
      "label": "firstdraft",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3a1"
    },
    {
      "name": "fish",
      "label": "Fish",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Pisces",
        "fauna",
        "fish",
        "gold",
        "seafood",
        "swimming",
        "zodiac"
      ],
      "unicode": "f578"
    },
    {
      "name": "fish-fins",
      "label": "Fish Fins",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "fish",
        "fishery",
        "pisces",
        "seafood"
      ],
      "unicode": "e4f2"
    },
    {
      "name": "flag",
      "label": "Flag",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "black flag",
        "country",
        "notice",
        "notification",
        "notify",
        "pole",
        "report",
        "symbol",
        "waving"
      ],
      "unicode": "f024"
    },
    {
      "name": "flag-checkered",
      "label": "Flag Checkered",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "checkered",
        "chequered",
        "chequered flag",
        "finish",
        "notice",
        "notification",
        "notify",
        "pole",
        "racing",
        "report",
        "start",
        "symbol",
        "win"
      ],
      "unicode": "f11e"
    },
    {
      "name": "flag-usa",
      "label": "Flag Usa",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "betsy ross",
        "country",
        "fla",
        "flag: United States",
        "old glory",
        "stars",
        "stripes",
        "symbol"
      ],
      "unicode": "f74d"
    },
    {
      "name": "flask",
      "label": "Flask",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "beaker",
        "chemicals",
        "experiment",
        "experimental",
        "knowledge",
        "labs",
        "liquid",
        "potion",
        "science",
        "vial"
      ],
      "unicode": "f0c3"
    },
    {
      "name": "flask-vial",
      "label": "Flask Vial",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ampule",
        "beaker",
        "chemicals",
        "chemistry",
        "experiment",
        "experimental",
        "lab",
        "laboratory",
        "labs",
        "liquid",
        "potion",
        "science",
        "test",
        "test tube",
        "vial"
      ],
      "unicode": "e4f3"
    },
    {
      "name": "flickr",
      "label": "Flickr",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f16e"
    },
    {
      "name": "flipboard",
      "label": "Flipboard",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f44d"
    },
    {
      "name": "floppy-disk",
      "label": "Floppy Disk",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "Black Hard Shell Floppy Disk",
        "computer",
        "disk",
        "download",
        "floppy",
        "floppy disk",
        "floppy-o"
      ],
      "unicode": "f0c7"
    },
    {
      "name": "florin-sign",
      "label": "Florin Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "currency"
      ],
      "unicode": "e184"
    },
    {
      "name": "flutter",
      "label": "Flutter",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e694"
    },
    {
      "name": "fly",
      "label": "Fly",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f417"
    },
    {
      "name": "folder",
      "label": "Folder",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "Black Folder",
        "archive",
        "directory",
        "document",
        "file",
        "file folder",
        "folder"
      ],
      "unicode": "f07b"
    },
    {
      "name": "folder-closed",
      "label": "Folder Closed",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "file"
      ],
      "unicode": "e185"
    },
    {
      "name": "folder-minus",
      "label": "Folder Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "archive",
        "delete",
        "directory",
        "document",
        "file",
        "negative",
        "remove"
      ],
      "unicode": "f65d"
    },
    {
      "name": "folder-open",
      "label": "Folder Open",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "Open Folder",
        "archive",
        "directory",
        "document",
        "empty",
        "file",
        "folder",
        "new",
        "open",
        "open file folder"
      ],
      "unicode": "f07c"
    },
    {
      "name": "folder-plus",
      "label": "Folder Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "add",
        "archive",
        "create",
        "directory",
        "document",
        "file",
        "new",
        "positive"
      ],
      "unicode": "f65e"
    },
    {
      "name": "folder-tree",
      "label": "Folder Tree",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "archive",
        "directory",
        "document",
        "file",
        "search",
        "structure"
      ],
      "unicode": "f802"
    },
    {
      "name": "font",
      "label": "Font",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "alphabet",
        "glyph",
        "text",
        "type",
        "typeface"
      ],
      "unicode": "f031"
    },
    {
      "name": "font-awesome",
      "label": "Font Awesome",
      "styles": [
        "solid",
        "regular",
        "brands"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "awesome",
        "flag",
        "font",
        "icons",
        "typeface"
      ],
      "unicode": "f2b4"
    },
    {
      "name": "fonticons",
      "label": "Fonticons",
      "styles": [
        "brands"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [],
      "unicode": "f280"
    },
    {
      "name": "fonticons-fi",
      "label": "Fonticons Fi",
      "styles": [
        "brands"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [],
      "unicode": "f3a2"
    },
    {
      "name": "football",
      "label": "Football",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "american",
        "american football",
        "ball",
        "fall",
        "football",
        "nfl",
        "pigskin",
        "seasonal"
      ],
      "unicode": "f44e"
    },
    {
      "name": "fort-awesome",
      "label": "Fort Awesome",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "castle"
      ],
      "unicode": "f286"
    },
    {
      "name": "fort-awesome-alt",
      "label": "Alternate Fort Awesome",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "castle"
      ],
      "unicode": "f3a3"
    },
    {
      "name": "forumbee",
      "label": "Forumbee",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f211"
    },
    {
      "name": "forward",
      "label": "Forward",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "double",
        "fast",
        "fast-forward button",
        "forward",
        "next",
        "skip"
      ],
      "unicode": "f04e"
    },
    {
      "name": "forward-fast",
      "label": "Forward Fast",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts"
      ],
      "search": [
        "arrow",
        "end",
        "last",
        "next",
        "next scene",
        "next track",
        "next track button",
        "quick",
        "triangle"
      ],
      "unicode": "f050"
    },
    {
      "name": "forward-step",
      "label": "Forward Step",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "end",
        "last",
        "next"
      ],
      "unicode": "f051"
    },
    {
      "name": "foursquare",
      "label": "Foursquare",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f180"
    },
    {
      "name": "franc-sign",
      "label": "Franc Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "French Franc Sign",
        "currency"
      ],
      "unicode": "e18f"
    },
    {
      "name": "free-code-camp",
      "label": "freeCodeCamp",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2c5"
    },
    {
      "name": "freebsd",
      "label": "FreeBSD",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3a4"
    },
    {
      "name": "frog",
      "label": "Frog",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "amphibian",
        "bullfrog",
        "fauna",
        "hop",
        "kermit",
        "kiss",
        "prince",
        "ribbit",
        "toad",
        "wart"
      ],
      "unicode": "f52e"
    },
    {
      "name": "fulcrum",
      "label": "Fulcrum",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f50b"
    },
    {
      "name": "futbol",
      "label": "Futbol",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ball",
        "football",
        "mls",
        "soccer",
        "soccer ball"
      ],
      "unicode": "f1e3"
    },
    {
      "name": "g",
      "label": "G",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter G",
        "Latin Small Letter G",
        "letter"
      ],
      "unicode": "47"
    },
    {
      "name": "galactic-republic",
      "label": "Galactic Republic",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "politics",
        "star wars"
      ],
      "unicode": "f50c"
    },
    {
      "name": "galactic-senate",
      "label": "Galactic Senate",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "star wars"
      ],
      "unicode": "f50d"
    },
    {
      "name": "gamepad",
      "label": "Gamepad",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media",
        "Shopping"
      ],
      "search": [
        "arcade",
        "controller",
        "d-pad",
        "joystick",
        "playstore",
        "video",
        "video game"
      ],
      "unicode": "f11b"
    },
    {
      "name": "gas-pump",
      "label": "Gas Pump",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "car",
        "diesel",
        "fuel",
        "fuel pump",
        "fuelpump",
        "gas",
        "gasoline",
        "petrol",
        "pump",
        "station"
      ],
      "unicode": "f52f"
    },
    {
      "name": "gauge",
      "label": "Gauge",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "dashboard",
        "fast",
        "odometer",
        "speed",
        "speedometer"
      ],
      "unicode": "f624"
    },
    {
      "name": "gauge-high",
      "label": "Gauge High",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "dashboard",
        "fast",
        "odometer",
        "quick",
        "speed",
        "speedometer"
      ],
      "unicode": "f625"
    },
    {
      "name": "gauge-simple",
      "label": "Gauge Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "dashboard",
        "fast",
        "odometer",
        "speed",
        "speedometer"
      ],
      "unicode": "f629"
    },
    {
      "name": "gauge-simple-high",
      "label": "Gauge Simple High",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "dashboard",
        "fast",
        "odometer",
        "quick",
        "speed",
        "speedometer"
      ],
      "unicode": "f62a"
    },
    {
      "name": "gavel",
      "label": "Gavel",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "hammer",
        "judge",
        "law",
        "lawyer",
        "opinion"
      ],
      "unicode": "f0e3"
    },
    {
      "name": "gear",
      "label": "Gear",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "cog",
        "cogwheel",
        "configuration",
        "gear",
        "mechanical",
        "modify",
        "settings",
        "sprocket",
        "tool",
        "wheel"
      ],
      "unicode": "f013"
    },
    {
      "name": "gears",
      "label": "Gears",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "configuration",
        "gears",
        "mechanical",
        "modify",
        "settings",
        "sprocket",
        "wheel"
      ],
      "unicode": "f085"
    },
    {
      "name": "gem",
      "label": "Gem",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "diamond",
        "gem",
        "gem stone",
        "jewel",
        "jewelry",
        "sapphire",
        "stone",
        "treasure"
      ],
      "unicode": "f3a5"
    },
    {
      "name": "genderless",
      "label": "Genderless",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "androgynous",
        "asexual",
        "gender",
        "sexless"
      ],
      "unicode": "f22d"
    },
    {
      "name": "get-pocket",
      "label": "Get Pocket",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f265"
    },
    {
      "name": "gg",
      "label": "GG Currency",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f260"
    },
    {
      "name": "gg-circle",
      "label": "GG Currency Circle",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f261"
    },
    {
      "name": "ghost",
      "label": "Ghost",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "apparition",
        "blinky",
        "clyde",
        "creature",
        "face",
        "fairy tale",
        "fantasy",
        "floating",
        "ghost",
        "halloween",
        "holiday",
        "inky",
        "monster",
        "pacman",
        "pinky",
        "spirit"
      ],
      "unicode": "f6e2"
    },
    {
      "name": "gift",
      "label": "Gift",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "box",
        "celebration",
        "christmas",
        "generosity",
        "gift",
        "giving",
        "holiday",
        "party",
        "present",
        "wrapped",
        "wrapped gift",
        "xmas"
      ],
      "unicode": "f06b"
    },
    {
      "name": "gifts",
      "label": "Gifts",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "christmas",
        "generosity",
        "giving",
        "holiday",
        "party",
        "present",
        "wrapped",
        "xmas"
      ],
      "unicode": "f79c"
    },
    {
      "name": "git",
      "label": "Git",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d3"
    },
    {
      "name": "git-alt",
      "label": "Git Alt",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f841"
    },
    {
      "name": "github",
      "label": "GitHub",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "octocat"
      ],
      "unicode": "f09b"
    },
    {
      "name": "github-alt",
      "label": "Alternate GitHub",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "octocat"
      ],
      "unicode": "f113"
    },
    {
      "name": "gitkraken",
      "label": "GitKraken",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3a6"
    },
    {
      "name": "gitlab",
      "label": "GitLab",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Axosoft"
      ],
      "unicode": "f296"
    },
    {
      "name": "gitter",
      "label": "Gitter",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f426"
    },
    {
      "name": "glass-water",
      "label": "Glass Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "potable",
        "water"
      ],
      "unicode": "e4f4"
    },
    {
      "name": "glass-water-droplet",
      "label": "Glass Water Droplet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "potable",
        "water"
      ],
      "unicode": "e4f5"
    },
    {
      "name": "glasses",
      "label": "Glasses",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "hipster",
        "nerd",
        "reading",
        "sight",
        "spectacles",
        "vision"
      ],
      "unicode": "f530"
    },
    {
      "name": "glide",
      "label": "Glide",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2a5"
    },
    {
      "name": "glide-g",
      "label": "Glide G",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2a6"
    },
    {
      "name": "globe",
      "label": "Globe",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "all",
        "coordinates",
        "country",
        "earth",
        "global",
        "globe",
        "globe with meridians",
        "gps",
        "internet",
        "language",
        "localize",
        "location",
        "map",
        "meridians",
        "network",
        "online",
        "place",
        "planet",
        "translate",
        "travel",
        "world",
        "www"
      ],
      "unicode": "f0ac"
    },
    {
      "name": "gofore",
      "label": "Gofore",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3a7"
    },
    {
      "name": "golang",
      "label": "Go",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e40f"
    },
    {
      "name": "golf-ball-tee",
      "label": "Golf Ball Tee",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "caddy",
        "eagle",
        "putt",
        "tee"
      ],
      "unicode": "f450"
    },
    {
      "name": "goodreads",
      "label": "Goodreads",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3a8"
    },
    {
      "name": "goodreads-g",
      "label": "Goodreads G",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3a9"
    },
    {
      "name": "google",
      "label": "Google Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f1a0"
    },
    {
      "name": "google-drive",
      "label": "Google Drive",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f3aa"
    },
    {
      "name": "google-pay",
      "label": "Google Pay",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "e079"
    },
    {
      "name": "google-play",
      "label": "Google Play",
      "styles": [
        "brands"
      ],
      "categories": [
        "Media",
        "Social & Brands",
        "Shopping"
      ],
      "search": [
        "playstore"
      ],
      "unicode": "f3ab"
    },
    {
      "name": "google-plus",
      "label": "Google Plus",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Actions",
        "Social & Brands"
      ],
      "search": [
        "google-plus-circle",
        "google-plus-official"
      ],
      "unicode": "f2b3"
    },
    {
      "name": "google-plus-g",
      "label": "Google Plus G",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions",
        "Social & Brands"
      ],
      "search": [
        "google-plus",
        "social network"
      ],
      "unicode": "f0d5"
    },
    {
      "name": "google-scholar",
      "label": "Google Scholar",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "e63b"
    },
    {
      "name": "google-wallet",
      "label": "Google Wallet",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f1ee"
    },
    {
      "name": "gopuram",
      "label": "Gopuram",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "entrance",
        "hinduism",
        "temple",
        "tower"
      ],
      "unicode": "f664"
    },
    {
      "name": "graduation-cap",
      "label": "Graduation Cap",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cap",
        "celebration",
        "ceremony",
        "clothing",
        "college",
        "graduate",
        "graduation",
        "graduation cap",
        "hat",
        "learning",
        "school",
        "student"
      ],
      "unicode": "f19d"
    },
    {
      "name": "gratipay",
      "label": "Gratipay (Gittip)",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "favorite",
        "heart",
        "like",
        "love"
      ],
      "unicode": "f184"
    },
    {
      "name": "grav",
      "label": "Grav",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2d6"
    },
    {
      "name": "greater-than",
      "label": "Greater Than",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Greater-Than Sign",
        "arithmetic",
        "compare",
        "math"
      ],
      "unicode": "3e"
    },
    {
      "name": "greater-than-equal",
      "label": "Greater Than Equal",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "arithmetic",
        "compare",
        "math"
      ],
      "unicode": "f532"
    },
    {
      "name": "grip",
      "label": "Grip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "affordance",
        "drag",
        "drop",
        "grab",
        "handle"
      ],
      "unicode": "f58d"
    },
    {
      "name": "grip-lines",
      "label": "Grip Lines",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "affordance",
        "drag",
        "drop",
        "grab",
        "handle"
      ],
      "unicode": "f7a4"
    },
    {
      "name": "grip-lines-vertical",
      "label": "Grip Lines Vertical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "affordance",
        "drag",
        "drop",
        "grab",
        "handle"
      ],
      "unicode": "f7a5"
    },
    {
      "name": "grip-vertical",
      "label": "Grip Vertical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "affordance",
        "drag",
        "drop",
        "grab",
        "handle"
      ],
      "unicode": "f58e"
    },
    {
      "name": "gripfire",
      "label": "Gripfire, Inc.",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3ac"
    },
    {
      "name": "group-arrows-rotate",
      "label": "Group Arrows Rotate",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "community",
        "engagement",
        "spin",
        "sync"
      ],
      "unicode": "e4f6"
    },
    {
      "name": "grunt",
      "label": "Grunt",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3ad"
    },
    {
      "name": "guarani-sign",
      "label": "Guarani Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Guarani Sign",
        "currency"
      ],
      "unicode": "e19a"
    },
    {
      "name": "guilded",
      "label": "Guilded",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e07e"
    },
    {
      "name": "guitar",
      "label": "Guitar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "acoustic",
        "instrument",
        "music",
        "rock",
        "rock and roll",
        "song",
        "strings"
      ],
      "unicode": "f7a6"
    },
    {
      "name": "gulp",
      "label": "Gulp",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3ae"
    },
    {
      "name": "gun",
      "label": "Gun",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "firearm",
        "pistol",
        "weapon"
      ],
      "unicode": "e19b"
    },
    {
      "name": "h",
      "label": "H",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter H",
        "Latin Small Letter H",
        "letter"
      ],
      "unicode": "48"
    },
    {
      "name": "hacker-news",
      "label": "Hacker News",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d4"
    },
    {
      "name": "hackerrank",
      "label": "Hackerrank",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5f7"
    },
    {
      "name": "hammer",
      "label": "Hammer",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "admin",
        "configuration",
        "equipment",
        "fix",
        "hammer",
        "maintenance",
        "modify",
        "recovery",
        "repair",
        "settings",
        "tool"
      ],
      "unicode": "f6e3"
    },
    {
      "name": "hamsa",
      "label": "Hamsa",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "amulet",
        "christianity",
        "islam",
        "jewish",
        "judaism",
        "muslim",
        "protection"
      ],
      "unicode": "f665"
    },
    {
      "name": "hand",
      "label": "Hand",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "Raised Hand",
        "backhand",
        "game",
        "halt",
        "palm",
        "raised",
        "raised back of hand",
        "request",
        "roshambo",
        "stop"
      ],
      "unicode": "f256"
    },
    {
      "name": "hand-back-fist",
      "label": "Hand Back Fist",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "fist",
        "game",
        "roshambo"
      ],
      "unicode": "f255"
    },
    {
      "name": "hand-dots",
      "label": "Hand Dots",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "allergy",
        "freckles",
        "hand",
        "hives",
        "palm",
        "pox",
        "skin",
        "spots"
      ],
      "unicode": "f461"
    },
    {
      "name": "hand-fist",
      "label": "Hand Fist",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "clenched",
        "d&d",
        "dnd",
        "fantasy",
        "fist",
        "hand",
        "ki",
        "monk",
        "punch",
        "raised fist",
        "resist",
        "strength",
        "unarmed combat"
      ],
      "unicode": "f6de"
    },
    {
      "name": "hand-holding",
      "label": "Hand Holding",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "carry",
        "lift"
      ],
      "unicode": "f4bd"
    },
    {
      "name": "hand-holding-dollar",
      "label": "Hand Holding Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Transportation"
      ],
      "search": [
        "$",
        "carry",
        "coupon",
        "dollar sign",
        "donate",
        "donation",
        "giving",
        "investment",
        "lift",
        "money",
        "premium",
        "price",
        "revenue",
        "salary"
      ],
      "unicode": "f4c0"
    },
    {
      "name": "hand-holding-droplet",
      "label": "Hand Holding Droplet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "blood",
        "carry",
        "covid-19",
        "drought",
        "grow",
        "lift",
        "sanitation"
      ],
      "unicode": "f4c1"
    },
    {
      "name": "hand-holding-hand",
      "label": "Hand Holding Hand",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "care",
        "give",
        "help",
        "hold",
        "protect"
      ],
      "unicode": "e4f7"
    },
    {
      "name": "hand-holding-heart",
      "label": "Hand Holding Heart",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting",
        "Transportation"
      ],
      "search": [
        "carry",
        "charity",
        "gift",
        "lift",
        "package",
        "wishlist"
      ],
      "unicode": "f4be"
    },
    {
      "name": "hand-holding-medical",
      "label": "Hand Holding Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "care",
        "covid-19",
        "donate",
        "help"
      ],
      "unicode": "e05c"
    },
    {
      "name": "hand-lizard",
      "label": "Hand Lizard",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "game",
        "roshambo"
      ],
      "unicode": "f258"
    },
    {
      "name": "hand-middle-finger",
      "label": "Hand Middle Finger",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "finger",
        "flip the bird",
        "gesture",
        "hand",
        "hate",
        "middle finger",
        "rude"
      ],
      "unicode": "f806"
    },
    {
      "name": "hand-peace",
      "label": "Hand Peace",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "hand",
        "rest",
        "truce",
        "v",
        "victory",
        "victory hand"
      ],
      "unicode": "f25b"
    },
    {
      "name": "hand-point-down",
      "label": "Hand Point Down",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "finger",
        "hand-o-down",
        "point"
      ],
      "unicode": "f0a7"
    },
    {
      "name": "hand-point-left",
      "label": "Hand Point Left",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "back",
        "finger",
        "hand-o-left",
        "left",
        "point",
        "previous"
      ],
      "unicode": "f0a5"
    },
    {
      "name": "hand-point-right",
      "label": "Hand Point Right",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "finger",
        "forward",
        "hand-o-right",
        "next",
        "point",
        "right"
      ],
      "unicode": "f0a4"
    },
    {
      "name": "hand-point-up",
      "label": "Hand Point Up",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "finger",
        "hand",
        "hand-o-up",
        "index",
        "index pointing up",
        "point",
        "request",
        "up",
        "upgrade"
      ],
      "unicode": "f0a6"
    },
    {
      "name": "hand-pointer",
      "label": "Hand Pointer",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "cursor",
        "select"
      ],
      "unicode": "f25a"
    },
    {
      "name": "hand-scissors",
      "label": "Hand Scissors",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cut",
        "game",
        "roshambo"
      ],
      "unicode": "f257"
    },
    {
      "name": "hand-sparkles",
      "label": "Hand Sparkles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clean",
        "covid-19",
        "hygiene",
        "magic",
        "palm",
        "soap",
        "wash"
      ],
      "unicode": "e05d"
    },
    {
      "name": "hand-spock",
      "label": "Hand Spock",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "finger",
        "hand",
        "live long",
        "palm",
        "prosper",
        "salute",
        "spock",
        "star trek",
        "vulcan",
        "vulcan salute"
      ],
      "unicode": "f259"
    },
    {
      "name": "handcuffs",
      "label": "Handcuffs",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "arrest",
        "criminal",
        "handcuffs",
        "jail",
        "lock",
        "police",
        "wrist"
      ],
      "unicode": "e4f8"
    },
    {
      "name": "hands",
      "label": "Hands",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Translate",
        "asl",
        "deaf",
        "hands"
      ],
      "unicode": "f2a7"
    },
    {
      "name": "hands-asl-interpreting",
      "label": "Hands Asl Interpreting",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "asl",
        "deaf",
        "finger",
        "hand",
        "interpret",
        "speak"
      ],
      "unicode": "f2a3"
    },
    {
      "name": "hands-bound",
      "label": "Hands Bound",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "abduction",
        "bound",
        "handcuff",
        "wrist"
      ],
      "unicode": "e4f9"
    },
    {
      "name": "hands-bubbles",
      "label": "Hands Bubbles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "covid-19",
        "hygiene",
        "soap",
        "wash"
      ],
      "unicode": "e05e"
    },
    {
      "name": "hands-clapping",
      "label": "Hands Clapping",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "applause",
        "clap",
        "clapping hands",
        "hand"
      ],
      "unicode": "e1a8"
    },
    {
      "name": "hands-holding",
      "label": "Hands Holding",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "carry",
        "hold",
        "lift"
      ],
      "unicode": "f4c2"
    },
    {
      "name": "hands-holding-child",
      "label": "Hands Holding Child",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "care",
        "give",
        "help",
        "hold",
        "parent",
        "protect"
      ],
      "unicode": "e4fa"
    },
    {
      "name": "hands-holding-circle",
      "label": "Hands Holding Circle",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "circle",
        "gift",
        "protection"
      ],
      "unicode": "e4fb"
    },
    {
      "name": "hands-praying",
      "label": "Hands Praying",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "kneel",
        "preach",
        "religion",
        "worship"
      ],
      "unicode": "f684"
    },
    {
      "name": "handshake",
      "label": "Handshake",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "agreement",
        "greeting",
        "meeting",
        "partnership"
      ],
      "unicode": "f2b5"
    },
    {
      "name": "handshake-angle",
      "label": "Handshake Angle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "aid",
        "assistance",
        "handshake",
        "partnership",
        "volunteering"
      ],
      "unicode": "f4c4"
    },
    {
      "name": "handshake-simple",
      "label": "Handshake Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "agreement",
        "greeting",
        "hand",
        "handshake",
        "meeting",
        "partnership",
        "shake"
      ],
      "unicode": "f4c6"
    },
    {
      "name": "handshake-simple-slash",
      "label": "Handshake Simple Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "broken",
        "covid-19",
        "disabled",
        "social distance"
      ],
      "unicode": "e05f"
    },
    {
      "name": "handshake-slash",
      "label": "Handshake Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "broken",
        "covid-19",
        "disabled",
        "social distance"
      ],
      "unicode": "e060"
    },
    {
      "name": "hanukiah",
      "label": "Hanukiah",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "candelabrum",
        "candle",
        "candlestick",
        "hanukkah",
        "jewish",
        "judaism",
        "light",
        "menorah",
        "religion"
      ],
      "unicode": "f6e6"
    },
    {
      "name": "hard-drive",
      "label": "Hard Drive",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "Hard Disk",
        "cpu",
        "hard drive",
        "harddrive",
        "machine",
        "save",
        "storage"
      ],
      "unicode": "f0a0"
    },
    {
      "name": "hashnode",
      "label": "Hashnode",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e499"
    },
    {
      "name": "hashtag",
      "label": "Hashtag",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands",
        "Shopping"
      ],
      "search": [
        "Number Sign",
        "Twitter",
        "instagram",
        "pound",
        "social media",
        "tag"
      ],
      "unicode": "23"
    },
    {
      "name": "hat-cowboy",
      "label": "Hat Cowboy",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "buckaroo",
        "horse",
        "jackeroo",
        "john b.",
        "old west",
        "pardner",
        "ranch",
        "rancher",
        "rodeo",
        "western",
        "wrangler"
      ],
      "unicode": "f8c0"
    },
    {
      "name": "hat-cowboy-side",
      "label": "Hat Cowboy Side",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "buckaroo",
        "horse",
        "jackeroo",
        "john b.",
        "old west",
        "pardner",
        "ranch",
        "rancher",
        "rodeo",
        "western",
        "wrangler"
      ],
      "unicode": "f8c1"
    },
    {
      "name": "hat-wizard",
      "label": "Hat Wizard",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "accessory",
        "buckle",
        "clothing",
        "d&d",
        "dnd",
        "fantasy",
        "halloween",
        "head",
        "holiday",
        "mage",
        "magic",
        "pointy",
        "witch"
      ],
      "unicode": "f6e8"
    },
    {
      "name": "head-side-cough",
      "label": "Head Side Cough",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cough",
        "covid-19",
        "germs",
        "lungs",
        "respiratory",
        "sick",
        "uer"
      ],
      "unicode": "e061"
    },
    {
      "name": "head-side-cough-slash",
      "label": "Head Side Cough Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cough",
        "covid-19",
        "disabled",
        "germs",
        "lungs",
        "respiratory",
        "sick",
        "uer"
      ],
      "unicode": "e062"
    },
    {
      "name": "head-side-mask",
      "label": "Head Side Mask",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "breath",
        "coronavirus",
        "covid-19",
        "filter",
        "flu",
        "infection",
        "pandemic",
        "respirator",
        "uer",
        "virus"
      ],
      "unicode": "e063"
    },
    {
      "name": "head-side-virus",
      "label": "Head Side Virus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cold",
        "coronavirus",
        "covid-19",
        "flu",
        "infection",
        "pandemic",
        "sick",
        "uer"
      ],
      "unicode": "e064"
    },
    {
      "name": "heading",
      "label": "Heading",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "format",
        "header",
        "text",
        "title"
      ],
      "unicode": "f1dc"
    },
    {
      "name": "headphones",
      "label": "Headphones",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Media",
        "Text & Formatting"
      ],
      "search": [
        "audio",
        "earbud",
        "headphone",
        "listen",
        "music",
        "sound",
        "speaker"
      ],
      "unicode": "f025"
    },
    {
      "name": "headphones-simple",
      "label": "Headphones Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Media",
        "Text & Formatting"
      ],
      "search": [
        "audio",
        "listen",
        "music",
        "sound",
        "speaker"
      ],
      "unicode": "f58f"
    },
    {
      "name": "headset",
      "label": "Headset",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "audio",
        "gamer",
        "gaming",
        "listen",
        "live chat",
        "microphone",
        "shot caller",
        "sound",
        "support",
        "telemarketer"
      ],
      "unicode": "f590"
    },
    {
      "name": "heart",
      "label": "Heart",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting",
        "Transportation"
      ],
      "search": [
        "ace",
        "black",
        "black heart",
        "blue",
        "blue heart",
        "brown",
        "brown heart",
        "card",
        "evil",
        "favorite",
        "game",
        "green",
        "green heart",
        "heart",
        "heart suit",
        "like",
        "love",
        "orange",
        "orange heart",
        "purple",
        "purple heart",
        "red heart",
        "relationship",
        "valentine",
        "white",
        "white heart",
        "wicked",
        "wishlist",
        "yellow",
        "yellow heart"
      ],
      "unicode": "f004"
    },
    {
      "name": "heart-circle-bolt",
      "label": "Heart Circle Bolt",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation",
        "Weather"
      ],
      "search": [
        "cardiogram",
        "ekg",
        "electric",
        "heart",
        "love",
        "pacemaker"
      ],
      "unicode": "e4fc"
    },
    {
      "name": "heart-circle-check",
      "label": "Heart Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "enable",
        "favorite",
        "heart",
        "love",
        "not affected",
        "ok",
        "okay",
        "validate",
        "working"
      ],
      "unicode": "e4fd"
    },
    {
      "name": "heart-circle-exclamation",
      "label": "Heart Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "failed",
        "favorite",
        "heart",
        "love"
      ],
      "unicode": "e4fe"
    },
    {
      "name": "heart-circle-minus",
      "label": "Heart Circle Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "favorite",
        "heart",
        "love"
      ],
      "unicode": "e4ff"
    },
    {
      "name": "heart-circle-plus",
      "label": "Heart Circle Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "favorite",
        "heart",
        "love"
      ],
      "unicode": "e500"
    },
    {
      "name": "heart-circle-xmark",
      "label": "Heart Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "favorite",
        "heart",
        "love",
        "uncheck"
      ],
      "unicode": "e501"
    },
    {
      "name": "heart-crack",
      "label": "Heart Crack",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "break",
        "breakup",
        "broken",
        "broken heart",
        "crushed",
        "dislike",
        "dumped",
        "grief",
        "love",
        "lovesick",
        "relationship",
        "sad"
      ],
      "unicode": "f7a9"
    },
    {
      "name": "heart-pulse",
      "label": "Heart Pulse",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "ekg",
        "electrocardiogram",
        "health",
        "lifeline",
        "vital signs"
      ],
      "unicode": "f21e"
    },
    {
      "name": "helicopter",
      "label": "Helicopter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "airwolf",
        "apache",
        "chopper",
        "flight",
        "fly",
        "helicopter",
        "travel",
        "vehicle"
      ],
      "unicode": "f533"
    },
    {
      "name": "helicopter-symbol",
      "label": "Helicopter Symbol",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "chopper",
        "helicopter",
        "landing pad",
        "whirlybird"
      ],
      "unicode": "e502"
    },
    {
      "name": "helmet-safety",
      "label": "Helmet Safety",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "construction",
        "hardhat",
        "helmet",
        "maintenance",
        "safety"
      ],
      "unicode": "f807"
    },
    {
      "name": "helmet-un",
      "label": "Helmet Un",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "helmet",
        "united nations"
      ],
      "unicode": "e503"
    },
    {
      "name": "hexagon-nodes",
      "label": "Hexagon Nodes",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "action",
        "ai",
        "artificial intelligence",
        "cluster",
        "graph",
        "language",
        "llm",
        "model",
        "network",
        "neuronal"
      ],
      "unicode": "e699"
    },
    {
      "name": "hexagon-nodes-bolt",
      "label": "Hexagon Nodes Bolt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Weather"
      ],
      "search": [
        "LLM",
        "action",
        "ai",
        "artificial intelligence",
        "cluster",
        "graph",
        "language",
        "llm",
        "model",
        "network",
        "neuronal"
      ],
      "unicode": "e69a"
    },
    {
      "name": "highlighter",
      "label": "Highlighter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "edit",
        "marker",
        "modify",
        "sharpie",
        "update",
        "write"
      ],
      "unicode": "f591"
    },
    {
      "name": "hill-avalanche",
      "label": "Hill Avalanche",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "mudslide",
        "snow",
        "winter"
      ],
      "unicode": "e507"
    },
    {
      "name": "hill-rockslide",
      "label": "Hill Rockslide",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "mudslide"
      ],
      "unicode": "e508"
    },
    {
      "name": "hippo",
      "label": "Hippo",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "animal",
        "fauna",
        "hippo",
        "hippopotamus",
        "hungry",
        "mammal"
      ],
      "unicode": "f6ed"
    },
    {
      "name": "hips",
      "label": "Hips",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f452"
    },
    {
      "name": "hire-a-helper",
      "label": "HireAHelper",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b0"
    },
    {
      "name": "hive",
      "label": "Hive Blockchain Network",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e07f"
    },
    {
      "name": "hockey-puck",
      "label": "Hockey Puck",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "ice",
        "nhl",
        "sport"
      ],
      "unicode": "f453"
    },
    {
      "name": "holly-berry",
      "label": "Holly Berry",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "catwoman",
        "christmas",
        "decoration",
        "flora",
        "halle",
        "holiday",
        "ororo munroe",
        "plant",
        "storm",
        "xmas"
      ],
      "unicode": "f7aa"
    },
    {
      "name": "hooli",
      "label": "Hooli",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f427"
    },
    {
      "name": "hornbill",
      "label": "Hornbill",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f592"
    },
    {
      "name": "horse",
      "label": "Horse",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "equestrian",
        "equus",
        "fauna",
        "horse",
        "mammmal",
        "mare",
        "neigh",
        "pony",
        "racehorse",
        "racing"
      ],
      "unicode": "f6f0"
    },
    {
      "name": "horse-head",
      "label": "Horse Head",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "equus",
        "fauna",
        "mammmal",
        "mare",
        "neigh",
        "pony"
      ],
      "unicode": "f7ab"
    },
    {
      "name": "hospital",
      "label": "Hospital",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "covid-19",
        "doctor",
        "emergency room",
        "hospital",
        "medical center",
        "medicine"
      ],
      "unicode": "f0f8"
    },
    {
      "name": "hospital-user",
      "label": "Hospital User",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "covid-19",
        "doctor",
        "network",
        "patient",
        "primary care",
        "uer"
      ],
      "unicode": "f80d"
    },
    {
      "name": "hot-tub-person",
      "label": "Hot Tub Person",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "jacuzzi",
        "spa",
        "uer"
      ],
      "unicode": "f593"
    },
    {
      "name": "hotdog",
      "label": "Hotdog",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bun",
        "chili",
        "frankfurt",
        "frankfurter",
        "hot dog",
        "hotdog",
        "kosher",
        "polish",
        "sandwich",
        "sausage",
        "vienna",
        "weiner"
      ],
      "unicode": "f80f"
    },
    {
      "name": "hotel",
      "label": "Hotel",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "hotel",
        "inn",
        "lodging",
        "motel",
        "resort",
        "travel"
      ],
      "unicode": "f594"
    },
    {
      "name": "hotjar",
      "label": "Hotjar",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b1"
    },
    {
      "name": "hourglass",
      "label": "Hourglass",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media",
        "Business"
      ],
      "search": [
        "hour",
        "hourglass",
        "hourglass not done",
        "minute",
        "sand",
        "stopwatch",
        "time",
        "timer"
      ],
      "unicode": "f254"
    },
    {
      "name": "hourglass-end",
      "label": "Hourglass End",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Media",
        "Business"
      ],
      "search": [
        "hour",
        "hourglass done",
        "minute",
        "pending",
        "sand",
        "stopwatch",
        "time",
        "timer",
        "waiting"
      ],
      "unicode": "f253"
    },
    {
      "name": "hourglass-half",
      "label": "Hourglass Half",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Media",
        "Business"
      ],
      "search": [
        "hour",
        "minute",
        "pending",
        "sand",
        "stopwatch",
        "time",
        "waiting"
      ],
      "unicode": "f252"
    },
    {
      "name": "hourglass-start",
      "label": "Hourglass Start",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Media",
        "Business"
      ],
      "search": [
        "hour",
        "minute",
        "sand",
        "stopwatch",
        "time",
        "waiting"
      ],
      "unicode": "f251"
    },
    {
      "name": "house",
      "label": "House",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "abode",
        "building",
        "home",
        "house",
        "main",
        "residence"
      ],
      "unicode": "f015"
    },
    {
      "name": "house-chimney",
      "label": "House Chimney",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "abode",
        "building",
        "chimney",
        "house",
        "main",
        "residence",
        "smokestack"
      ],
      "unicode": "e3af"
    },
    {
      "name": "house-chimney-crack",
      "label": "House Chimney Crack",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "building",
        "devastation",
        "disaster",
        "earthquake",
        "home",
        "insurance"
      ],
      "unicode": "f6f1"
    },
    {
      "name": "house-chimney-medical",
      "label": "House Chimney Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "covid-19",
        "doctor",
        "general practitioner",
        "hospital",
        "infirmary",
        "medicine",
        "office",
        "outpatient"
      ],
      "unicode": "f7f2"
    },
    {
      "name": "house-chimney-user",
      "label": "House Chimney User",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "covid-19",
        "home",
        "isolation",
        "quarantine",
        "uer"
      ],
      "unicode": "e065"
    },
    {
      "name": "house-chimney-window",
      "label": "House Chimney Window",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business",
        "Weather"
      ],
      "search": [
        "abode",
        "building",
        "family",
        "home",
        "residence"
      ],
      "unicode": "e00d"
    },
    {
      "name": "house-circle-check",
      "label": "House Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "abode",
        "enable",
        "home",
        "house",
        "not affected",
        "ok",
        "okay",
        "validate",
        "working"
      ],
      "unicode": "e509"
    },
    {
      "name": "house-circle-exclamation",
      "label": "House Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "abode",
        "affected",
        "failed",
        "home",
        "house"
      ],
      "unicode": "e50a"
    },
    {
      "name": "house-circle-xmark",
      "label": "House Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "abode",
        "destroy",
        "home",
        "house",
        "uncheck"
      ],
      "unicode": "e50b"
    },
    {
      "name": "house-crack",
      "label": "House Crack",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "building",
        "devastation",
        "disaster",
        "earthquake",
        "home",
        "insurance"
      ],
      "unicode": "e3b1"
    },
    {
      "name": "house-fire",
      "label": "House Fire",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "burn",
        "emergency",
        "home"
      ],
      "unicode": "e50c"
    },
    {
      "name": "house-flag",
      "label": "House Flag",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "camp",
        "home"
      ],
      "unicode": "e50d"
    },
    {
      "name": "house-flood-water",
      "label": "House Flood Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "damage",
        "flood",
        "water"
      ],
      "unicode": "e50e"
    },
    {
      "name": "house-flood-water-circle-arrow-right",
      "label": "House Flood Water Circle Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "damage",
        "flood",
        "water"
      ],
      "unicode": "e50f"
    },
    {
      "name": "house-laptop",
      "label": "House Laptop",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "computer",
        "covid-19",
        "device",
        "office",
        "remote",
        "work from home"
      ],
      "unicode": "e066"
    },
    {
      "name": "house-lock",
      "label": "House Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "closed",
        "home",
        "house",
        "lockdown",
        "padlock",
        "privacy",
        "quarantine"
      ],
      "unicode": "e510"
    },
    {
      "name": "house-medical",
      "label": "House Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "covid-19",
        "doctor",
        "facility",
        "general practitioner",
        "health",
        "hospital",
        "infirmary",
        "medicine",
        "office",
        "outpatient"
      ],
      "unicode": "e3b2"
    },
    {
      "name": "house-medical-circle-check",
      "label": "House Medical Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "clinic",
        "enable",
        "hospital",
        "not affected",
        "ok",
        "okay",
        "validate",
        "working"
      ],
      "unicode": "e511"
    },
    {
      "name": "house-medical-circle-exclamation",
      "label": "House Medical Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "clinic",
        "failed",
        "hospital"
      ],
      "unicode": "e512"
    },
    {
      "name": "house-medical-circle-xmark",
      "label": "House Medical Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "clinic",
        "destroy",
        "hospital",
        "uncheck"
      ],
      "unicode": "e513"
    },
    {
      "name": "house-medical-flag",
      "label": "House Medical Flag",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clinic",
        "hospital",
        "mash"
      ],
      "unicode": "e514"
    },
    {
      "name": "house-signal",
      "label": "House Signal",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "abode",
        "building",
        "connect",
        "family",
        "home",
        "residence",
        "smart home",
        "wifi",
        "www"
      ],
      "unicode": "e012"
    },
    {
      "name": "house-tsunami",
      "label": "House Tsunami",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "damage",
        "flood",
        "tidal wave",
        "wave"
      ],
      "unicode": "e515"
    },
    {
      "name": "house-user",
      "label": "House User",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "house",
        "uer"
      ],
      "unicode": "e1b0"
    },
    {
      "name": "houzz",
      "label": "Houzz",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f27c"
    },
    {
      "name": "hryvnia-sign",
      "label": "Hryvnia Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Hryvnia Sign",
        "currency"
      ],
      "unicode": "f6f2"
    },
    {
      "name": "html5",
      "label": "HTML 5 Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f13b"
    },
    {
      "name": "hubspot",
      "label": "HubSpot",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b2"
    },
    {
      "name": "hurricane",
      "label": "Hurricane",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "coriolis effect",
        "eye",
        "storm",
        "tropical cyclone",
        "typhoon"
      ],
      "unicode": "f751"
    },
    {
      "name": "i",
      "label": "I",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter I",
        "Latin Small Letter I",
        "letter"
      ],
      "unicode": "49"
    },
    {
      "name": "i-cursor",
      "label": "I Cursor",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "editing",
        "i-beam",
        "type",
        "writing"
      ],
      "unicode": "f246"
    },
    {
      "name": "ice-cream",
      "label": "Ice Cream",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "chocolate",
        "cone",
        "cream",
        "dessert",
        "frozen",
        "ice",
        "ice cream",
        "scoop",
        "sorbet",
        "sweet",
        "vanilla",
        "yogurt"
      ],
      "unicode": "f810"
    },
    {
      "name": "icicles",
      "label": "Icicles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cold",
        "frozen",
        "hanging",
        "ice",
        "seasonal",
        "sharp"
      ],
      "unicode": "f7ad"
    },
    {
      "name": "icons",
      "label": "Icons",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Media",
        "Weather"
      ],
      "search": [
        "bolt",
        "category",
        "emoji",
        "heart",
        "image",
        "music",
        "photo",
        "symbols"
      ],
      "unicode": "f86d"
    },
    {
      "name": "id-badge",
      "label": "Id Badge",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Files & Folders"
      ],
      "search": [
        "address",
        "contact",
        "identification",
        "license",
        "profile",
        "uer",
        "username"
      ],
      "unicode": "f2c1"
    },
    {
      "name": "id-card",
      "label": "Id Card",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Business",
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "contact",
        "demographics",
        "document",
        "identification",
        "issued",
        "profile",
        "registration",
        "uer",
        "username"
      ],
      "unicode": "f2c2"
    },
    {
      "name": "id-card-clip",
      "label": "Id Card Clip",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business",
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "contact",
        "demographics",
        "document",
        "identification",
        "issued",
        "profile",
        "uer",
        "username"
      ],
      "unicode": "f47f"
    },
    {
      "name": "ideal",
      "label": "iDeal",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e013"
    },
    {
      "name": "igloo",
      "label": "Igloo",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Weather"
      ],
      "search": [
        "dome",
        "dwelling",
        "eskimo",
        "home",
        "house",
        "ice",
        "snow"
      ],
      "unicode": "f7ae"
    },
    {
      "name": "image",
      "label": "Image",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "album",
        "img",
        "landscape",
        "photo",
        "picture"
      ],
      "unicode": "f03e"
    },
    {
      "name": "image-portrait",
      "label": "Image Portrait",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Media"
      ],
      "search": [
        "id",
        "image",
        "img",
        "photo",
        "picture",
        "selfie",
        "uer",
        "username"
      ],
      "unicode": "f3e0"
    },
    {
      "name": "images",
      "label": "Images",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "album",
        "img",
        "landscape",
        "photo",
        "picture"
      ],
      "unicode": "f302"
    },
    {
      "name": "imdb",
      "label": "IMDB",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2d8"
    },
    {
      "name": "inbox",
      "label": "Inbox",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Files & Folders"
      ],
      "search": [
        "archive",
        "desk",
        "email",
        "mail",
        "message"
      ],
      "unicode": "f01c"
    },
    {
      "name": "indent",
      "label": "Indent",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "align",
        "justify",
        "paragraph",
        "tab"
      ],
      "unicode": "f03c"
    },
    {
      "name": "indian-rupee-sign",
      "label": "Indian Rupee Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Indian Rupee Sign",
        "currency"
      ],
      "unicode": "e1bc"
    },
    {
      "name": "industry",
      "label": "Industry",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "factory",
        "industrial",
        "manufacturing",
        "mill",
        "warehouse"
      ],
      "unicode": "f275"
    },
    {
      "name": "infinity",
      "label": "Infinity",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Infinity",
        "eternity",
        "forever",
        "infinity",
        "math",
        "unbounded",
        "universal"
      ],
      "unicode": "f534"
    },
    {
      "name": "info",
      "label": "Info",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "details",
        "help",
        "information",
        "more",
        "support"
      ],
      "unicode": "f129"
    },
    {
      "name": "instagram",
      "label": "Instagram",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands",
        "Shopping"
      ],
      "search": [],
      "unicode": "f16d"
    },
    {
      "name": "instalod",
      "label": "InstaLOD",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e081"
    },
    {
      "name": "intercom",
      "label": "Intercom",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "app",
        "customer",
        "messenger"
      ],
      "unicode": "f7af"
    },
    {
      "name": "internet-explorer",
      "label": "Internet-explorer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "browser",
        "ie"
      ],
      "unicode": "f26b"
    },
    {
      "name": "invision",
      "label": "InVision",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "app",
        "design",
        "interface"
      ],
      "unicode": "f7b0"
    },
    {
      "name": "ioxhost",
      "label": "ioxhost",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f208"
    },
    {
      "name": "italic",
      "label": "Italic",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "edit",
        "emphasis",
        "font",
        "format",
        "text",
        "type"
      ],
      "unicode": "f033"
    },
    {
      "name": "itch-io",
      "label": "itch.io",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f83a"
    },
    {
      "name": "itunes",
      "label": "iTunes",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b4"
    },
    {
      "name": "itunes-note",
      "label": "Itunes Note",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b5"
    },
    {
      "name": "j",
      "label": "J",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter J",
        "Latin Small Letter J",
        "letter"
      ],
      "unicode": "4a"
    },
    {
      "name": "jar",
      "label": "Jar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "jam",
        "jelly",
        "storage"
      ],
      "unicode": "e516"
    },
    {
      "name": "jar-wheat",
      "label": "Jar Wheat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "flour",
        "storage"
      ],
      "unicode": "e517"
    },
    {
      "name": "java",
      "label": "Java",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4e4"
    },
    {
      "name": "jedi",
      "label": "Jedi",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "crest",
        "force",
        "sith",
        "skywalker",
        "star wars",
        "yoda"
      ],
      "unicode": "f669"
    },
    {
      "name": "jedi-order",
      "label": "Jedi Order",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "star wars"
      ],
      "unicode": "f50e"
    },
    {
      "name": "jenkins",
      "label": "Jenkis",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b6"
    },
    {
      "name": "jet-fighter",
      "label": "Jet Fighter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "airforce",
        "airplane",
        "airport",
        "fast",
        "fly",
        "goose",
        "marines",
        "maverick",
        "military",
        "plane",
        "quick",
        "top gun",
        "transportation",
        "travel"
      ],
      "unicode": "f0fb"
    },
    {
      "name": "jet-fighter-up",
      "label": "Jet Fighter Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "airforce",
        "airplane",
        "airport",
        "fast",
        "fly",
        "goose",
        "marines",
        "maverick",
        "military",
        "plane",
        "quick",
        "top gun",
        "transportation",
        "travel"
      ],
      "unicode": "e518"
    },
    {
      "name": "jira",
      "label": "Jira",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "atlassian"
      ],
      "unicode": "f7b1"
    },
    {
      "name": "joget",
      "label": "Joget",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b7"
    },
    {
      "name": "joint",
      "label": "Joint",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "blunt",
        "cannabis",
        "doobie",
        "drugs",
        "marijuana",
        "roach",
        "smoke",
        "smoking",
        "spliff"
      ],
      "unicode": "f595"
    },
    {
      "name": "joomla",
      "label": "Joomla Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1aa"
    },
    {
      "name": "js",
      "label": "JavaScript (JS)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3b8"
    },
    {
      "name": "jsfiddle",
      "label": "jsFiddle",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1cc"
    },
    {
      "name": "jug-detergent",
      "label": "Jug Detergent",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "detergent",
        "laundry",
        "soap",
        "wash"
      ],
      "unicode": "e519"
    },
    {
      "name": "jxl",
      "label": "JXL",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e67b"
    },
    {
      "name": "k",
      "label": "K",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter K",
        "Latin Small Letter K",
        "letter"
      ],
      "unicode": "4b"
    },
    {
      "name": "kaaba",
      "label": "Kaaba",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "Muslim",
        "building",
        "cube",
        "islam",
        "kaaba",
        "muslim",
        "religion"
      ],
      "unicode": "f66b"
    },
    {
      "name": "kaggle",
      "label": "Kaggle",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5fa"
    },
    {
      "name": "key",
      "label": "Key",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "key",
        "lock",
        "password",
        "private",
        "secret",
        "unlock"
      ],
      "unicode": "f084"
    },
    {
      "name": "keybase",
      "label": "Keybase",
      "styles": [
        "brands"
      ],
      "categories": [
        "Security"
      ],
      "search": [],
      "unicode": "f4f5"
    },
    {
      "name": "keyboard",
      "label": "Keyboard",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Text & Formatting",
        "Security"
      ],
      "search": [
        "accessory",
        "computer",
        "edit",
        "input",
        "keyboard",
        "text",
        "type",
        "write"
      ],
      "unicode": "f11c"
    },
    {
      "name": "keycdn",
      "label": "KeyCDN",
      "styles": [
        "brands"
      ],
      "categories": [
        "Security"
      ],
      "search": [],
      "unicode": "f3ba"
    },
    {
      "name": "khanda",
      "label": "Khanda",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Adi Shakti",
        "chakkar",
        "sikh",
        "sikhism",
        "sword"
      ],
      "unicode": "f66d"
    },
    {
      "name": "kickstarter",
      "label": "Kickstarter",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f3bb"
    },
    {
      "name": "kickstarter-k",
      "label": "Kickstarter K",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f3bc"
    },
    {
      "name": "kip-sign",
      "label": "Kip Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Kip Sign",
        "currency"
      ],
      "unicode": "e1c4"
    },
    {
      "name": "kit-medical",
      "label": "Kit Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "emergency",
        "emt",
        "health",
        "medical",
        "rescue"
      ],
      "unicode": "f479"
    },
    {
      "name": "kitchen-set",
      "label": "Kitchen Set",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "chef",
        "cook",
        "cup",
        "kitchen",
        "pan",
        "pot",
        "skillet"
      ],
      "unicode": "e51a"
    },
    {
      "name": "kiwi-bird",
      "label": "Kiwi Bird",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bird",
        "fauna",
        "new zealand"
      ],
      "unicode": "f535"
    },
    {
      "name": "korvue",
      "label": "KORVUE",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f42f"
    },
    {
      "name": "l",
      "label": "L",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter L",
        "Latin Small Letter L",
        "letter"
      ],
      "unicode": "4c"
    },
    {
      "name": "land-mine-on",
      "label": "Land Mine On",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bomb",
        "danger",
        "explosion",
        "war"
      ],
      "unicode": "e51b"
    },
    {
      "name": "landmark",
      "label": "Landmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "classical",
        "historic",
        "memorable",
        "monument",
        "museum",
        "politics",
        "society"
      ],
      "unicode": "f66f"
    },
    {
      "name": "landmark-dome",
      "label": "Landmark Dome",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "historic",
        "memorable",
        "monument",
        "politics"
      ],
      "unicode": "f752"
    },
    {
      "name": "landmark-flag",
      "label": "Landmark Flag",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "capitol",
        "flag",
        "landmark",
        "memorial"
      ],
      "unicode": "e51c"
    },
    {
      "name": "language",
      "label": "Language",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "dialect",
        "idiom",
        "localize",
        "speech",
        "translate",
        "vernacular"
      ],
      "unicode": "f1ab"
    },
    {
      "name": "laptop",
      "label": "Laptop",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "cpu",
        "dell",
        "demo",
        "device",
        "fabook",
        "fb",
        "laptop",
        "mac",
        "macbook",
        "machine",
        "pc",
        "personal"
      ],
      "unicode": "f109"
    },
    {
      "name": "laptop-code",
      "label": "Laptop Code",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "cpu",
        "dell",
        "demo",
        "develop",
        "device",
        "fabook",
        "fb",
        "mac",
        "macbook",
        "machine",
        "mysql",
        "pc",
        "sql"
      ],
      "unicode": "f5fc"
    },
    {
      "name": "laptop-file",
      "label": "Laptop File",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "computer",
        "education",
        "laptop",
        "learning",
        "remote work"
      ],
      "unicode": "e51d"
    },
    {
      "name": "laptop-medical",
      "label": "Laptop Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "device",
        "ehr",
        "electronic health records",
        "history"
      ],
      "unicode": "f812"
    },
    {
      "name": "laravel",
      "label": "Laravel",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3bd"
    },
    {
      "name": "lari-sign",
      "label": "Lari Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Lari Sign",
        "currency"
      ],
      "unicode": "e1c8"
    },
    {
      "name": "lastfm",
      "label": "last.fm",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f202"
    },
    {
      "name": "layer-group",
      "label": "Layer Group",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrange",
        "category",
        "develop",
        "layers",
        "map",
        "platform",
        "stack"
      ],
      "unicode": "f5fd"
    },
    {
      "name": "leaf",
      "label": "Leaf",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "eco",
        "flora",
        "nature",
        "plant",
        "vegan"
      ],
      "unicode": "f06c"
    },
    {
      "name": "leanpub",
      "label": "Leanpub",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f212"
    },
    {
      "name": "left-long",
      "label": "Left Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "back",
        "long-arrow-left",
        "previous"
      ],
      "unicode": "f30a"
    },
    {
      "name": "left-right",
      "label": "Left Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "arrows-h",
        "expand",
        "horizontal",
        "landscape",
        "left-right arrow",
        "resize",
        "wide"
      ],
      "unicode": "f337"
    },
    {
      "name": "lemon",
      "label": "Lemon",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "citrus",
        "fruit",
        "lemon",
        "lemonade",
        "lime",
        "tart"
      ],
      "unicode": "f094"
    },
    {
      "name": "less",
      "label": "Less",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f41d"
    },
    {
      "name": "less-than",
      "label": "Less Than",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Less-Than Sign",
        "arithmetic",
        "compare",
        "math"
      ],
      "unicode": "3c"
    },
    {
      "name": "less-than-equal",
      "label": "Less Than Equal",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "arithmetic",
        "compare",
        "math"
      ],
      "unicode": "f537"
    },
    {
      "name": "letterboxd",
      "label": "Letterboxd",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e62d"
    },
    {
      "name": "life-ring",
      "label": "Life Ring",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "coast guard",
        "help",
        "overboard",
        "save",
        "support"
      ],
      "unicode": "f1cd"
    },
    {
      "name": "lightbulb",
      "label": "Lightbulb",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bulb",
        "bulb",
        "comic",
        "comic",
        "electric",
        "electric",
        "energy",
        "idea",
        "idea",
        "innovation",
        "inspiration",
        "inspiration",
        "light",
        "light bulb",
        "mechanical"
      ],
      "unicode": "f0eb"
    },
    {
      "name": "line",
      "label": "Line",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3c0"
    },
    {
      "name": "lines-leaning",
      "label": "Lines Leaning",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "canted",
        "domino",
        "falling",
        "resilience",
        "resilient",
        "tipped"
      ],
      "unicode": "e51e"
    },
    {
      "name": "link",
      "label": "Link",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "attach",
        "attachment",
        "chain",
        "connect",
        "lin",
        "link"
      ],
      "unicode": "f0c1"
    },
    {
      "name": "link-slash",
      "label": "Link Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "attachment",
        "chain",
        "chain-broken",
        "disabled",
        "disconnect",
        "remove"
      ],
      "unicode": "f127"
    },
    {
      "name": "linkedin",
      "label": "LinkedIn",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands"
      ],
      "search": [
        "linkedin-square",
        "linkin"
      ],
      "unicode": "f08c"
    },
    {
      "name": "linkedin-in",
      "label": "LinkedIn In",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "linkedin",
        "linkin"
      ],
      "unicode": "f0e1"
    },
    {
      "name": "linode",
      "label": "Linode",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2b8"
    },
    {
      "name": "linux",
      "label": "Linux",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "tux"
      ],
      "unicode": "f17c"
    },
    {
      "name": "lira-sign",
      "label": "Lira Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Lira Sign",
        "currency"
      ],
      "unicode": "f195"
    },
    {
      "name": "list",
      "label": "List",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "bullet",
        "category",
        "cheatsheet",
        "checklist",
        "completed",
        "done",
        "finished",
        "ol",
        "summary",
        "todo",
        "ul"
      ],
      "unicode": "f03a"
    },
    {
      "name": "list-check",
      "label": "List Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "bullet",
        "cheatsheet",
        "checklist",
        "downloading",
        "downloads",
        "enable",
        "loading",
        "progress",
        "project management",
        "settings",
        "summary",
        "to do",
        "validate",
        "working"
      ],
      "unicode": "f0ae"
    },
    {
      "name": "list-ol",
      "label": "List Ol",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "cheatsheet",
        "checklist",
        "completed",
        "done",
        "finished",
        "numbers",
        "ol",
        "summary",
        "todo",
        "ul"
      ],
      "unicode": "f0cb"
    },
    {
      "name": "list-ul",
      "label": "List Ul",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "bullet",
        "cheatsheet",
        "checklist",
        "completed",
        "done",
        "finished",
        "ol",
        "summary",
        "survey",
        "todo",
        "ul"
      ],
      "unicode": "f0ca"
    },
    {
      "name": "litecoin-sign",
      "label": "Litecoin Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "currency"
      ],
      "unicode": "e1d3"
    },
    {
      "name": "location-arrow",
      "label": "Location Arrow",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "compass",
        "coordinate",
        "direction",
        "gps",
        "map",
        "navigation",
        "place"
      ],
      "unicode": "f124"
    },
    {
      "name": "location-crosshairs",
      "label": "Location Crosshairs",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "coordinate",
        "direction",
        "gps",
        "location",
        "map",
        "navigation",
        "place",
        "where"
      ],
      "unicode": "f601"
    },
    {
      "name": "location-dot",
      "label": "Location Dot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "coordinates",
        "destination",
        "gps",
        "localize",
        "location",
        "map",
        "navigation",
        "paper",
        "pin",
        "place",
        "point of interest",
        "position",
        "route",
        "travel"
      ],
      "unicode": "f3c5"
    },
    {
      "name": "location-pin",
      "label": "Location Pin",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "coordinates",
        "destination",
        "gps",
        "localize",
        "location",
        "map",
        "navigation",
        "paper",
        "pin",
        "place",
        "point of interest",
        "position",
        "route",
        "travel"
      ],
      "unicode": "f041"
    },
    {
      "name": "location-pin-lock",
      "label": "Location Pin Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Security"
      ],
      "search": [
        "closed",
        "lockdown",
        "map",
        "padlock",
        "privacy",
        "quarantine"
      ],
      "unicode": "e51f"
    },
    {
      "name": "lock",
      "label": "Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "admin",
        "closed",
        "lock",
        "locked",
        "open",
        "padlock",
        "password",
        "privacy",
        "private",
        "protect",
        "security"
      ],
      "unicode": "f023"
    },
    {
      "name": "lock-open",
      "label": "Lock Open",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "admin",
        "lock",
        "open",
        "padlock",
        "password",
        "privacy",
        "private",
        "protect",
        "security",
        "unlock"
      ],
      "unicode": "f3c1"
    },
    {
      "name": "locust",
      "label": "Locust",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "horde",
        "infestation",
        "locust",
        "plague",
        "swarm"
      ],
      "unicode": "e520"
    },
    {
      "name": "lungs",
      "label": "Lungs",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "air",
        "breath",
        "covid-19",
        "exhalation",
        "inhalation",
        "lungs",
        "organ",
        "respiration",
        "respiratory"
      ],
      "unicode": "f604"
    },
    {
      "name": "lungs-virus",
      "label": "Lungs Virus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "breath",
        "coronavirus",
        "covid-19",
        "flu",
        "infection",
        "pandemic",
        "respiratory",
        "sick"
      ],
      "unicode": "e067"
    },
    {
      "name": "lyft",
      "label": "lyft",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3c3"
    },
    {
      "name": "m",
      "label": "M",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter M",
        "Latin Small Letter M",
        "letter"
      ],
      "unicode": "4d"
    },
    {
      "name": "magento",
      "label": "Magento",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3c4"
    },
    {
      "name": "magnet",
      "label": "Magnet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Attract",
        "attraction",
        "horseshoe",
        "lodestone",
        "magnet",
        "magnetic",
        "tool"
      ],
      "unicode": "f076"
    },
    {
      "name": "magnifying-glass",
      "label": "Magnifying Glass",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bigger",
        "enlarge",
        "equipment",
        "find",
        "glass",
        "inspection",
        "magnifier",
        "magnify",
        "magnifying",
        "magnifying glass tilted left",
        "preview",
        "search",
        "tool",
        "zoom"
      ],
      "unicode": "f002"
    },
    {
      "name": "magnifying-glass-arrow-right",
      "label": "Magnifying Glass Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "find",
        "magnifier",
        "next",
        "search"
      ],
      "unicode": "e521"
    },
    {
      "name": "magnifying-glass-chart",
      "label": "Magnifying Glass Chart",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "analysis",
        "chart",
        "data",
        "graph",
        "intelligence",
        "magnifier",
        "market",
        "revenue"
      ],
      "unicode": "e522"
    },
    {
      "name": "magnifying-glass-dollar",
      "label": "Magnifying Glass Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "bigger",
        "enlarge",
        "find",
        "magnifier",
        "magnify",
        "money",
        "preview",
        "zoom"
      ],
      "unicode": "f688"
    },
    {
      "name": "magnifying-glass-location",
      "label": "Magnifying Glass Location",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "bigger",
        "enlarge",
        "find",
        "magnifier",
        "magnify",
        "preview",
        "zoom"
      ],
      "unicode": "f689"
    },
    {
      "name": "magnifying-glass-minus",
      "label": "Magnifying Glass Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "magnifier",
        "minify",
        "negative",
        "smaller",
        "zoom",
        "zoom out"
      ],
      "unicode": "f010"
    },
    {
      "name": "magnifying-glass-plus",
      "label": "Magnifying Glass Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "bigger",
        "enlarge",
        "magnifier",
        "magnify",
        "positive",
        "zoom",
        "zoom in"
      ],
      "unicode": "f00e"
    },
    {
      "name": "mailchimp",
      "label": "Mailchimp",
      "styles": [
        "brands"
      ],
      "categories": [
        "Communication"
      ],
      "search": [],
      "unicode": "f59e"
    },
    {
      "name": "manat-sign",
      "label": "Manat Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Manat Sign",
        "currency"
      ],
      "unicode": "e1d5"
    },
    {
      "name": "mandalorian",
      "label": "Mandalorian",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f50f"
    },
    {
      "name": "map",
      "label": "Map",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "coordinates",
        "destination",
        "gps",
        "localize",
        "location",
        "map",
        "navigation",
        "paper",
        "pin",
        "place",
        "point of interest",
        "position",
        "route",
        "travel",
        "world",
        "world map"
      ],
      "unicode": "f279"
    },
    {
      "name": "map-location",
      "label": "Map Location",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "coordinates",
        "destination",
        "gps",
        "localize",
        "location",
        "map",
        "navigation",
        "paper",
        "pin",
        "place",
        "point of interest",
        "position",
        "route",
        "travel"
      ],
      "unicode": "f59f"
    },
    {
      "name": "map-location-dot",
      "label": "Map Location Dot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "coordinates",
        "destination",
        "gps",
        "localize",
        "location",
        "map",
        "navigation",
        "paper",
        "pin",
        "place",
        "point of interest",
        "position",
        "route",
        "travel"
      ],
      "unicode": "f5a0"
    },
    {
      "name": "map-pin",
      "label": "Map Pin",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "address",
        "agree",
        "coordinates",
        "destination",
        "gps",
        "localize",
        "location",
        "map",
        "marker",
        "navigation",
        "pin",
        "place",
        "position",
        "pushpin",
        "round pushpin",
        "travel"
      ],
      "unicode": "f276"
    },
    {
      "name": "markdown",
      "label": "Markdown",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f60f"
    },
    {
      "name": "marker",
      "label": "Marker",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "design",
        "edit",
        "modify",
        "sharpie",
        "update",
        "write"
      ],
      "unicode": "f5a1"
    },
    {
      "name": "mars",
      "label": "Mars",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "gender",
        "male",
        "male sign",
        "man"
      ],
      "unicode": "f222"
    },
    {
      "name": "mars-and-venus",
      "label": "Mars And Venus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Male and Female Sign",
        "female",
        "gender",
        "intersex",
        "male",
        "transgender"
      ],
      "unicode": "f224"
    },
    {
      "name": "mars-and-venus-burst",
      "label": "Mars And Venus Burst",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "gender",
        "uer",
        "violence"
      ],
      "unicode": "e523"
    },
    {
      "name": "mars-double",
      "label": "Mars Double",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Doubled Male Sign",
        "gay",
        "gender",
        "male",
        "men"
      ],
      "unicode": "f227"
    },
    {
      "name": "mars-stroke",
      "label": "Mars Stroke",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Male with Stroke Sign",
        "gender",
        "transgender"
      ],
      "unicode": "f229"
    },
    {
      "name": "mars-stroke-right",
      "label": "Mars Stroke Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Horizontal Male with Stroke Sign",
        "gender"
      ],
      "unicode": "f22b"
    },
    {
      "name": "mars-stroke-up",
      "label": "Mars Stroke Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Vertical Male with Stroke Sign",
        "gender"
      ],
      "unicode": "f22a"
    },
    {
      "name": "martini-glass",
      "label": "Martini Glass",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "bar",
        "beverage",
        "cocktail",
        "cocktail glass",
        "drink",
        "glass",
        "liquor"
      ],
      "unicode": "f57b"
    },
    {
      "name": "martini-glass-citrus",
      "label": "Martini Glass Citrus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "beverage",
        "drink",
        "gin",
        "glass",
        "margarita",
        "martini",
        "vodka"
      ],
      "unicode": "f561"
    },
    {
      "name": "martini-glass-empty",
      "label": "Martini Glass Empty",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "bar",
        "beverage",
        "drink",
        "liquor"
      ],
      "unicode": "f000"
    },
    {
      "name": "mask",
      "label": "Mask",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "carnivale",
        "costume",
        "disguise",
        "halloween",
        "secret",
        "super hero"
      ],
      "unicode": "f6fa"
    },
    {
      "name": "mask-face",
      "label": "Mask Face",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "breath",
        "coronavirus",
        "covid-19",
        "filter",
        "flu",
        "infection",
        "pandemic",
        "respirator",
        "virus"
      ],
      "unicode": "e1d7"
    },
    {
      "name": "mask-ventilator",
      "label": "Mask Ventilator",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "breath",
        "gas",
        "mask",
        "oxygen",
        "respirator",
        "ventilator"
      ],
      "unicode": "e524"
    },
    {
      "name": "masks-theater",
      "label": "Masks Theater",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "art",
        "comedy",
        "mask",
        "perform",
        "performing",
        "performing arts",
        "theater",
        "theatre",
        "tragedy"
      ],
      "unicode": "f630"
    },
    {
      "name": "mastodon",
      "label": "Mastodon",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f6"
    },
    {
      "name": "mattress-pillow",
      "label": "Mattress Pillow",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "air mattress",
        "mattress",
        "pillow",
        "rest",
        "sleep"
      ],
      "unicode": "e525"
    },
    {
      "name": "maxcdn",
      "label": "MaxCDN",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f136"
    },
    {
      "name": "maximize",
      "label": "Maximize",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrows",
        "bigger",
        "enlarge",
        "expand",
        "fullscreen",
        "maximize",
        "resize",
        "resize",
        "scale",
        "size"
      ],
      "unicode": "f31e"
    },
    {
      "name": "mdb",
      "label": "Material Design for Bootstrap",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f8ca"
    },
    {
      "name": "medal",
      "label": "Medal",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "award",
        "guarantee",
        "medal",
        "quality",
        "ribbon",
        "sports medal",
        "star",
        "trophy",
        "warranty"
      ],
      "unicode": "f5a2"
    },
    {
      "name": "medapps",
      "label": "MedApps",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3c6"
    },
    {
      "name": "medium",
      "label": "Medium",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f23a"
    },
    {
      "name": "medrt",
      "label": "MRT",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3c8"
    },
    {
      "name": "meetup",
      "label": "Meetup",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2e0"
    },
    {
      "name": "megaport",
      "label": "Megaport",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5a3"
    },
    {
      "name": "memory",
      "label": "Memory",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "DIMM",
        "RAM",
        "hardware",
        "storage",
        "technology"
      ],
      "unicode": "f538"
    },
    {
      "name": "mendeley",
      "label": "Mendeley",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f7b3"
    },
    {
      "name": "menorah",
      "label": "Menorah",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "candle",
        "hanukkah",
        "jewish",
        "judaism",
        "light"
      ],
      "unicode": "f676"
    },
    {
      "name": "mercury",
      "label": "Mercury",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Mercury",
        "gender",
        "hybrid",
        "transgender"
      ],
      "unicode": "f223"
    },
    {
      "name": "message",
      "label": "Message",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "answer",
        "bubble",
        "chat",
        "commenting",
        "conversation",
        "conversation",
        "discussion",
        "feedback",
        "message",
        "note",
        "notification",
        "sms",
        "speech",
        "talk",
        "talking",
        "texting"
      ],
      "unicode": "f27a"
    },
    {
      "name": "meta",
      "label": "Meta",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e49b"
    },
    {
      "name": "meteor",
      "label": "Meteor",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "armageddon",
        "asteroid",
        "comet",
        "shooting star",
        "space"
      ],
      "unicode": "f753"
    },
    {
      "name": "microblog",
      "label": "Micro.blog",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e01a"
    },
    {
      "name": "microchip",
      "label": "Microchip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cpu",
        "hardware",
        "processor",
        "technology"
      ],
      "unicode": "f2db"
    },
    {
      "name": "microphone",
      "label": "Microphone",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Communication"
      ],
      "search": [
        "address",
        "audio",
        "information",
        "podcast",
        "public",
        "record",
        "sing",
        "sound",
        "talking",
        "voice"
      ],
      "unicode": "f130"
    },
    {
      "name": "microphone-lines",
      "label": "Microphone Lines",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Media"
      ],
      "search": [
        "audio",
        "mic",
        "microphone",
        "music",
        "podcast",
        "record",
        "sing",
        "sound",
        "studio",
        "studio microphone",
        "talking",
        "voice"
      ],
      "unicode": "f3c9"
    },
    {
      "name": "microphone-lines-slash",
      "label": "Microphone Lines Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "audio",
        "disable",
        "disabled",
        "disconnect",
        "disconnect",
        "mute",
        "podcast",
        "record",
        "sing",
        "sound",
        "voice"
      ],
      "unicode": "f539"
    },
    {
      "name": "microphone-slash",
      "label": "Microphone Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "audio",
        "disable",
        "disabled",
        "mute",
        "podcast",
        "record",
        "sing",
        "sound",
        "voice"
      ],
      "unicode": "f131"
    },
    {
      "name": "microscope",
      "label": "Microscope",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "covid-19",
        "electron",
        "knowledge",
        "lens",
        "microscope",
        "optics",
        "science",
        "shrink",
        "testing",
        "tool"
      ],
      "unicode": "f610"
    },
    {
      "name": "microsoft",
      "label": "Microsoft",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f3ca"
    },
    {
      "name": "mill-sign",
      "label": "Mill Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Mill Sign",
        "currency"
      ],
      "unicode": "e1ed"
    },
    {
      "name": "minimize",
      "label": "Minimize",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "collapse",
        "fullscreen",
        "minimize",
        "move",
        "resize",
        "shrink",
        "smaller"
      ],
      "unicode": "f78c"
    },
    {
      "name": "mintbit",
      "label": "Mintbit",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e62f"
    },
    {
      "name": "minus",
      "label": "Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "En Dash",
        "Minus Sign",
        "collapse",
        "delete",
        "hide",
        "math",
        "minify",
        "minus",
        "negative",
        "remove",
        "sign",
        "trash",
        "−"
      ],
      "unicode": "f068"
    },
    {
      "name": "mitten",
      "label": "Mitten",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clothing",
        "cold",
        "glove",
        "hands",
        "knitted",
        "seasonal",
        "warmth"
      ],
      "unicode": "f7b5"
    },
    {
      "name": "mix",
      "label": "Mix",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3cb"
    },
    {
      "name": "mixcloud",
      "label": "Mixcloud",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "f289"
    },
    {
      "name": "mixer",
      "label": "Mixer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e056"
    },
    {
      "name": "mizuni",
      "label": "Mizuni",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3cc"
    },
    {
      "name": "mobile",
      "label": "Mobile",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "android",
        "call",
        "cell",
        "cell phone",
        "device",
        "mobile",
        "mobile phone",
        "number",
        "phone",
        "screen",
        "telephone",
        "text"
      ],
      "unicode": "f3ce"
    },
    {
      "name": "mobile-button",
      "label": "Mobile Button",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Social & Brands"
      ],
      "search": [
        "apple",
        "call",
        "cell phone",
        "device",
        "iphone",
        "number",
        "screen",
        "telephone"
      ],
      "unicode": "f10b"
    },
    {
      "name": "mobile-retro",
      "label": "Mobile Retro",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "cellphone",
        "cellular",
        "phone"
      ],
      "unicode": "e527"
    },
    {
      "name": "mobile-screen",
      "label": "Mobile Screen",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "android",
        "call",
        "cell phone",
        "device",
        "number",
        "screen",
        "telephone",
        "text"
      ],
      "unicode": "f3cf"
    },
    {
      "name": "mobile-screen-button",
      "label": "Mobile Screen Button",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Social & Brands"
      ],
      "search": [
        "apple",
        "call",
        "cell phone",
        "device",
        "iphone",
        "number",
        "screen",
        "telephone"
      ],
      "unicode": "f3cd"
    },
    {
      "name": "modx",
      "label": "MODX",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f285"
    },
    {
      "name": "monero",
      "label": "Monero",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d0"
    },
    {
      "name": "money-bill",
      "label": "Money Bill",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "buy",
        "cash",
        "checkout",
        "coupon",
        "investment",
        "money",
        "payment",
        "premium",
        "price",
        "purchase",
        "revenue",
        "salary"
      ],
      "unicode": "f0d6"
    },
    {
      "name": "money-bill-1",
      "label": "Money Bill 1",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "buy",
        "cash",
        "checkout",
        "money",
        "payment",
        "premium",
        "price",
        "purchase",
        "salary"
      ],
      "unicode": "f3d1"
    },
    {
      "name": "money-bill-1-wave",
      "label": "Money Bill 1 Wave",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "buy",
        "cash",
        "checkout",
        "money",
        "payment",
        "premium",
        "price",
        "purchase",
        "salary"
      ],
      "unicode": "f53b"
    },
    {
      "name": "money-bill-transfer",
      "label": "Money Bill Transfer",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "bank",
        "conversion",
        "deposit",
        "investment",
        "money",
        "salary",
        "transfer",
        "withdrawal"
      ],
      "unicode": "e528"
    },
    {
      "name": "money-bill-trend-up",
      "label": "Money Bill Trend Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "bank",
        "bonds",
        "inflation",
        "investment",
        "market",
        "revenue",
        "salary",
        "stocks",
        "trade"
      ],
      "unicode": "e529"
    },
    {
      "name": "money-bill-wave",
      "label": "Money Bill Wave",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "buy",
        "cash",
        "checkout",
        "money",
        "payment",
        "premium",
        "price",
        "purchase",
        "salary"
      ],
      "unicode": "f53a"
    },
    {
      "name": "money-bill-wheat",
      "label": "Money Bill Wheat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Transportation"
      ],
      "search": [
        "agribusiness",
        "agriculture",
        "farming",
        "food",
        "investment",
        "livelihood",
        "subsidy"
      ],
      "unicode": "e52a"
    },
    {
      "name": "money-bills",
      "label": "Money Bills",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "atm",
        "cash",
        "investment",
        "money",
        "moolah",
        "premium",
        "revenue",
        "salary"
      ],
      "unicode": "e1f3"
    },
    {
      "name": "money-check",
      "label": "Money Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "bank check",
        "buy",
        "checkout",
        "cheque",
        "money",
        "payment",
        "price",
        "purchase",
        "salary"
      ],
      "unicode": "f53c"
    },
    {
      "name": "money-check-dollar",
      "label": "Money Check Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "bank check",
        "buy",
        "checkout",
        "cheque",
        "money",
        "payment",
        "price",
        "purchase",
        "salary"
      ],
      "unicode": "f53d"
    },
    {
      "name": "monument",
      "label": "Monument",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "historic",
        "landmark",
        "memorable"
      ],
      "unicode": "f5a6"
    },
    {
      "name": "moon",
      "label": "Moon",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "Power Sleep Symbol",
        "contrast",
        "crescent",
        "crescent moon",
        "dark",
        "lunar",
        "moon",
        "night"
      ],
      "unicode": "f186"
    },
    {
      "name": "mortar-pestle",
      "label": "Mortar Pestle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crush",
        "culinary",
        "grind",
        "medical",
        "mix",
        "pharmacy",
        "prescription",
        "spices"
      ],
      "unicode": "f5a7"
    },
    {
      "name": "mosque",
      "label": "Mosque",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "Muslim",
        "building",
        "islam",
        "landmark",
        "mosque",
        "muslim",
        "religion"
      ],
      "unicode": "f678"
    },
    {
      "name": "mosquito",
      "label": "Mosquito",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bite",
        "bug",
        "mosquito",
        "west nile"
      ],
      "unicode": "e52b"
    },
    {
      "name": "mosquito-net",
      "label": "Mosquito Net",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bite",
        "malaria",
        "mosquito",
        "net"
      ],
      "unicode": "e52c"
    },
    {
      "name": "motorcycle",
      "label": "Motorcycle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bike",
        "machine",
        "motorcycle",
        "racing",
        "transportation",
        "vehicle"
      ],
      "unicode": "f21c"
    },
    {
      "name": "mound",
      "label": "Mound",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "barrier",
        "hill",
        "pitcher",
        "speedbump"
      ],
      "unicode": "e52d"
    },
    {
      "name": "mountain",
      "label": "Mountain",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cold",
        "glacier",
        "hiking",
        "hill",
        "landscape",
        "mountain",
        "snow",
        "snow-capped mountain",
        "travel",
        "view"
      ],
      "unicode": "f6fc"
    },
    {
      "name": "mountain-city",
      "label": "Mountain City",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts"
      ],
      "search": [
        "location",
        "rural",
        "urban"
      ],
      "unicode": "e52e"
    },
    {
      "name": "mountain-sun",
      "label": "Mountain Sun",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "country",
        "hiking",
        "landscape",
        "rural",
        "travel",
        "view"
      ],
      "unicode": "e52f"
    },
    {
      "name": "mug-hot",
      "label": "Mug Hot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "beverage",
        "caliente",
        "cocoa",
        "coffee",
        "cup",
        "drink",
        "holiday",
        "hot",
        "hot beverage",
        "hot chocolate",
        "steam",
        "steaming",
        "tea",
        "warmth"
      ],
      "unicode": "f7b6"
    },
    {
      "name": "mug-saucer",
      "label": "Mug Saucer",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "beverage",
        "breakfast",
        "cafe",
        "drink",
        "fall",
        "morning",
        "mug",
        "seasonal",
        "tea"
      ],
      "unicode": "f0f4"
    },
    {
      "name": "music",
      "label": "Music",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "lyrics",
        "melody",
        "music",
        "musical note",
        "note",
        "sing",
        "sound"
      ],
      "unicode": "f001"
    },
    {
      "name": "n",
      "label": "N",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter N",
        "Latin Small Letter N",
        "letter",
        "nay",
        "no"
      ],
      "unicode": "4e"
    },
    {
      "name": "naira-sign",
      "label": "Naira Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Naira Sign",
        "currency"
      ],
      "unicode": "e1f6"
    },
    {
      "name": "napster",
      "label": "Napster",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d2"
    },
    {
      "name": "neos",
      "label": "Neos",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f612"
    },
    {
      "name": "network-wired",
      "label": "Network Wired",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "connect",
        "ethernet",
        "internet",
        "intranet"
      ],
      "unicode": "f6ff"
    },
    {
      "name": "neuter",
      "label": "Neuter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Neuter",
        "gender"
      ],
      "unicode": "f22c"
    },
    {
      "name": "newspaper",
      "label": "Newspaper",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "article",
        "editorial",
        "headline",
        "journal",
        "journalism",
        "news",
        "newsletter",
        "newspaper",
        "paper",
        "press"
      ],
      "unicode": "f1ea"
    },
    {
      "name": "nfc-directional",
      "label": "NFC Directional",
      "styles": [
        "brands"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "connect",
        "data",
        "near field communication",
        "nfc",
        "scan",
        "signal",
        "transfer",
        "wireless"
      ],
      "unicode": "e530"
    },
    {
      "name": "nfc-symbol",
      "label": "Nfc Symbol",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "connect",
        "data",
        "near field communication",
        "nfc",
        "scan",
        "signal",
        "transfer",
        "wireless"
      ],
      "unicode": "e531"
    },
    {
      "name": "nimblr",
      "label": "Nimblr",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5a8"
    },
    {
      "name": "node",
      "label": "Node.js",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f419"
    },
    {
      "name": "node-js",
      "label": "Node.js JS",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d3"
    },
    {
      "name": "not-equal",
      "label": "Not Equal",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "arithmetic",
        "compare",
        "math"
      ],
      "unicode": "f53e"
    },
    {
      "name": "notdef",
      "label": "Notdef",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "404",
        "close",
        "missing",
        "not found"
      ],
      "unicode": "e1fe"
    },
    {
      "name": "note-sticky",
      "label": "Note Sticky",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "message",
        "note",
        "paper",
        "reminder",
        "sticker"
      ],
      "unicode": "f249"
    },
    {
      "name": "notes-medical",
      "label": "Notes Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clipboard",
        "doctor",
        "ehr",
        "health",
        "history",
        "records"
      ],
      "unicode": "f481"
    },
    {
      "name": "npm",
      "label": "npm",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d4"
    },
    {
      "name": "ns8",
      "label": "NS8",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d5"
    },
    {
      "name": "nutritionix",
      "label": "Nutritionix",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d6"
    },
    {
      "name": "o",
      "label": "O",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter O",
        "Latin Small Letter O",
        "letter"
      ],
      "unicode": "4f"
    },
    {
      "name": "object-group",
      "label": "Object Group",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "combine",
        "copy",
        "design",
        "merge",
        "select"
      ],
      "unicode": "f247"
    },
    {
      "name": "object-ungroup",
      "label": "Object Ungroup",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "copy",
        "design",
        "merge",
        "select",
        "separate"
      ],
      "unicode": "f248"
    },
    {
      "name": "octopus-deploy",
      "label": "Octopus Deploy",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e082"
    },
    {
      "name": "odnoklassniki",
      "label": "Odnoklassniki",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f263"
    },
    {
      "name": "odysee",
      "label": "Odysee",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e5c6"
    },
    {
      "name": "oil-can",
      "label": "Oil Can",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "auto",
        "crude",
        "gasoline",
        "grease",
        "lubricate",
        "petroleum"
      ],
      "unicode": "f613"
    },
    {
      "name": "oil-well",
      "label": "Oil Well",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drill",
        "oil",
        "rig"
      ],
      "unicode": "e532"
    },
    {
      "name": "old-republic",
      "label": "Old Republic",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "politics",
        "star wars"
      ],
      "unicode": "f510"
    },
    {
      "name": "om",
      "label": "Om",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Hindu",
        "buddhism",
        "hinduism",
        "jainism",
        "mantra",
        "om",
        "religion"
      ],
      "unicode": "f679"
    },
    {
      "name": "opencart",
      "label": "OpenCart",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions",
        "Shopping",
        "Transportation"
      ],
      "search": [],
      "unicode": "f23d"
    },
    {
      "name": "openid",
      "label": "OpenID",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions"
      ],
      "search": [],
      "unicode": "f19b"
    },
    {
      "name": "opensuse",
      "label": "Opensuse",
      "styles": [
        "brands"
      ],
      "categories": [
        "Actions"
      ],
      "search": [],
      "unicode": "e62b"
    },
    {
      "name": "opera",
      "label": "Opera",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f26a"
    },
    {
      "name": "optin-monster",
      "label": "Optin Monster",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f23c"
    },
    {
      "name": "orcid",
      "label": "ORCID",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f8d2"
    },
    {
      "name": "osi",
      "label": "Open Source Initiative",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f41a"
    },
    {
      "name": "otter",
      "label": "Otter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "animal",
        "badger",
        "fauna",
        "fishing",
        "fur",
        "mammal",
        "marten",
        "otter",
        "playful"
      ],
      "unicode": "f700"
    },
    {
      "name": "outdent",
      "label": "Outdent",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "align",
        "justify",
        "paragraph",
        "tab"
      ],
      "unicode": "f03b"
    },
    {
      "name": "p",
      "label": "P",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter P",
        "Latin Small Letter P",
        "letter"
      ],
      "unicode": "50"
    },
    {
      "name": "padlet",
      "label": "Padlet",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e4a0"
    },
    {
      "name": "page4",
      "label": "page4 Corporation",
      "styles": [
        "brands"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [],
      "unicode": "f3d7"
    },
    {
      "name": "pagelines",
      "label": "Pagelines",
      "styles": [
        "brands"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "eco",
        "flora",
        "leaf",
        "leaves",
        "nature",
        "plant",
        "tree"
      ],
      "unicode": "f18c"
    },
    {
      "name": "pager",
      "label": "Pager",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Files & Folders"
      ],
      "search": [
        "beeper",
        "cell phone",
        "communication",
        "page",
        "pager"
      ],
      "unicode": "f815"
    },
    {
      "name": "paint-roller",
      "label": "Paint Roller",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "acrylic",
        "art",
        "brush",
        "color",
        "fill",
        "maintenance",
        "paint",
        "pigment",
        "watercolor"
      ],
      "unicode": "f5aa"
    },
    {
      "name": "paintbrush",
      "label": "Paintbrush",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "acrylic",
        "art",
        "brush",
        "color",
        "fill",
        "modify",
        "paint",
        "paintbrush",
        "painting",
        "pigment",
        "watercolor"
      ],
      "unicode": "f1fc"
    },
    {
      "name": "palette",
      "label": "Palette",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "acrylic",
        "art",
        "artist palette",
        "brush",
        "color",
        "fill",
        "museum",
        "paint",
        "painting",
        "palette",
        "pigment",
        "watercolor"
      ],
      "unicode": "f53f"
    },
    {
      "name": "palfed",
      "label": "Palfed",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d8"
    },
    {
      "name": "pallet",
      "label": "Pallet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "archive",
        "box",
        "inventory",
        "shipping",
        "warehouse"
      ],
      "unicode": "f482"
    },
    {
      "name": "panorama",
      "label": "Panorama",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "image",
        "img",
        "landscape",
        "photo",
        "wide"
      ],
      "unicode": "e209"
    },
    {
      "name": "paper-plane",
      "label": "Paper Plane",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Communication",
        "Transportation"
      ],
      "search": [
        "air",
        "float",
        "fold",
        "mail",
        "paper",
        "send"
      ],
      "unicode": "f1d8"
    },
    {
      "name": "paperclip",
      "label": "Paperclip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "attach",
        "attachment",
        "connect",
        "link",
        "papercli",
        "paperclip"
      ],
      "unicode": "f0c6"
    },
    {
      "name": "parachute-box",
      "label": "Parachute Box",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "aid",
        "assistance",
        "goods",
        "relief",
        "rescue",
        "supplies"
      ],
      "unicode": "f4cd"
    },
    {
      "name": "paragraph",
      "label": "Paragraph",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Business",
        "Text & Formatting"
      ],
      "search": [
        "Pilcrow Sign",
        "edit",
        "format",
        "text",
        "writing"
      ],
      "unicode": "f1dd"
    },
    {
      "name": "passport",
      "label": "Passport",
      "styles": [
        "solid"
      ],
      "categories": [
        "Files & Folders"
      ],
      "search": [
        "document",
        "id",
        "identification",
        "issued",
        "travel"
      ],
      "unicode": "f5ab"
    },
    {
      "name": "paste",
      "label": "Paste",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "clipboard",
        "copy",
        "document",
        "paper"
      ],
      "unicode": "f0ea"
    },
    {
      "name": "patreon",
      "label": "Patreon",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3d9"
    },
    {
      "name": "pause",
      "label": "Pause",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "bar",
        "double",
        "hold",
        "pause",
        "pause button",
        "vertical",
        "wait"
      ],
      "unicode": "f04c"
    },
    {
      "name": "paw",
      "label": "Paw",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "animal",
        "cat",
        "dog",
        "pet",
        "print"
      ],
      "unicode": "f1b0"
    },
    {
      "name": "paypal",
      "label": "Paypal",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1ed"
    },
    {
      "name": "peace",
      "label": "Peace",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "peace",
        "peace symbol",
        "serenity",
        "tranquility",
        "truce",
        "war"
      ],
      "unicode": "f67c"
    },
    {
      "name": "pen",
      "label": "Pen",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "ballpoint",
        "design",
        "edit",
        "modify",
        "pen",
        "update",
        "write"
      ],
      "unicode": "f304"
    },
    {
      "name": "pen-clip",
      "label": "Pen Clip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "design",
        "edit",
        "modify",
        "update",
        "write"
      ],
      "unicode": "f305"
    },
    {
      "name": "pen-fancy",
      "label": "Pen Fancy",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "black nib",
        "design",
        "edit",
        "fountain",
        "fountain pen",
        "modify",
        "nib",
        "pen",
        "update",
        "write"
      ],
      "unicode": "f5ac"
    },
    {
      "name": "pen-nib",
      "label": "Pen Nib",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "design",
        "edit",
        "fountain pen",
        "modify",
        "update",
        "write"
      ],
      "unicode": "f5ad"
    },
    {
      "name": "pen-ruler",
      "label": "Pen Ruler",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "design",
        "draft",
        "draw",
        "maintenance",
        "modify",
        "pencil"
      ],
      "unicode": "f5ae"
    },
    {
      "name": "pen-to-square",
      "label": "Pen To Square",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "edit",
        "modify",
        "pen",
        "pencil",
        "update",
        "write"
      ],
      "unicode": "f044"
    },
    {
      "name": "pencil",
      "label": "Pencil",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "Lower Left Pencil",
        "design",
        "draw",
        "edit",
        "lead",
        "maintenance",
        "modify",
        "pencil",
        "update",
        "write"
      ],
      "unicode": "f303"
    },
    {
      "name": "people-arrows",
      "label": "People Arrows",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "conversation",
        "discussion",
        "distance",
        "insert",
        "isolation",
        "separate",
        "social distancing",
        "talk",
        "talking",
        "together",
        "uer",
        "users-people"
      ],
      "unicode": "e068"
    },
    {
      "name": "people-carry-box",
      "label": "People Carry Box",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "together",
        "uer",
        "users-people"
      ],
      "unicode": "f4ce"
    },
    {
      "name": "people-group",
      "label": "People Group",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crowd",
        "family",
        "group",
        "team",
        "together",
        "uer"
      ],
      "unicode": "e533"
    },
    {
      "name": "people-line",
      "label": "People Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crowd",
        "group",
        "need",
        "together",
        "uer"
      ],
      "unicode": "e534"
    },
    {
      "name": "people-pulling",
      "label": "People Pulling",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "forced return",
        "together",
        "uer",
        "yanking"
      ],
      "unicode": "e535"
    },
    {
      "name": "people-robbery",
      "label": "People Robbery",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "criminal",
        "hands up",
        "looting",
        "robbery",
        "steal",
        "uer"
      ],
      "unicode": "e536"
    },
    {
      "name": "people-roof",
      "label": "People Roof",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crowd",
        "family",
        "group",
        "manage",
        "people",
        "safe",
        "shelter",
        "together",
        "uer"
      ],
      "unicode": "e537"
    },
    {
      "name": "pepper-hot",
      "label": "Pepper Hot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Actions"
      ],
      "search": [
        "buffalo wings",
        "capsicum",
        "chili",
        "chilli",
        "habanero",
        "hot",
        "hot pepper",
        "jalapeno",
        "mexican",
        "pepper",
        "spicy",
        "tabasco",
        "vegetable"
      ],
      "unicode": "f816"
    },
    {
      "name": "perbyte",
      "label": "PerByte",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e083"
    },
    {
      "name": "percent",
      "label": "Percent",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Percent Sign",
        "discount",
        "fraction",
        "proportion",
        "rate",
        "ratio"
      ],
      "unicode": "25"
    },
    {
      "name": "periscope",
      "label": "Periscope",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3da"
    },
    {
      "name": "person",
      "label": "Person",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "default",
        "man",
        "person standing",
        "stand",
        "standing",
        "uer",
        "woman"
      ],
      "unicode": "f183"
    },
    {
      "name": "person-arrow-down-to-line",
      "label": "Person Arrow Down To Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "ground",
        "indigenous",
        "insert",
        "native",
        "uer"
      ],
      "unicode": "e538"
    },
    {
      "name": "person-arrow-up-from-line",
      "label": "Person Arrow Up From Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "population",
        "rise",
        "uer",
        "upgrade"
      ],
      "unicode": "e539"
    },
    {
      "name": "person-biking",
      "label": "Person Biking",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting",
        "Transportation"
      ],
      "search": [
        "bicycle",
        "bike",
        "biking",
        "cyclist",
        "pedal",
        "person biking",
        "summer",
        "uer",
        "wheel"
      ],
      "unicode": "f84a"
    },
    {
      "name": "person-booth",
      "label": "Person Booth",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "changing room",
        "curtain",
        "uer",
        "vote",
        "voting"
      ],
      "unicode": "f756"
    },
    {
      "name": "person-breastfeeding",
      "label": "Person Breastfeeding",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "baby",
        "child",
        "infant",
        "mother",
        "nutrition",
        "parent",
        "sustenance",
        "uer"
      ],
      "unicode": "e53a"
    },
    {
      "name": "person-burst",
      "label": "Person Burst",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "abuse",
        "accident",
        "crash",
        "explode",
        "uer",
        "violence"
      ],
      "unicode": "e53b"
    },
    {
      "name": "person-cane",
      "label": "Person Cane",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "aging",
        "cane",
        "elderly",
        "old",
        "staff",
        "uer"
      ],
      "unicode": "e53c"
    },
    {
      "name": "person-chalkboard",
      "label": "Person Chalkboard",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "blackboard",
        "instructor",
        "keynote",
        "lesson",
        "presentation",
        "teacher",
        "uer"
      ],
      "unicode": "e53d"
    },
    {
      "name": "person-circle-check",
      "label": "Person Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "approved",
        "enable",
        "not affected",
        "ok",
        "okay",
        "uer",
        "validate",
        "working"
      ],
      "unicode": "e53e"
    },
    {
      "name": "person-circle-exclamation",
      "label": "Person Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "alert",
        "failed",
        "lost",
        "missing",
        "uer"
      ],
      "unicode": "e53f"
    },
    {
      "name": "person-circle-minus",
      "label": "Person Circle Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "delete",
        "remove",
        "uer"
      ],
      "unicode": "e540"
    },
    {
      "name": "person-circle-plus",
      "label": "Person Circle Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "add",
        "follow",
        "found",
        "uer"
      ],
      "unicode": "e541"
    },
    {
      "name": "person-circle-question",
      "label": "Person Circle Question",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "faq",
        "lost",
        "missing",
        "request",
        "uer"
      ],
      "unicode": "e542"
    },
    {
      "name": "person-circle-xmark",
      "label": "Person Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "dead",
        "removed",
        "uer",
        "uncheck"
      ],
      "unicode": "e543"
    },
    {
      "name": "person-digging",
      "label": "Person Digging",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bury",
        "construction",
        "debris",
        "dig",
        "maintenance",
        "men at work",
        "uer"
      ],
      "unicode": "f85e"
    },
    {
      "name": "person-dots-from-line",
      "label": "Person Dots From Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "allergy",
        "diagnosis",
        "uer"
      ],
      "unicode": "f470"
    },
    {
      "name": "person-dress",
      "label": "Person Dress",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "man",
        "skirt",
        "uer",
        "woman"
      ],
      "unicode": "f182"
    },
    {
      "name": "person-dress-burst",
      "label": "Person Dress Burst",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "abuse",
        "accident",
        "crash",
        "explode",
        "uer",
        "violence"
      ],
      "unicode": "e544"
    },
    {
      "name": "person-drowning",
      "label": "Person Drowning",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drown",
        "emergency",
        "swim",
        "uer"
      ],
      "unicode": "e545"
    },
    {
      "name": "person-falling",
      "label": "Person Falling",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "accident",
        "fall",
        "trip",
        "uer"
      ],
      "unicode": "e546"
    },
    {
      "name": "person-falling-burst",
      "label": "Person Falling Burst",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "accident",
        "crash",
        "death",
        "fall",
        "homicide",
        "murder",
        "uer"
      ],
      "unicode": "e547"
    },
    {
      "name": "person-half-dress",
      "label": "Person Half Dress",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "gender",
        "man",
        "restroom",
        "transgender",
        "uer",
        "woman"
      ],
      "unicode": "e548"
    },
    {
      "name": "person-harassing",
      "label": "Person Harassing",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "abuse",
        "scream",
        "shame",
        "shout",
        "uer",
        "yell"
      ],
      "unicode": "e549"
    },
    {
      "name": "person-hiking",
      "label": "Person Hiking",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "autumn",
        "fall",
        "follow",
        "hike",
        "mountain",
        "outdoors",
        "summer",
        "uer",
        "walk"
      ],
      "unicode": "f6ec"
    },
    {
      "name": "person-military-pointing",
      "label": "Person Military Pointing",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "army",
        "customs",
        "guard",
        "uer"
      ],
      "unicode": "e54a"
    },
    {
      "name": "person-military-rifle",
      "label": "Person Military Rifle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "armed forces",
        "army",
        "military",
        "rifle",
        "uer",
        "war"
      ],
      "unicode": "e54b"
    },
    {
      "name": "person-military-to-person",
      "label": "Person Military To Person",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "civilian",
        "coordination",
        "military",
        "uer"
      ],
      "unicode": "e54c"
    },
    {
      "name": "person-praying",
      "label": "Person Praying",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "kneel",
        "place of worship",
        "religion",
        "thank",
        "uer",
        "worship"
      ],
      "unicode": "f683"
    },
    {
      "name": "person-pregnant",
      "label": "Person Pregnant",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "baby",
        "birth",
        "child",
        "parent",
        "pregnant",
        "pregnant woman",
        "uer",
        "woman"
      ],
      "unicode": "e31e"
    },
    {
      "name": "person-rays",
      "label": "Person Rays",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "affected",
        "focus",
        "shine",
        "uer"
      ],
      "unicode": "e54d"
    },
    {
      "name": "person-rifle",
      "label": "Person Rifle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "army",
        "combatant",
        "gun",
        "military",
        "rifle",
        "uer",
        "war"
      ],
      "unicode": "e54e"
    },
    {
      "name": "person-running",
      "label": "Person Running",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "exit",
        "flee",
        "follow",
        "marathon",
        "person running",
        "race",
        "running",
        "uer",
        "workout"
      ],
      "unicode": "f70c"
    },
    {
      "name": "person-shelter",
      "label": "Person Shelter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "house",
        "inside",
        "roof",
        "safe",
        "safety",
        "shelter",
        "uer"
      ],
      "unicode": "e54f"
    },
    {
      "name": "person-skating",
      "label": "Person Skating",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "figure skating",
        "ice",
        "olympics",
        "rink",
        "skate",
        "uer",
        "winter"
      ],
      "unicode": "f7c5"
    },
    {
      "name": "person-skiing",
      "label": "Person Skiing",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "downhill",
        "olympics",
        "ski",
        "skier",
        "snow",
        "uer",
        "winter"
      ],
      "unicode": "f7c9"
    },
    {
      "name": "person-skiing-nordic",
      "label": "Person Skiing Nordic",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cross country",
        "olympics",
        "uer",
        "winter"
      ],
      "unicode": "f7ca"
    },
    {
      "name": "person-snowboarding",
      "label": "Person Snowboarding",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "olympics",
        "ski",
        "snow",
        "snowboard",
        "snowboarder",
        "uer",
        "winter"
      ],
      "unicode": "f7ce"
    },
    {
      "name": "person-swimming",
      "label": "Person Swimming",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ocean",
        "person swimming",
        "pool",
        "sea",
        "swim",
        "uer",
        "water"
      ],
      "unicode": "f5c4"
    },
    {
      "name": "person-through-window",
      "label": "Person Through Window",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "door",
        "exit",
        "forced entry",
        "leave",
        "robbery",
        "steal",
        "uer",
        "window"
      ],
      "unicode": "e5a9"
    },
    {
      "name": "person-walking",
      "label": "Person Walking",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crosswalk",
        "exercise",
        "follow",
        "hike",
        "move",
        "person walking",
        "uer",
        "walk",
        "walking",
        "workout"
      ],
      "unicode": "f554"
    },
    {
      "name": "person-walking-arrow-loop-left",
      "label": "Person Walking Arrow Loop Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "follow",
        "population return",
        "return",
        "uer"
      ],
      "unicode": "e551"
    },
    {
      "name": "person-walking-arrow-right",
      "label": "Person Walking Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "exit",
        "follow",
        "internally displaced",
        "leave",
        "refugee",
        "uer"
      ],
      "unicode": "e552"
    },
    {
      "name": "person-walking-dashed-line-arrow-right",
      "label": "Person Walking Dashed Line Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "exit",
        "follow",
        "refugee",
        "uer"
      ],
      "unicode": "e553"
    },
    {
      "name": "person-walking-luggage",
      "label": "Person Walking Luggage",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping",
        "Transportation"
      ],
      "search": [
        "bag",
        "baggage",
        "briefcase",
        "carry-on",
        "deployment",
        "follow",
        "rolling",
        "uer"
      ],
      "unicode": "e554"
    },
    {
      "name": "person-walking-with-cane",
      "label": "Person Walking With Cane",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "blind",
        "cane",
        "follow",
        "uer"
      ],
      "unicode": "f29d"
    },
    {
      "name": "peseta-sign",
      "label": "Peseta Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Peseta Sign",
        "currency"
      ],
      "unicode": "e221"
    },
    {
      "name": "peso-sign",
      "label": "Peso Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Peso Sign",
        "currency"
      ],
      "unicode": "e222"
    },
    {
      "name": "phabricator",
      "label": "Phabricator",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3db"
    },
    {
      "name": "phoenix-framework",
      "label": "Phoenix Framework",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3dc"
    },
    {
      "name": "phoenix-squadron",
      "label": "Phoenix Squadron",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f511"
    },
    {
      "name": "phone",
      "label": "Phone",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "Left Hand Telephone Receiver",
        "call",
        "earphone",
        "number",
        "phone",
        "receiver",
        "support",
        "talking",
        "telephone",
        "telephone receiver",
        "voice"
      ],
      "unicode": "f095"
    },
    {
      "name": "phone-flip",
      "label": "Phone Flip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "Right Hand Telephone Receiver",
        "call",
        "earphone",
        "number",
        "support",
        "telephone",
        "voice"
      ],
      "unicode": "f879"
    },
    {
      "name": "phone-slash",
      "label": "Phone Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "call",
        "cancel",
        "disabled",
        "disconnect",
        "earphone",
        "mute",
        "number",
        "support",
        "telephone",
        "voice"
      ],
      "unicode": "f3dd"
    },
    {
      "name": "phone-volume",
      "label": "Phone Volume",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "call",
        "earphone",
        "number",
        "ring",
        "ringing",
        "sound",
        "support",
        "talking",
        "telephone",
        "voice",
        "volume-control-phone"
      ],
      "unicode": "f2a0"
    },
    {
      "name": "photo-film",
      "label": "Photo Film",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "av",
        "film",
        "image",
        "library",
        "media"
      ],
      "unicode": "f87c"
    },
    {
      "name": "php",
      "label": "PHP",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f457"
    },
    {
      "name": "pied-piper",
      "label": "Pied Piper Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2ae"
    },
    {
      "name": "pied-piper-alt",
      "label": "Alternate Pied Piper Logo (Old)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a8"
    },
    {
      "name": "pied-piper-hat",
      "label": "Pied Piper Hat (Old)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clothing"
      ],
      "unicode": "f4e5"
    },
    {
      "name": "pied-piper-pp",
      "label": "Pied Piper PP Logo (Old)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a7"
    },
    {
      "name": "piggy-bank",
      "label": "Piggy Bank",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Actions"
      ],
      "search": [
        "bank",
        "salary",
        "save",
        "savings"
      ],
      "unicode": "f4d3"
    },
    {
      "name": "pills",
      "label": "Pills",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drugs",
        "medicine",
        "prescription",
        "tablets"
      ],
      "unicode": "f484"
    },
    {
      "name": "pinterest",
      "label": "Pinterest",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f0d2"
    },
    {
      "name": "pinterest-p",
      "label": "Pinterest P",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f231"
    },
    {
      "name": "pix",
      "label": "Pix",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e43a"
    },
    {
      "name": "pixiv",
      "label": "Pixiv",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e640"
    },
    {
      "name": "pizza-slice",
      "label": "Pizza Slice",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cheese",
        "chicago",
        "italian",
        "mozzarella",
        "new york",
        "pepperoni",
        "pie",
        "slice",
        "teenage mutant ninja turtles",
        "tomato"
      ],
      "unicode": "f818"
    },
    {
      "name": "place-of-worship",
      "label": "Place Of Worship",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Transportation"
      ],
      "search": [
        "building",
        "church",
        "holy",
        "mosque",
        "synagogue"
      ],
      "unicode": "f67f"
    },
    {
      "name": "plane",
      "label": "Plane",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "airplane",
        "airport",
        "destination",
        "fly",
        "location",
        "mode",
        "travel",
        "trip"
      ],
      "unicode": "f072"
    },
    {
      "name": "plane-arrival",
      "label": "Plane Arrival",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "aeroplane",
        "airplane",
        "airplane arrival",
        "airport",
        "arrivals",
        "arriving",
        "destination",
        "fly",
        "land",
        "landing",
        "location",
        "mode",
        "travel",
        "trip"
      ],
      "unicode": "f5af"
    },
    {
      "name": "plane-circle-check",
      "label": "Plane Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "airplane",
        "airport",
        "enable",
        "flight",
        "fly",
        "not affected",
        "ok",
        "okay",
        "travel",
        "validate",
        "working"
      ],
      "unicode": "e555"
    },
    {
      "name": "plane-circle-exclamation",
      "label": "Plane Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "affected",
        "airplane",
        "airport",
        "failed",
        "flight",
        "fly",
        "travel"
      ],
      "unicode": "e556"
    },
    {
      "name": "plane-circle-xmark",
      "label": "Plane Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "airplane",
        "airport",
        "destroy",
        "flight",
        "fly",
        "travel",
        "uncheck"
      ],
      "unicode": "e557"
    },
    {
      "name": "plane-departure",
      "label": "Plane Departure",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "aeroplane",
        "airplane",
        "airplane departure",
        "airport",
        "check-in",
        "departing",
        "departure",
        "departures",
        "destination",
        "fly",
        "location",
        "mode",
        "take off",
        "taking off",
        "travel",
        "trip"
      ],
      "unicode": "f5b0"
    },
    {
      "name": "plane-lock",
      "label": "Plane Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security",
        "Transportation"
      ],
      "search": [
        "airplane",
        "airport",
        "closed",
        "flight",
        "fly",
        "lockdown",
        "padlock",
        "privacy",
        "quarantine",
        "travel"
      ],
      "unicode": "e558"
    },
    {
      "name": "plane-slash",
      "label": "Plane Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "airplane mode",
        "airport",
        "canceled",
        "covid-19",
        "delayed",
        "disabled",
        "grounded",
        "travel"
      ],
      "unicode": "e069"
    },
    {
      "name": "plane-up",
      "label": "Plane Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "airplane",
        "airport",
        "internet",
        "signal",
        "sky",
        "wifi",
        "wireless"
      ],
      "unicode": "e22d"
    },
    {
      "name": "plant-wilt",
      "label": "Plant Wilt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drought",
        "planting",
        "vegetation",
        "wilt"
      ],
      "unicode": "e5aa"
    },
    {
      "name": "plate-wheat",
      "label": "Plate Wheat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bowl",
        "hunger",
        "rations",
        "wheat"
      ],
      "unicode": "e55a"
    },
    {
      "name": "play",
      "label": "Play",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Media"
      ],
      "search": [
        "arrow",
        "audio",
        "music",
        "play",
        "play button",
        "playing",
        "right",
        "sound",
        "start",
        "triangle",
        "video"
      ],
      "unicode": "f04b"
    },
    {
      "name": "playstation",
      "label": "PlayStation",
      "styles": [
        "brands"
      ],
      "categories": [
        "Media"
      ],
      "search": [],
      "unicode": "f3df"
    },
    {
      "name": "plug",
      "label": "Plug",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "connect",
        "electric",
        "electric plug",
        "electricity",
        "online",
        "plug",
        "power"
      ],
      "unicode": "f1e6"
    },
    {
      "name": "plug-circle-bolt",
      "label": "Plug Circle Bolt",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Weather"
      ],
      "search": [
        "electric",
        "electricity",
        "plug",
        "power"
      ],
      "unicode": "e55b"
    },
    {
      "name": "plug-circle-check",
      "label": "Plug Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "electric",
        "electricity",
        "enable",
        "not affected",
        "ok",
        "okay",
        "plug",
        "power",
        "validate",
        "working"
      ],
      "unicode": "e55c"
    },
    {
      "name": "plug-circle-exclamation",
      "label": "Plug Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "electric",
        "electricity",
        "failed",
        "plug",
        "power"
      ],
      "unicode": "e55d"
    },
    {
      "name": "plug-circle-minus",
      "label": "Plug Circle Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "disconnect",
        "electric",
        "electricity",
        "plug",
        "power"
      ],
      "unicode": "e55e"
    },
    {
      "name": "plug-circle-plus",
      "label": "Plug Circle Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "electric",
        "electricity",
        "plug",
        "power"
      ],
      "unicode": "e55f"
    },
    {
      "name": "plug-circle-xmark",
      "label": "Plug Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Shopping"
      ],
      "search": [
        "destroy",
        "disconnect",
        "electric",
        "electricity",
        "outage",
        "plug",
        "power",
        "uncheck"
      ],
      "unicode": "e560"
    },
    {
      "name": "plus",
      "label": "Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "+",
        "Plus Sign",
        "add",
        "create",
        "expand",
        "follow",
        "math",
        "modify",
        "new",
        "plus",
        "positive",
        "shape",
        "sign"
      ],
      "unicode": "2b"
    },
    {
      "name": "plus-minus",
      "label": "Plus Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "Plus-Minus Sign",
        "add",
        "math",
        "subtract"
      ],
      "unicode": "e43c"
    },
    {
      "name": "podcast",
      "label": "Podcast",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "audio",
        "broadcast",
        "music",
        "sound"
      ],
      "unicode": "f2ce"
    },
    {
      "name": "poo",
      "label": "Poo",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crap",
        "dung",
        "face",
        "monster",
        "pile of poo",
        "poo",
        "poop",
        "shit",
        "smile",
        "turd",
        "uer"
      ],
      "unicode": "f2fe"
    },
    {
      "name": "poo-storm",
      "label": "Poo Storm",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "bolt",
        "cloud",
        "euphemism",
        "lightning",
        "mess",
        "poop",
        "shit",
        "turd"
      ],
      "unicode": "f75a"
    },
    {
      "name": "poop",
      "label": "Poop",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "crap",
        "poop",
        "shit",
        "smile",
        "turd"
      ],
      "unicode": "f619"
    },
    {
      "name": "power-off",
      "label": "Power Off",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "Power Symbol",
        "cancel",
        "computer",
        "on",
        "reboot",
        "restart"
      ],
      "unicode": "f011"
    },
    {
      "name": "prescription",
      "label": "Prescription",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drugs",
        "medical",
        "medicine",
        "pharmacy",
        "rx"
      ],
      "unicode": "f5b1"
    },
    {
      "name": "prescription-bottle",
      "label": "Prescription Bottle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drugs",
        "medical",
        "medicine",
        "pharmacy",
        "rx"
      ],
      "unicode": "f485"
    },
    {
      "name": "prescription-bottle-medical",
      "label": "Prescription Bottle Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drugs",
        "medical",
        "medicine",
        "pharmacy",
        "rx"
      ],
      "unicode": "f486"
    },
    {
      "name": "print",
      "label": "Print",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "Print Screen Symbol",
        "Printer Icon",
        "business",
        "computer",
        "copy",
        "document",
        "office",
        "paper",
        "printer"
      ],
      "unicode": "f02f"
    },
    {
      "name": "product-hunt",
      "label": "Product Hunt",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f288"
    },
    {
      "name": "pump-medical",
      "label": "Pump Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "anti-bacterial",
        "clean",
        "covid-19",
        "disinfect",
        "hygiene",
        "medical grade",
        "sanitizer",
        "soap"
      ],
      "unicode": "e06a"
    },
    {
      "name": "pump-soap",
      "label": "Pump Soap",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "anti-bacterial",
        "clean",
        "covid-19",
        "disinfect",
        "hygiene",
        "sanitizer",
        "soap"
      ],
      "unicode": "e06b"
    },
    {
      "name": "pushed",
      "label": "Pushed",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3e1"
    },
    {
      "name": "puzzle-piece",
      "label": "Puzzle Piece",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "add-on",
        "addon",
        "clue",
        "game",
        "interlocking",
        "jigsaw",
        "piece",
        "puzzle",
        "puzzle piece",
        "section"
      ],
      "unicode": "f12e"
    },
    {
      "name": "python",
      "label": "Python",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3e2"
    },
    {
      "name": "q",
      "label": "Q",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter Q",
        "Latin Small Letter Q",
        "letter"
      ],
      "unicode": "51"
    },
    {
      "name": "qq",
      "label": "QQ",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d6"
    },
    {
      "name": "qrcode",
      "label": "Qrcode",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "barcode",
        "info",
        "information",
        "scan"
      ],
      "unicode": "f029"
    },
    {
      "name": "question",
      "label": "Question",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "?",
        "Question Mark",
        "faq",
        "help",
        "information",
        "mark",
        "outlined",
        "punctuation",
        "question",
        "red question mark",
        "request",
        "support",
        "unknown",
        "white question mark"
      ],
      "unicode": "3f"
    },
    {
      "name": "quinscape",
      "label": "QuinScape",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f459"
    },
    {
      "name": "quora",
      "label": "Quora",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2c4"
    },
    {
      "name": "quote-left",
      "label": "Quote Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "Left Double Quotation Mark",
        "mention",
        "note",
        "phrase",
        "text",
        "type"
      ],
      "unicode": "f10d"
    },
    {
      "name": "quote-right",
      "label": "Quote Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "Right Double Quotation Mark",
        "mention",
        "note",
        "phrase",
        "text",
        "type"
      ],
      "unicode": "f10e"
    },
    {
      "name": "r",
      "label": "R",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter R",
        "Latin Small Letter R",
        "letter"
      ],
      "unicode": "52"
    },
    {
      "name": "r-project",
      "label": "R Project",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f7"
    },
    {
      "name": "radiation",
      "label": "Radiation",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "danger",
        "dangerous",
        "deadly",
        "hazard",
        "nuclear",
        "radioactive",
        "warning"
      ],
      "unicode": "f7b9"
    },
    {
      "name": "radio",
      "label": "Radio",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "am",
        "broadcast",
        "fm",
        "frequency",
        "music",
        "news",
        "radio",
        "receiver",
        "transmitter",
        "tuner",
        "video"
      ],
      "unicode": "f8d7"
    },
    {
      "name": "rainbow",
      "label": "Rainbow",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "gold",
        "leprechaun",
        "prism",
        "rain",
        "rainbow",
        "sky"
      ],
      "unicode": "f75b"
    },
    {
      "name": "ranking-star",
      "label": "Ranking Star",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "chart",
        "first place",
        "podium",
        "quality",
        "rank",
        "revenue",
        "win"
      ],
      "unicode": "e561"
    },
    {
      "name": "raspberry-pi",
      "label": "Raspberry Pi",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f7bb"
    },
    {
      "name": "ravelry",
      "label": "Ravelry",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2d9"
    },
    {
      "name": "react",
      "label": "React",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f41b"
    },
    {
      "name": "reacteurope",
      "label": "ReactEurope",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f75d"
    },
    {
      "name": "readme",
      "label": "ReadMe",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4d5"
    },
    {
      "name": "rebel",
      "label": "Rebel Alliance",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d0"
    },
    {
      "name": "receipt",
      "label": "Receipt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "accounting",
        "bookkeeping",
        "check",
        "coupon",
        "evidence",
        "invoice",
        "money",
        "pay",
        "proof",
        "receipt",
        "table"
      ],
      "unicode": "f543"
    },
    {
      "name": "record-vinyl",
      "label": "Record Vinyl",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media",
        "Business"
      ],
      "search": [
        "LP",
        "album",
        "analog",
        "music",
        "phonograph",
        "sound"
      ],
      "unicode": "f8d9"
    },
    {
      "name": "rectangle-ad",
      "label": "Rectangle Ad",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "advertisement",
        "media",
        "newspaper",
        "promotion",
        "publicity"
      ],
      "unicode": "f641"
    },
    {
      "name": "rectangle-list",
      "label": "Rectangle List",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "cheatsheet",
        "checklist",
        "completed",
        "done",
        "finished",
        "ol",
        "summary",
        "todo",
        "ul"
      ],
      "unicode": "f022"
    },
    {
      "name": "rectangle-xmark",
      "label": "Rectangle Xmark",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts"
      ],
      "search": [
        "browser",
        "cancel",
        "computer",
        "development",
        "uncheck"
      ],
      "unicode": "f410"
    },
    {
      "name": "recycle",
      "label": "Recycle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Shopping"
      ],
      "search": [
        "Recycling Symbol For Generic Materials",
        "Universal Recycling Symbol",
        "Waste",
        "compost",
        "garbage",
        "recycle",
        "recycling symbol",
        "reuse",
        "trash"
      ],
      "unicode": "f1b8"
    },
    {
      "name": "red-river",
      "label": "red river",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3e3"
    },
    {
      "name": "reddit",
      "label": "Reddit",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a1"
    },
    {
      "name": "reddit-alien",
      "label": "Reddit Alien",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f281"
    },
    {
      "name": "redhat",
      "label": "Redhat",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "linux",
        "operating system",
        "os"
      ],
      "unicode": "f7bc"
    },
    {
      "name": "registered",
      "label": "Registered",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "copyright",
        "mark",
        "r",
        "registered",
        "trademark"
      ],
      "unicode": "f25d"
    },
    {
      "name": "renren",
      "label": "Renren",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f18b"
    },
    {
      "name": "repeat",
      "label": "Repeat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Business",
        "Security",
        "Weather"
      ],
      "search": [
        "arrow",
        "clockwise",
        "flip",
        "reload",
        "renew",
        "repeat",
        "repeat button",
        "retry",
        "rewind",
        "switch"
      ],
      "unicode": "f363"
    },
    {
      "name": "reply",
      "label": "Reply",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "mail",
        "message",
        "respond"
      ],
      "unicode": "f3e5"
    },
    {
      "name": "reply-all",
      "label": "Reply All",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "mail",
        "message",
        "respond"
      ],
      "unicode": "f122"
    },
    {
      "name": "replyd",
      "label": "replyd",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3e6"
    },
    {
      "name": "republican",
      "label": "Republican",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "american",
        "conservative",
        "election",
        "elephant",
        "politics",
        "republican party",
        "right",
        "right-wing",
        "usa"
      ],
      "unicode": "f75e"
    },
    {
      "name": "researchgate",
      "label": "Researchgate",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f8"
    },
    {
      "name": "resolving",
      "label": "Resolving",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3e7"
    },
    {
      "name": "restroom",
      "label": "Restroom",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bathroom",
        "toilet",
        "uer",
        "water closet",
        "wc"
      ],
      "unicode": "f7bd"
    },
    {
      "name": "retweet",
      "label": "Retweet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "refresh",
        "reload",
        "renew",
        "retry",
        "share",
        "swap"
      ],
      "unicode": "f079"
    },
    {
      "name": "rev",
      "label": "Rev.io",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5b2"
    },
    {
      "name": "ribbon",
      "label": "Ribbon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "badge",
        "cause",
        "celebration",
        "lapel",
        "pin",
        "reminder",
        "reminder ribbon",
        "ribbon"
      ],
      "unicode": "f4d6"
    },
    {
      "name": "right-from-bracket",
      "label": "Right From Bracket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "exit",
        "leave",
        "log out",
        "logout",
        "sign-out"
      ],
      "unicode": "f2f5"
    },
    {
      "name": "right-left",
      "label": "Right Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "arrows",
        "exchange",
        "reciprocate",
        "return",
        "swap",
        "transfer"
      ],
      "unicode": "f362"
    },
    {
      "name": "right-long",
      "label": "Right Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "forward",
        "long-arrow-right",
        "next"
      ],
      "unicode": "f30b"
    },
    {
      "name": "right-to-bracket",
      "label": "Right To Bracket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "enter",
        "join",
        "log in",
        "login",
        "sign in",
        "sign up",
        "sign-in",
        "signin",
        "signup"
      ],
      "unicode": "f2f6"
    },
    {
      "name": "ring",
      "label": "Ring",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Dungeons & Dragons",
        "Gollum",
        "band",
        "binding",
        "d&d",
        "dnd",
        "engagement",
        "fantasy",
        "gold",
        "jewelry",
        "marriage",
        "precious",
        "premium"
      ],
      "unicode": "f70b"
    },
    {
      "name": "road",
      "label": "Road",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "highway",
        "map",
        "motorway",
        "pavement",
        "road",
        "route",
        "street",
        "travel"
      ],
      "unicode": "f018"
    },
    {
      "name": "road-barrier",
      "label": "Road Barrier",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "block",
        "border",
        "no entry",
        "roadblock"
      ],
      "unicode": "e562"
    },
    {
      "name": "road-bridge",
      "label": "Road Bridge",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bridge",
        "infrastructure",
        "road",
        "travel"
      ],
      "unicode": "e563"
    },
    {
      "name": "road-circle-check",
      "label": "Road Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "enable",
        "freeway",
        "highway",
        "not affected",
        "ok",
        "okay",
        "pavement",
        "road",
        "validate",
        "working"
      ],
      "unicode": "e564"
    },
    {
      "name": "road-circle-exclamation",
      "label": "Road Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "failed",
        "freeway",
        "highway",
        "pavement",
        "road"
      ],
      "unicode": "e565"
    },
    {
      "name": "road-circle-xmark",
      "label": "Road Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "destroy",
        "freeway",
        "highway",
        "pavement",
        "road",
        "uncheck"
      ],
      "unicode": "e566"
    },
    {
      "name": "road-lock",
      "label": "Road Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "closed",
        "freeway",
        "highway",
        "lockdown",
        "padlock",
        "pavement",
        "privacy",
        "quarantine",
        "road"
      ],
      "unicode": "e567"
    },
    {
      "name": "road-spikes",
      "label": "Road Spikes",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "barrier",
        "roadblock",
        "spikes"
      ],
      "unicode": "e568"
    },
    {
      "name": "robot",
      "label": "Robot",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "android",
        "automate",
        "computer",
        "cyborg",
        "face",
        "monster",
        "robot"
      ],
      "unicode": "f544"
    },
    {
      "name": "rocket",
      "label": "Rocket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "aircraft",
        "app",
        "jet",
        "launch",
        "nasa",
        "space"
      ],
      "unicode": "f135"
    },
    {
      "name": "rocketchat",
      "label": "Rocket.Chat",
      "styles": [
        "brands"
      ],
      "categories": [
        "Communication"
      ],
      "search": [],
      "unicode": "f3e8"
    },
    {
      "name": "rockrms",
      "label": "Rockrms",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3e9"
    },
    {
      "name": "rotate",
      "label": "Rotate",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Business",
        "Security"
      ],
      "search": [
        "arrow",
        "clockwise",
        "exchange",
        "modify",
        "refresh",
        "reload",
        "renew",
        "retry",
        "rotate",
        "swap",
        "withershins"
      ],
      "unicode": "f2f1"
    },
    {
      "name": "rotate-left",
      "label": "Rotate Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "back",
        "control z",
        "exchange",
        "oops",
        "return",
        "swap"
      ],
      "unicode": "f2ea"
    },
    {
      "name": "rotate-right",
      "label": "Rotate Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "forward",
        "refresh",
        "reload",
        "renew",
        "repeat",
        "retry"
      ],
      "unicode": "f2f9"
    },
    {
      "name": "route",
      "label": "Route",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "directions",
        "navigation",
        "travel"
      ],
      "unicode": "f4d7"
    },
    {
      "name": "rss",
      "label": "Rss",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "blog",
        "feed",
        "journal",
        "news",
        "writing"
      ],
      "unicode": "f09e"
    },
    {
      "name": "ruble-sign",
      "label": "Ruble Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Ruble Sign",
        "currency"
      ],
      "unicode": "f158"
    },
    {
      "name": "rug",
      "label": "Rug",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting",
        "Transportation"
      ],
      "search": [
        "blanket",
        "carpet",
        "rug",
        "textile"
      ],
      "unicode": "e569"
    },
    {
      "name": "ruler",
      "label": "Ruler",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "draft",
        "length",
        "measure",
        "planning",
        "ruler",
        "straight edge",
        "straight ruler"
      ],
      "unicode": "f545"
    },
    {
      "name": "ruler-combined",
      "label": "Ruler Combined",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "draft",
        "length",
        "measure",
        "planning"
      ],
      "unicode": "f546"
    },
    {
      "name": "ruler-horizontal",
      "label": "Ruler Horizontal",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "draft",
        "length",
        "measure",
        "planning"
      ],
      "unicode": "f547"
    },
    {
      "name": "ruler-vertical",
      "label": "Ruler Vertical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "draft",
        "length",
        "measure",
        "planning"
      ],
      "unicode": "f548"
    },
    {
      "name": "rupee-sign",
      "label": "Rupee Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Rupee Sign",
        "currency"
      ],
      "unicode": "f156"
    },
    {
      "name": "rupiah-sign",
      "label": "Rupiah Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "currency"
      ],
      "unicode": "e23d"
    },
    {
      "name": "rust",
      "label": "Rust",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e07a"
    },
    {
      "name": "s",
      "label": "S",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter S",
        "Latin Small Letter S",
        "letter"
      ],
      "unicode": "53"
    },
    {
      "name": "sack-dollar",
      "label": "Sack Dollar",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping"
      ],
      "search": [
        "bag",
        "burlap",
        "cash",
        "dollar",
        "investment",
        "money",
        "money bag",
        "moneybag",
        "premium",
        "robber",
        "salary",
        "santa",
        "usd"
      ],
      "unicode": "f81d"
    },
    {
      "name": "sack-xmark",
      "label": "Sack Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Shopping"
      ],
      "search": [
        "bag",
        "burlap",
        "coupon",
        "rations",
        "salary",
        "uncheck"
      ],
      "unicode": "e56a"
    },
    {
      "name": "safari",
      "label": "Safari",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "browser"
      ],
      "unicode": "f267"
    },
    {
      "name": "sailboat",
      "label": "Sailboat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "dinghy",
        "mast",
        "sailboat",
        "sailing",
        "yacht"
      ],
      "unicode": "e445"
    },
    {
      "name": "salesforce",
      "label": "Salesforce",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f83b"
    },
    {
      "name": "sass",
      "label": "Sass",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f41e"
    },
    {
      "name": "satellite",
      "label": "Satellite",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "communications",
        "hardware",
        "orbit",
        "satellite",
        "space"
      ],
      "unicode": "f7bf"
    },
    {
      "name": "satellite-dish",
      "label": "Satellite Dish",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "SETI",
        "antenna",
        "communications",
        "dish",
        "hardware",
        "radar",
        "receiver",
        "satellite",
        "satellite antenna",
        "saucer",
        "signal",
        "space"
      ],
      "unicode": "f7c0"
    },
    {
      "name": "scale-balanced",
      "label": "Scale Balanced",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Libra",
        "balance",
        "balance scale",
        "balanced",
        "justice",
        "law",
        "legal",
        "measure",
        "rule",
        "scale",
        "weight",
        "zodiac"
      ],
      "unicode": "f24e"
    },
    {
      "name": "scale-unbalanced",
      "label": "Scale Unbalanced",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "justice",
        "legal",
        "measure",
        "unbalanced",
        "weight"
      ],
      "unicode": "f515"
    },
    {
      "name": "scale-unbalanced-flip",
      "label": "Scale Unbalanced Flip",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "justice",
        "legal",
        "measure",
        "unbalanced",
        "weight"
      ],
      "unicode": "f516"
    },
    {
      "name": "schlix",
      "label": "SCHLIX",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3ea"
    },
    {
      "name": "school",
      "label": "School",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "education",
        "learn",
        "school",
        "student",
        "teacher"
      ],
      "unicode": "f549"
    },
    {
      "name": "school-circle-check",
      "label": "School Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "enable",
        "not affected",
        "ok",
        "okay",
        "schoolhouse",
        "validate",
        "working"
      ],
      "unicode": "e56b"
    },
    {
      "name": "school-circle-exclamation",
      "label": "School Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "failed",
        "schoolhouse"
      ],
      "unicode": "e56c"
    },
    {
      "name": "school-circle-xmark",
      "label": "School Circle Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "destroy",
        "schoolhouse",
        "uncheck"
      ],
      "unicode": "e56d"
    },
    {
      "name": "school-flag",
      "label": "School Flag",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "educate",
        "flag",
        "school",
        "schoolhouse"
      ],
      "unicode": "e56e"
    },
    {
      "name": "school-lock",
      "label": "School Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "closed",
        "lockdown",
        "padlock",
        "privacy",
        "quarantine",
        "schoolhouse"
      ],
      "unicode": "e56f"
    },
    {
      "name": "scissors",
      "label": "Scissors",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Black Safety Scissors",
        "White Scissors",
        "clip",
        "cutting",
        "equipment",
        "modify",
        "scissors",
        "snip",
        "tool"
      ],
      "unicode": "f0c4"
    },
    {
      "name": "screenpal",
      "label": "Screenpal",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e570"
    },
    {
      "name": "screwdriver",
      "label": "Screwdriver",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "admin",
        "configuration",
        "equipment",
        "fix",
        "maintenance",
        "mechanic",
        "modify",
        "repair",
        "screw",
        "screwdriver",
        "settings",
        "tool"
      ],
      "unicode": "f54a"
    },
    {
      "name": "screwdriver-wrench",
      "label": "Screwdriver Wrench",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "admin",
        "configuration",
        "equipment",
        "fix",
        "maintenance",
        "modify",
        "repair",
        "screwdriver",
        "settings",
        "tools",
        "wrench"
      ],
      "unicode": "f7d9"
    },
    {
      "name": "scribd",
      "label": "Scribd",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f28a"
    },
    {
      "name": "scroll",
      "label": "Scroll",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "announcement",
        "d&d",
        "dnd",
        "fantasy",
        "paper",
        "scholar",
        "script",
        "scroll"
      ],
      "unicode": "f70e"
    },
    {
      "name": "scroll-torah",
      "label": "Scroll Torah",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "book",
        "jewish",
        "judaism",
        "religion",
        "scroll"
      ],
      "unicode": "f6a0"
    },
    {
      "name": "sd-card",
      "label": "Sd Card",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Media",
        "Transportation"
      ],
      "search": [
        "image",
        "img",
        "memory",
        "photo",
        "save"
      ],
      "unicode": "f7c2"
    },
    {
      "name": "searchengin",
      "label": "Searchengin",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3eb"
    },
    {
      "name": "section",
      "label": "Section",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Section Sign",
        "law",
        "legal",
        "silcrow"
      ],
      "unicode": "e447"
    },
    {
      "name": "seedling",
      "label": "Seedling",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "environment",
        "flora",
        "grow",
        "investment",
        "plant",
        "sapling",
        "seedling",
        "vegan",
        "young"
      ],
      "unicode": "f4d8"
    },
    {
      "name": "sellcast",
      "label": "Sellcast",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "eercast"
      ],
      "unicode": "f2da"
    },
    {
      "name": "sellsy",
      "label": "Sellsy",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f213"
    },
    {
      "name": "server",
      "label": "Server",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "computer",
        "cpu",
        "database",
        "hardware",
        "mysql",
        "network",
        "sql"
      ],
      "unicode": "f233"
    },
    {
      "name": "servicestack",
      "label": "Servicestack",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3ec"
    },
    {
      "name": "shapes",
      "label": "Shapes",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Security"
      ],
      "search": [
        "blocks",
        "build",
        "circle",
        "square",
        "triangle"
      ],
      "unicode": "f61f"
    },
    {
      "name": "share",
      "label": "Share",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "forward",
        "save",
        "send",
        "social"
      ],
      "unicode": "f064"
    },
    {
      "name": "share-from-square",
      "label": "Share From Square",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "forward",
        "save",
        "send",
        "social"
      ],
      "unicode": "f14d"
    },
    {
      "name": "share-nodes",
      "label": "Share Nodes",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "forward",
        "save",
        "send",
        "social"
      ],
      "unicode": "f1e0"
    },
    {
      "name": "sheet-plastic",
      "label": "Sheet Plastic",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "plastic",
        "plastic wrap",
        "protect",
        "tarp",
        "tarpaulin",
        "waterproof"
      ],
      "unicode": "e571"
    },
    {
      "name": "shekel-sign",
      "label": "Shekel Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "New Sheqel Sign",
        "currency",
        "ils",
        "money"
      ],
      "unicode": "f20b"
    },
    {
      "name": "shield",
      "label": "Shield",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "achievement",
        "armor",
        "award",
        "block",
        "cleric",
        "defend",
        "defense",
        "holy",
        "paladin",
        "protect",
        "safety",
        "security",
        "shield",
        "weapon",
        "winner"
      ],
      "unicode": "f132"
    },
    {
      "name": "shield-cat",
      "label": "Shield Cat",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "animal",
        "feline",
        "pet",
        "protect",
        "safety",
        "veterinary"
      ],
      "unicode": "e572"
    },
    {
      "name": "shield-dog",
      "label": "Shield Dog",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "animal",
        "canine",
        "pet",
        "protect",
        "safety",
        "veterinary"
      ],
      "unicode": "e573"
    },
    {
      "name": "shield-halved",
      "label": "Shield Halved",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "achievement",
        "armor",
        "award",
        "block",
        "cleric",
        "defend",
        "defense",
        "holy",
        "paladin",
        "privacy",
        "security",
        "shield",
        "weapon",
        "winner"
      ],
      "unicode": "f3ed"
    },
    {
      "name": "shield-heart",
      "label": "Shield Heart",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting",
        "Security"
      ],
      "search": [
        "love",
        "protect",
        "safe",
        "safety",
        "shield",
        "wishlist"
      ],
      "unicode": "e574"
    },
    {
      "name": "shield-virus",
      "label": "Shield Virus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "antibodies",
        "barrier",
        "coronavirus",
        "covid-19",
        "flu",
        "health",
        "infection",
        "pandemic",
        "protect",
        "safety",
        "vaccine"
      ],
      "unicode": "e06c"
    },
    {
      "name": "ship",
      "label": "Ship",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "boat",
        "passenger",
        "sea",
        "ship",
        "water"
      ],
      "unicode": "f21a"
    },
    {
      "name": "shirt",
      "label": "Shirt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "clothing",
        "fashion",
        "garment",
        "shirt",
        "short sleeve",
        "t-shirt",
        "tshirt"
      ],
      "unicode": "f553"
    },
    {
      "name": "shirtsinbulk",
      "label": "Shirts in Bulk",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f214"
    },
    {
      "name": "shoe-prints",
      "label": "Shoe Prints",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "feet",
        "footprints",
        "steps",
        "walk"
      ],
      "unicode": "f54b"
    },
    {
      "name": "shoelace",
      "label": "Shoelace",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e60c"
    },
    {
      "name": "shop",
      "label": "Shop",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping"
      ],
      "search": [
        "bodega",
        "building",
        "buy",
        "market",
        "purchase",
        "shopping",
        "store"
      ],
      "unicode": "f54f"
    },
    {
      "name": "shop-lock",
      "label": "Shop Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Security",
        "Shopping"
      ],
      "search": [
        "bodega",
        "building",
        "buy",
        "closed",
        "lock",
        "lockdown",
        "market",
        "padlock",
        "privacy",
        "purchase",
        "quarantine",
        "shop",
        "shopping",
        "store"
      ],
      "unicode": "e4a5"
    },
    {
      "name": "shop-slash",
      "label": "Shop Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping"
      ],
      "search": [
        "building",
        "buy",
        "closed",
        "covid-19",
        "disabled",
        "purchase",
        "shopping"
      ],
      "unicode": "e070"
    },
    {
      "name": "shopify",
      "label": "Shopify",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e057"
    },
    {
      "name": "shopware",
      "label": "Shopware",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5b5"
    },
    {
      "name": "shower",
      "label": "Shower",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bath",
        "clean",
        "faucet",
        "shower",
        "water"
      ],
      "unicode": "f2cc"
    },
    {
      "name": "shrimp",
      "label": "Shrimp",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "allergy",
        "crustacean",
        "prawn",
        "seafood",
        "shellfish",
        "shrimp",
        "tail"
      ],
      "unicode": "e448"
    },
    {
      "name": "shuffle",
      "label": "Shuffle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "arrows",
        "crossed",
        "shuffle",
        "shuffle tracks button",
        "sort",
        "swap",
        "switch",
        "transfer"
      ],
      "unicode": "f074"
    },
    {
      "name": "shuttle-space",
      "label": "Shuttle Space",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "astronaut",
        "machine",
        "nasa",
        "rocket",
        "space",
        "transportation"
      ],
      "unicode": "f197"
    },
    {
      "name": "sign-hanging",
      "label": "Sign Hanging",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "directions",
        "real estate",
        "signage",
        "wayfinding"
      ],
      "unicode": "f4d9"
    },
    {
      "name": "signal",
      "label": "Signal",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Communication",
        "Business"
      ],
      "search": [
        "antenna",
        "antenna bars",
        "bar",
        "bars",
        "cell",
        "graph",
        "mobile",
        "online",
        "phone",
        "reception",
        "status"
      ],
      "unicode": "f012"
    },
    {
      "name": "signal-messenger",
      "label": "Signal Messenger",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e663"
    },
    {
      "name": "signature",
      "label": "Signature",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "John Hancock",
        "cursive",
        "name",
        "username",
        "writing"
      ],
      "unicode": "f5b7"
    },
    {
      "name": "signs-post",
      "label": "Signs Post",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "directions",
        "directory",
        "map",
        "signage",
        "wayfinding"
      ],
      "unicode": "f277"
    },
    {
      "name": "sim-card",
      "label": "Sim Card",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "hard drive",
        "hardware",
        "portable",
        "storage",
        "technology",
        "tiny"
      ],
      "unicode": "f7c4"
    },
    {
      "name": "simplybuilt",
      "label": "SimplyBuilt",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f215"
    },
    {
      "name": "sink",
      "label": "Sink",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bathroom",
        "covid-19",
        "faucet",
        "kitchen",
        "wash"
      ],
      "unicode": "e06d"
    },
    {
      "name": "sistrix",
      "label": "SISTRIX",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3ee"
    },
    {
      "name": "sitemap",
      "label": "Sitemap",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts"
      ],
      "search": [
        "directory",
        "hierarchy",
        "ia",
        "information architecture",
        "organization"
      ],
      "unicode": "f0e8"
    },
    {
      "name": "sith",
      "label": "Sith",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f512"
    },
    {
      "name": "sitrox",
      "label": "Sitrox",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e44a"
    },
    {
      "name": "sketch",
      "label": "Sketch",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "app",
        "design",
        "interface"
      ],
      "unicode": "f7c6"
    },
    {
      "name": "skull",
      "label": "Skull",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bones",
        "death",
        "face",
        "fairy tale",
        "monster",
        "skeleton",
        "skull",
        "uer",
        "x-ray",
        "yorick"
      ],
      "unicode": "f54c"
    },
    {
      "name": "skull-crossbones",
      "label": "Skull Crossbones",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Black Skull and Crossbones",
        "Dungeons & Dragons",
        "alert",
        "bones",
        "crossbones",
        "d&d",
        "danger",
        "dangerous area",
        "dead",
        "deadly",
        "death",
        "dnd",
        "face",
        "fantasy",
        "halloween",
        "holiday",
        "jolly-roger",
        "monster",
        "pirate",
        "poison",
        "skeleton",
        "skull",
        "skull and crossbones",
        "warning"
      ],
      "unicode": "f714"
    },
    {
      "name": "skyatlas",
      "label": "skyatlas",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f216"
    },
    {
      "name": "skype",
      "label": "Skype",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f17e"
    },
    {
      "name": "slack",
      "label": "Slack Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "anchor",
        "hash",
        "hashtag"
      ],
      "unicode": "f198"
    },
    {
      "name": "slash",
      "label": "Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "cancel",
        "close",
        "mute",
        "off",
        "stop",
        "x"
      ],
      "unicode": "f715"
    },
    {
      "name": "sleigh",
      "label": "Sleigh",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "christmas",
        "claus",
        "fly",
        "holiday",
        "santa",
        "sled",
        "snow",
        "xmas"
      ],
      "unicode": "f7cc"
    },
    {
      "name": "sliders",
      "label": "Sliders",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "adjust",
        "configuration",
        "modify",
        "settings",
        "sliders",
        "toggle"
      ],
      "unicode": "f1de"
    },
    {
      "name": "slideshare",
      "label": "Slideshare",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1e7"
    },
    {
      "name": "smog",
      "label": "Smog",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "dragon",
        "fog",
        "haze",
        "pollution",
        "smoke",
        "weather"
      ],
      "unicode": "f75f"
    },
    {
      "name": "smoking",
      "label": "Smoking",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cancer",
        "cigarette",
        "nicotine",
        "smoking",
        "smoking status",
        "tobacco"
      ],
      "unicode": "f48d"
    },
    {
      "name": "snapchat",
      "label": "Snapchat",
      "styles": [
        "brands"
      ],
      "categories": [
        "Communication"
      ],
      "search": [],
      "unicode": "f2ab"
    },
    {
      "name": "snowflake",
      "label": "Snowflake",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Navigation",
        "Weather"
      ],
      "search": [
        "Heavy Chevron Snowflake",
        "cold",
        "precipitation",
        "rain",
        "snow",
        "snowfall",
        "snowflake",
        "winter"
      ],
      "unicode": "f2dc"
    },
    {
      "name": "snowman",
      "label": "Snowman",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cold",
        "decoration",
        "frost",
        "frosty",
        "holiday",
        "snow",
        "snowman",
        "snowman without snow"
      ],
      "unicode": "f7d0"
    },
    {
      "name": "snowplow",
      "label": "Snowplow",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "clean up",
        "cold",
        "road",
        "storm",
        "winter"
      ],
      "unicode": "f7d2"
    },
    {
      "name": "soap",
      "label": "Soap",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bar",
        "bathing",
        "bubbles",
        "clean",
        "cleaning",
        "covid-19",
        "hygiene",
        "lather",
        "soap",
        "soapdish",
        "wash"
      ],
      "unicode": "e06e"
    },
    {
      "name": "socks",
      "label": "Socks",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Transportation"
      ],
      "search": [
        "business socks",
        "business time",
        "clothing",
        "feet",
        "flight of the conchords",
        "socks",
        "stocking",
        "wednesday"
      ],
      "unicode": "f696"
    },
    {
      "name": "solar-panel",
      "label": "Solar Panel",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "clean",
        "eco-friendly",
        "energy",
        "green",
        "sun"
      ],
      "unicode": "f5ba"
    },
    {
      "name": "sort",
      "label": "Sort",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "filter",
        "order"
      ],
      "unicode": "f0dc"
    },
    {
      "name": "sort-down",
      "label": "Sort Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "descending",
        "filter",
        "insert",
        "order",
        "sort-desc"
      ],
      "unicode": "f0dd"
    },
    {
      "name": "sort-up",
      "label": "Sort Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "ascending",
        "filter",
        "order",
        "sort-asc",
        "upgrade"
      ],
      "unicode": "f0de"
    },
    {
      "name": "soundcloud",
      "label": "Soundcloud",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "f1be"
    },
    {
      "name": "sourcetree",
      "label": "Sourcetree",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f7d3"
    },
    {
      "name": "spa",
      "label": "Spa",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "flora",
        "massage",
        "mindfulness",
        "plant",
        "wellness"
      ],
      "unicode": "f5bb"
    },
    {
      "name": "space-awesome",
      "label": "Space Awesome",
      "styles": [
        "brands"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "adventure",
        "rocket",
        "ship",
        "shuttle"
      ],
      "unicode": "e5ac"
    },
    {
      "name": "spaghetti-monster-flying",
      "label": "Spaghetti Monster Flying",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "agnosticism",
        "atheism",
        "flying spaghetti monster",
        "fsm"
      ],
      "unicode": "f67b"
    },
    {
      "name": "speakap",
      "label": "Speakap",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3f3"
    },
    {
      "name": "speaker-deck",
      "label": "Speaker Deck",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f83c"
    },
    {
      "name": "spell-check",
      "label": "Spell Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "dictionary",
        "edit",
        "editor",
        "enable",
        "grammar",
        "text",
        "validate",
        "working"
      ],
      "unicode": "f891"
    },
    {
      "name": "spider",
      "label": "Spider",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "arachnid",
        "bug",
        "charlotte",
        "crawl",
        "eight",
        "halloween",
        "insect",
        "spider"
      ],
      "unicode": "f717"
    },
    {
      "name": "spinner",
      "label": "Spinner",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "circle",
        "loading",
        "pending",
        "progress"
      ],
      "unicode": "f110"
    },
    {
      "name": "splotch",
      "label": "Splotch",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Ink",
        "blob",
        "blotch",
        "glob",
        "stain"
      ],
      "unicode": "f5bc"
    },
    {
      "name": "spoon",
      "label": "Spoon",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cutlery",
        "dining",
        "scoop",
        "silverware",
        "spoon",
        "tableware"
      ],
      "unicode": "f2e5"
    },
    {
      "name": "spotify",
      "label": "Spotify",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1bc"
    },
    {
      "name": "spray-can",
      "label": "Spray Can",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "Paint",
        "aerosol",
        "design",
        "graffiti",
        "tag"
      ],
      "unicode": "f5bd"
    },
    {
      "name": "spray-can-sparkles",
      "label": "Spray Can Sparkles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "car",
        "clean",
        "deodorize",
        "fresh",
        "pine",
        "scent"
      ],
      "unicode": "f5d0"
    },
    {
      "name": "square",
      "label": "Square",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "Black Square",
        "black medium square",
        "block",
        "box",
        "geometric",
        "shape",
        "square",
        "white medium square"
      ],
      "unicode": "f0c8"
    },
    {
      "name": "square-arrow-up-right",
      "label": "Square Arrow Up Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions"
      ],
      "search": [
        "diagonal",
        "new",
        "open",
        "send",
        "share"
      ],
      "unicode": "f14c"
    },
    {
      "name": "square-behance",
      "label": "Square Behance",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f1b5"
    },
    {
      "name": "square-binary",
      "label": "Square Binary",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "ai",
        "data",
        "language",
        "llm",
        "model",
        "programming",
        "token"
      ],
      "unicode": "e69b"
    },
    {
      "name": "square-bluesky",
      "label": "Square Bluesky",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "social network"
      ],
      "unicode": "e6a3"
    },
    {
      "name": "square-caret-down",
      "label": "Square Caret Down",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "caret-square-o-down",
        "dropdown",
        "expand",
        "insert",
        "menu",
        "more",
        "triangle"
      ],
      "unicode": "f150"
    },
    {
      "name": "square-caret-left",
      "label": "Square Caret Left",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "back",
        "caret-square-o-left",
        "previous",
        "triangle"
      ],
      "unicode": "f191"
    },
    {
      "name": "square-caret-right",
      "label": "Square Caret Right",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Transportation"
      ],
      "search": [
        "arrow",
        "caret-square-o-right",
        "forward",
        "next",
        "triangle"
      ],
      "unicode": "f152"
    },
    {
      "name": "square-caret-up",
      "label": "Square Caret Up",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Status & Alerts",
        "Actions",
        "Transportation"
      ],
      "search": [
        "arrow",
        "caret-square-o-up",
        "collapse",
        "triangle",
        "upgrade",
        "upload"
      ],
      "unicode": "f151"
    },
    {
      "name": "square-check",
      "label": "Square Check",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "accept",
        "agree",
        "box",
        "button",
        "check",
        "check box with check",
        "check mark button",
        "checkmark",
        "confirm",
        "correct",
        "coupon",
        "done",
        "enable",
        "mark",
        "ok",
        "select",
        "success",
        "tick",
        "todo",
        "validate",
        "working",
        "yes",
        "✓"
      ],
      "unicode": "f14a"
    },
    {
      "name": "square-dribbble",
      "label": "Square Dribbble",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f397"
    },
    {
      "name": "square-envelope",
      "label": "Square Envelope",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Communication"
      ],
      "search": [
        "e-mail",
        "email",
        "letter",
        "mail",
        "message",
        "notification",
        "offer",
        "support"
      ],
      "unicode": "f199"
    },
    {
      "name": "square-facebook",
      "label": "Square Facebook",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands"
      ],
      "search": [
        "fabook",
        "fb",
        "social network"
      ],
      "unicode": "f082"
    },
    {
      "name": "square-font-awesome",
      "label": "Square Font Awesome",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting"
      ],
      "search": [],
      "unicode": "e5ad"
    },
    {
      "name": "square-font-awesome-stroke",
      "label": "Square Font Awesome Stroke",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Text & Formatting"
      ],
      "search": [
        "awesome",
        "flag",
        "font",
        "icons",
        "typeface"
      ],
      "unicode": "f35c"
    },
    {
      "name": "square-full",
      "label": "Square Full",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "black large square",
        "block",
        "blue",
        "blue square",
        "box",
        "brown",
        "brown square",
        "geometric",
        "green",
        "green square",
        "orange",
        "orange square",
        "purple",
        "purple square",
        "red",
        "red square",
        "shape",
        "square",
        "white large square",
        "yellow",
        "yellow square"
      ],
      "unicode": "f45c"
    },
    {
      "name": "square-git",
      "label": "Square Git",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f1d2"
    },
    {
      "name": "square-github",
      "label": "Square Github",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands"
      ],
      "search": [
        "octocat"
      ],
      "unicode": "f092"
    },
    {
      "name": "square-gitlab",
      "label": "Square Gitlab",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "e5ae"
    },
    {
      "name": "square-google-plus",
      "label": "Square Google Plus",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Actions",
        "Social & Brands"
      ],
      "search": [
        "social network"
      ],
      "unicode": "f0d4"
    },
    {
      "name": "square-h",
      "label": "Square H",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "directions",
        "emergency",
        "hospital",
        "hotel",
        "letter",
        "map"
      ],
      "unicode": "f0fd"
    },
    {
      "name": "square-hacker-news",
      "label": "Square Hacker News",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f3af"
    },
    {
      "name": "square-instagram",
      "label": "Square Instagram",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands",
        "Shopping"
      ],
      "search": [],
      "unicode": "e055"
    },
    {
      "name": "square-js",
      "label": "Square Js",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f3b9"
    },
    {
      "name": "square-lastfm",
      "label": "Square Lastfm",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f203"
    },
    {
      "name": "square-letterboxd",
      "label": "Square Letterboxd",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "e62e"
    },
    {
      "name": "square-minus",
      "label": "Square Minus",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "collapse",
        "delete",
        "hide",
        "minify",
        "negative",
        "remove",
        "shape",
        "trash"
      ],
      "unicode": "f146"
    },
    {
      "name": "square-nfi",
      "label": "Square Nfi",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "non-food item",
        "supplies"
      ],
      "unicode": "e576"
    },
    {
      "name": "square-odnoklassniki",
      "label": "Square Odnoklassniki",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f264"
    },
    {
      "name": "square-parking",
      "label": "Square Parking",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "auto",
        "car",
        "garage",
        "meter",
        "parking"
      ],
      "unicode": "f540"
    },
    {
      "name": "square-pen",
      "label": "Square Pen",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "edit",
        "modify",
        "pencil-square",
        "update",
        "write"
      ],
      "unicode": "f14b"
    },
    {
      "name": "square-person-confined",
      "label": "Square Person Confined",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "captivity",
        "confined",
        "uer"
      ],
      "unicode": "e577"
    },
    {
      "name": "square-phone",
      "label": "Square Phone",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Communication"
      ],
      "search": [
        "call",
        "earphone",
        "number",
        "support",
        "telephone",
        "voice"
      ],
      "unicode": "f098"
    },
    {
      "name": "square-phone-flip",
      "label": "Square Phone Flip",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Communication"
      ],
      "search": [
        "call",
        "earphone",
        "number",
        "support",
        "telephone",
        "voice"
      ],
      "unicode": "f87b"
    },
    {
      "name": "square-pied-piper",
      "label": "Pied Piper Square Logo (Old)",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "e01e"
    },
    {
      "name": "square-pinterest",
      "label": "Square Pinterest",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f0d3"
    },
    {
      "name": "square-plus",
      "label": "Square Plus",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "add",
        "create",
        "expand",
        "new",
        "positive",
        "shape"
      ],
      "unicode": "f0fe"
    },
    {
      "name": "square-poll-horizontal",
      "label": "Square Poll Horizontal",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "chart",
        "graph",
        "results",
        "statistics",
        "survey",
        "trend",
        "vote",
        "voting"
      ],
      "unicode": "f682"
    },
    {
      "name": "square-poll-vertical",
      "label": "Square Poll Vertical",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "chart",
        "graph",
        "results",
        "revenue",
        "statistics",
        "survey",
        "trend",
        "vote",
        "voting"
      ],
      "unicode": "f681"
    },
    {
      "name": "square-reddit",
      "label": "Square Reddit",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f1a2"
    },
    {
      "name": "square-root-variable",
      "label": "Square Root Variable",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "arithmetic",
        "calculus",
        "division",
        "math"
      ],
      "unicode": "f698"
    },
    {
      "name": "square-rss",
      "label": "Square Rss",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "blog",
        "feed",
        "journal",
        "news",
        "writing"
      ],
      "unicode": "f143"
    },
    {
      "name": "square-share-nodes",
      "label": "Square Share Nodes",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "forward",
        "save",
        "send",
        "social"
      ],
      "unicode": "f1e1"
    },
    {
      "name": "square-snapchat",
      "label": "Snapchat Square",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Communication"
      ],
      "search": [],
      "unicode": "f2ad"
    },
    {
      "name": "square-steam",
      "label": "Square Steam",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f1b7"
    },
    {
      "name": "square-threads",
      "label": "Square Threads",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "social network"
      ],
      "unicode": "e619"
    },
    {
      "name": "square-tumblr",
      "label": "Square Tumblr",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f174"
    },
    {
      "name": "square-twitter",
      "label": "Square Twitter",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands"
      ],
      "search": [
        "social network",
        "tweet"
      ],
      "unicode": "f081"
    },
    {
      "name": "square-up-right",
      "label": "Square Up Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation",
        "Actions",
        "Transportation"
      ],
      "search": [
        "arrow",
        "diagonal",
        "direction",
        "external-link-square",
        "intercardinal",
        "new",
        "northeast",
        "open",
        "share",
        "up-right arrow"
      ],
      "unicode": "f360"
    },
    {
      "name": "square-upwork",
      "label": "Square Upwork",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "e67c"
    },
    {
      "name": "square-viadeo",
      "label": "Square Viadeo",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f2aa"
    },
    {
      "name": "square-vimeo",
      "label": "Square Vimeo",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f194"
    },
    {
      "name": "square-virus",
      "label": "Square Virus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "coronavirus",
        "covid-19",
        "disease",
        "flu",
        "infection",
        "pandemic"
      ],
      "unicode": "e578"
    },
    {
      "name": "square-web-awesome",
      "label": "Square Web Awesome",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "awesome",
        "coding",
        "components",
        "crown",
        "web"
      ],
      "unicode": "e683"
    },
    {
      "name": "square-web-awesome-stroke",
      "label": "Square Web Awesome Stroke",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "awesome",
        "coding",
        "components",
        "crown",
        "web"
      ],
      "unicode": "e684"
    },
    {
      "name": "square-whatsapp",
      "label": "Square Whatsapp",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f40c"
    },
    {
      "name": "square-x-twitter",
      "label": "Square X Twitter",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands"
      ],
      "search": [
        "elon",
        "twitter",
        "x"
      ],
      "unicode": "e61a"
    },
    {
      "name": "square-xing",
      "label": "Square Xing",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f169"
    },
    {
      "name": "square-xmark",
      "label": "Square Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Weather"
      ],
      "search": [
        "close",
        "cross",
        "cross mark button",
        "incorrect",
        "mark",
        "notice",
        "notification",
        "notify",
        "problem",
        "square",
        "uncheck",
        "window",
        "wrong",
        "x",
        "×"
      ],
      "unicode": "f2d3"
    },
    {
      "name": "square-youtube",
      "label": "Square Youtube",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Social & Brands"
      ],
      "search": [],
      "unicode": "f431"
    },
    {
      "name": "squarespace",
      "label": "Squarespace",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f5be"
    },
    {
      "name": "stack-exchange",
      "label": "Stack Exchange",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f18d"
    },
    {
      "name": "stack-overflow",
      "label": "Stack Overflow",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f16c"
    },
    {
      "name": "stackpath",
      "label": "Stackpath",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f842"
    },
    {
      "name": "staff-snake",
      "label": "Staff Snake",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "asclepius",
        "asklepian",
        "health",
        "serpent",
        "wellness"
      ],
      "unicode": "e579"
    },
    {
      "name": "stairs",
      "label": "Stairs",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "exit",
        "steps",
        "up"
      ],
      "unicode": "e289"
    },
    {
      "name": "stamp",
      "label": "Stamp",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "art",
        "certificate",
        "imprint",
        "rubber",
        "seal"
      ],
      "unicode": "f5bf"
    },
    {
      "name": "stapler",
      "label": "Stapler",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "desktop",
        "milton",
        "office",
        "paperclip",
        "staple"
      ],
      "unicode": "e5af"
    },
    {
      "name": "star",
      "label": "Star",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "achievement",
        "award",
        "favorite",
        "important",
        "night",
        "quality",
        "rating",
        "score",
        "star",
        "vip"
      ],
      "unicode": "f005"
    },
    {
      "name": "star-and-crescent",
      "label": "Star And Crescent",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "Muslim",
        "islam",
        "muslim",
        "religion",
        "star and crescent"
      ],
      "unicode": "f699"
    },
    {
      "name": "star-half",
      "label": "Star Half",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "achievement",
        "award",
        "rating",
        "score",
        "star-half-empty",
        "star-half-full"
      ],
      "unicode": "f089"
    },
    {
      "name": "star-half-stroke",
      "label": "Star Half Stroke",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "achievement",
        "award",
        "rating",
        "score",
        "star-half-empty",
        "star-half-full"
      ],
      "unicode": "f5c0"
    },
    {
      "name": "star-of-david",
      "label": "Star Of David",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "David",
        "Jew",
        "Jewish",
        "jewish",
        "judaism",
        "religion",
        "star",
        "star of David"
      ],
      "unicode": "f69a"
    },
    {
      "name": "star-of-life",
      "label": "Star Of Life",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "doctor",
        "emt",
        "first aid",
        "health",
        "medical"
      ],
      "unicode": "f621"
    },
    {
      "name": "staylinked",
      "label": "StayLinked",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "linkin"
      ],
      "unicode": "f3f5"
    },
    {
      "name": "steam",
      "label": "Steam",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1b6"
    },
    {
      "name": "steam-symbol",
      "label": "Steam Symbol",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3f6"
    },
    {
      "name": "sterling-sign",
      "label": "Sterling Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Pound Sign",
        "currency"
      ],
      "unicode": "f154"
    },
    {
      "name": "stethoscope",
      "label": "Stethoscope",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "covid-19",
        "diagnosis",
        "doctor",
        "general practitioner",
        "heart",
        "hospital",
        "infirmary",
        "medicine",
        "office",
        "outpatient",
        "stethoscope"
      ],
      "unicode": "f0f1"
    },
    {
      "name": "sticker-mule",
      "label": "Sticker Mule",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3f7"
    },
    {
      "name": "stop",
      "label": "Stop",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Media",
        "Security"
      ],
      "search": [
        "block",
        "box",
        "square",
        "stop",
        "stop button"
      ],
      "unicode": "f04d"
    },
    {
      "name": "stopwatch",
      "label": "Stopwatch",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media",
        "Business",
        "Security"
      ],
      "search": [
        "clock",
        "reminder",
        "stopwatch",
        "time",
        "waiting"
      ],
      "unicode": "f2f2"
    },
    {
      "name": "stopwatch-20",
      "label": "Stopwatch 20",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media",
        "Business"
      ],
      "search": [
        "ABCs",
        "countdown",
        "covid-19",
        "happy birthday",
        "i will survive",
        "reminder",
        "seconds",
        "time",
        "timer"
      ],
      "unicode": "e06f"
    },
    {
      "name": "store",
      "label": "Store",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping"
      ],
      "search": [
        "bodega",
        "building",
        "buy",
        "market",
        "purchase",
        "shopping",
        "store"
      ],
      "unicode": "f54e"
    },
    {
      "name": "store-slash",
      "label": "Store Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business",
        "Shopping"
      ],
      "search": [
        "building",
        "buy",
        "closed",
        "covid-19",
        "disabled",
        "purchase",
        "shopping"
      ],
      "unicode": "e071"
    },
    {
      "name": "strava",
      "label": "Strava",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f428"
    },
    {
      "name": "street-view",
      "label": "Street View",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "directions",
        "location",
        "map",
        "navigation",
        "uer"
      ],
      "unicode": "f21d"
    },
    {
      "name": "strikethrough",
      "label": "Strikethrough",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "cancel",
        "edit",
        "font",
        "format",
        "modify",
        "text",
        "type"
      ],
      "unicode": "f0cc"
    },
    {
      "name": "stripe",
      "label": "Stripe",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f429"
    },
    {
      "name": "stripe-s",
      "label": "Stripe S",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f42a"
    },
    {
      "name": "stroopwafel",
      "label": "Stroopwafel",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "caramel",
        "cookie",
        "dessert",
        "sweets",
        "waffle"
      ],
      "unicode": "f551"
    },
    {
      "name": "stubber",
      "label": "Stubber",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e5c7"
    },
    {
      "name": "studiovinari",
      "label": "Studio Vinari",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3f8"
    },
    {
      "name": "stumbleupon",
      "label": "StumbleUpon Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1a4"
    },
    {
      "name": "stumbleupon-circle",
      "label": "StumbleUpon Circle",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [],
      "unicode": "f1a3"
    },
    {
      "name": "subscript",
      "label": "Subscript",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "edit",
        "font",
        "format",
        "text",
        "type"
      ],
      "unicode": "f12c"
    },
    {
      "name": "suitcase",
      "label": "Suitcase",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "baggage",
        "luggage",
        "move",
        "packing",
        "suitcase",
        "travel",
        "trip"
      ],
      "unicode": "f0f2"
    },
    {
      "name": "suitcase-medical",
      "label": "Suitcase Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "first aid",
        "firstaid",
        "health",
        "help",
        "medical",
        "supply",
        "support"
      ],
      "unicode": "f0fa"
    },
    {
      "name": "suitcase-rolling",
      "label": "Suitcase Rolling",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "baggage",
        "luggage",
        "move",
        "suitcase",
        "travel",
        "trip"
      ],
      "unicode": "f5c1"
    },
    {
      "name": "sun",
      "label": "Sun",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Weather"
      ],
      "search": [
        "bright",
        "brighten",
        "contrast",
        "day",
        "lighter",
        "rays",
        "sol",
        "solar",
        "star",
        "sun",
        "sunny",
        "weather"
      ],
      "unicode": "f185"
    },
    {
      "name": "sun-plant-wilt",
      "label": "Sun Plant Wilt",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "arid",
        "droop",
        "drought"
      ],
      "unicode": "e57a"
    },
    {
      "name": "superpowers",
      "label": "Superpowers",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2dd"
    },
    {
      "name": "superscript",
      "label": "Superscript",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "edit",
        "exponential",
        "font",
        "format",
        "text",
        "type"
      ],
      "unicode": "f12b"
    },
    {
      "name": "supple",
      "label": "Supple",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f3f9"
    },
    {
      "name": "suse",
      "label": "Suse",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "linux",
        "operating system",
        "os"
      ],
      "unicode": "f7d6"
    },
    {
      "name": "swatchbook",
      "label": "Swatchbook",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Pantone",
        "color",
        "design",
        "hue",
        "palette"
      ],
      "unicode": "f5c3"
    },
    {
      "name": "swift",
      "label": "Swift",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f8e1"
    },
    {
      "name": "symfony",
      "label": "Symfony",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f83d"
    },
    {
      "name": "synagogue",
      "label": "Synagogue",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "Jew",
        "Jewish",
        "building",
        "jewish",
        "judaism",
        "religion",
        "star of david",
        "synagogue",
        "temple"
      ],
      "unicode": "f69b"
    },
    {
      "name": "syringe",
      "label": "Syringe",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "covid-19",
        "doctor",
        "immunizations",
        "medical",
        "medicine",
        "needle",
        "shot",
        "sick",
        "syringe",
        "vaccinate",
        "vaccine"
      ],
      "unicode": "f48e"
    },
    {
      "name": "t",
      "label": "T",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter T",
        "Latin Small Letter T",
        "letter"
      ],
      "unicode": "54"
    },
    {
      "name": "table",
      "label": "Table",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "category",
        "data",
        "excel",
        "spreadsheet"
      ],
      "unicode": "f0ce"
    },
    {
      "name": "table-cells",
      "label": "Table Cells",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "blocks",
        "boxes",
        "category",
        "excel",
        "grid",
        "spreadsheet",
        "squares"
      ],
      "unicode": "f00a"
    },
    {
      "name": "table-cells-column-lock",
      "label": "Table Cells Column Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "blocks",
        "boxes",
        "category",
        "column",
        "excel",
        "grid",
        "lock",
        "spreadsheet",
        "squares"
      ],
      "unicode": "e678"
    },
    {
      "name": "table-cells-large",
      "label": "Table Cells Large",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "blocks",
        "boxes",
        "category",
        "excel",
        "grid",
        "spreadsheet",
        "squares"
      ],
      "unicode": "f009"
    },
    {
      "name": "table-cells-row-lock",
      "label": "Table Cells Row Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "blocks",
        "boxes",
        "category",
        "column",
        "column",
        "excel",
        "grid",
        "lock",
        "lock",
        "spreadsheet",
        "squares"
      ],
      "unicode": "e67a"
    },
    {
      "name": "table-cells-row-unlock",
      "label": "Table Cells Row Unlock",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "blocks",
        "boxes",
        "category",
        "column",
        "column",
        "excel",
        "grid",
        "lock",
        "lock",
        "spreadsheet",
        "squares",
        "unlock"
      ],
      "unicode": "e691"
    },
    {
      "name": "table-columns",
      "label": "Table Columns",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "browser",
        "category",
        "dashboard",
        "organize",
        "panes",
        "split"
      ],
      "unicode": "f0db"
    },
    {
      "name": "table-list",
      "label": "Table List",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Text & Formatting"
      ],
      "search": [
        "category",
        "cheatsheet",
        "checklist",
        "completed",
        "done",
        "finished",
        "ol",
        "summary",
        "todo",
        "ul"
      ],
      "unicode": "f00b"
    },
    {
      "name": "table-tennis-paddle-ball",
      "label": "Table Tennis Paddle Ball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ball",
        "bat",
        "game",
        "paddle",
        "ping pong",
        "table tennis"
      ],
      "unicode": "f45d"
    },
    {
      "name": "tablet",
      "label": "Tablet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "device",
        "kindle",
        "screen"
      ],
      "unicode": "f3fb"
    },
    {
      "name": "tablet-button",
      "label": "Tablet Button",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "apple",
        "device",
        "ipad",
        "kindle",
        "screen"
      ],
      "unicode": "f10a"
    },
    {
      "name": "tablet-screen-button",
      "label": "Tablet Screen Button",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "apple",
        "device",
        "ipad",
        "kindle",
        "screen"
      ],
      "unicode": "f3fa"
    },
    {
      "name": "tablets",
      "label": "Tablets",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "drugs",
        "medicine",
        "pills",
        "prescription"
      ],
      "unicode": "f490"
    },
    {
      "name": "tachograph-digital",
      "label": "Tachograph Digital",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business"
      ],
      "search": [
        "data",
        "distance",
        "speed",
        "tachometer"
      ],
      "unicode": "f566"
    },
    {
      "name": "tag",
      "label": "Tag",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "discount",
        "labe",
        "label",
        "price",
        "shopping"
      ],
      "unicode": "f02b"
    },
    {
      "name": "tags",
      "label": "Tags",
      "styles": [
        "solid"
      ],
      "categories": [
        "Shopping"
      ],
      "search": [
        "discount",
        "label",
        "price",
        "shopping"
      ],
      "unicode": "f02c"
    },
    {
      "name": "tape",
      "label": "Tape",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "design",
        "package",
        "sticky"
      ],
      "unicode": "f4db"
    },
    {
      "name": "tarp",
      "label": "Tarp",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "protection",
        "tarp",
        "tent",
        "waterproof"
      ],
      "unicode": "e57b"
    },
    {
      "name": "tarp-droplet",
      "label": "Tarp Droplet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "protection",
        "tarp",
        "tent",
        "waterproof"
      ],
      "unicode": "e57c"
    },
    {
      "name": "taxi",
      "label": "Taxi",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "cab",
        "cabbie",
        "car",
        "car service",
        "lyft",
        "machine",
        "oncoming",
        "oncoming taxi",
        "taxi",
        "transportation",
        "travel",
        "uber",
        "vehicle"
      ],
      "unicode": "f1ba"
    },
    {
      "name": "teamspeak",
      "label": "Teamspeak",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f4f9"
    },
    {
      "name": "teeth",
      "label": "Teeth",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bite",
        "dental",
        "dentist",
        "gums",
        "mouth",
        "smile",
        "tooth"
      ],
      "unicode": "f62e"
    },
    {
      "name": "teeth-open",
      "label": "Teeth Open",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "dental",
        "dentist",
        "gums bite",
        "mouth",
        "smile",
        "tooth"
      ],
      "unicode": "f62f"
    },
    {
      "name": "telegram",
      "label": "Telegram",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2c6"
    },
    {
      "name": "temperature-arrow-down",
      "label": "Temperature Arrow Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Weather"
      ],
      "search": [
        "air conditioner",
        "cold",
        "heater",
        "mercury",
        "thermometer",
        "winter"
      ],
      "unicode": "e03f"
    },
    {
      "name": "temperature-arrow-up",
      "label": "Temperature Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Weather"
      ],
      "search": [
        "air conditioner",
        "cold",
        "heater",
        "mercury",
        "thermometer",
        "winter"
      ],
      "unicode": "e040"
    },
    {
      "name": "temperature-empty",
      "label": "Temperature Empty",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cold",
        "mercury",
        "status",
        "temperature"
      ],
      "unicode": "f2cb"
    },
    {
      "name": "temperature-full",
      "label": "Temperature Full",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "fever",
        "hot",
        "mercury",
        "status",
        "temperature"
      ],
      "unicode": "f2c7"
    },
    {
      "name": "temperature-half",
      "label": "Temperature Half",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "mercury",
        "status",
        "temperature",
        "thermometer",
        "weather"
      ],
      "unicode": "f2c9"
    },
    {
      "name": "temperature-high",
      "label": "Temperature High",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cook",
        "covid-19",
        "mercury",
        "summer",
        "thermometer",
        "warm"
      ],
      "unicode": "f769"
    },
    {
      "name": "temperature-low",
      "label": "Temperature Low",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "cold",
        "cool",
        "covid-19",
        "mercury",
        "thermometer",
        "winter"
      ],
      "unicode": "f76b"
    },
    {
      "name": "temperature-quarter",
      "label": "Temperature Quarter",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "mercury",
        "status",
        "temperature"
      ],
      "unicode": "f2ca"
    },
    {
      "name": "temperature-three-quarters",
      "label": "Temperature Three Quarters",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "mercury",
        "status",
        "temperature"
      ],
      "unicode": "f2c8"
    },
    {
      "name": "tencent-weibo",
      "label": "Tencent Weibo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d5"
    },
    {
      "name": "tenge-sign",
      "label": "Tenge Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Tenge Sign",
        "currency"
      ],
      "unicode": "f7d7"
    },
    {
      "name": "tent",
      "label": "Tent",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bivouac",
        "campground",
        "campsite",
        "refugee",
        "shelter",
        "tent"
      ],
      "unicode": "e57d"
    },
    {
      "name": "tent-arrow-down-to-line",
      "label": "Tent Arrow Down To Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "bivouac",
        "campground",
        "campsite",
        "permanent",
        "refugee",
        "refugee",
        "shelter",
        "shelter",
        "tent"
      ],
      "unicode": "e57e"
    },
    {
      "name": "tent-arrow-left-right",
      "label": "Tent Arrow Left Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "bivouac",
        "campground",
        "campsite",
        "refugee",
        "refugee",
        "shelter",
        "shelter",
        "tent",
        "transition"
      ],
      "unicode": "e57f"
    },
    {
      "name": "tent-arrow-turn-left",
      "label": "Tent Arrow Turn Left",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "bivouac",
        "campground",
        "campsite",
        "refugee",
        "refugee",
        "shelter",
        "shelter",
        "temporary",
        "tent"
      ],
      "unicode": "e580"
    },
    {
      "name": "tent-arrows-down",
      "label": "Tent Arrows Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "bivouac",
        "campground",
        "campsite",
        "insert",
        "refugee",
        "refugee",
        "shelter",
        "shelter",
        "spontaneous",
        "tent"
      ],
      "unicode": "e581"
    },
    {
      "name": "tents",
      "label": "Tents",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bivouac",
        "bivouac",
        "campground",
        "campground",
        "campsite",
        "refugee",
        "refugee",
        "shelter",
        "shelter",
        "tent",
        "tent"
      ],
      "unicode": "e582"
    },
    {
      "name": "terminal",
      "label": "Terminal",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "code",
        "coding",
        "command",
        "console",
        "development",
        "prompt",
        "terminal"
      ],
      "unicode": "f120"
    },
    {
      "name": "text-height",
      "label": "Text Height",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "edit",
        "font",
        "format",
        "modify",
        "text",
        "type"
      ],
      "unicode": "f034"
    },
    {
      "name": "text-slash",
      "label": "Text Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting"
      ],
      "search": [
        "cancel",
        "disabled",
        "font",
        "format",
        "remove",
        "style",
        "text"
      ],
      "unicode": "f87d"
    },
    {
      "name": "text-width",
      "label": "Text Width",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "edit",
        "font",
        "format",
        "modify",
        "text",
        "type"
      ],
      "unicode": "f035"
    },
    {
      "name": "the-red-yeti",
      "label": "The Red Yeti",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f69d"
    },
    {
      "name": "themeco",
      "label": "Themeco",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5c6"
    },
    {
      "name": "themeisle",
      "label": "ThemeIsle",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2b2"
    },
    {
      "name": "thermometer",
      "label": "Thermometer",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "covid-19",
        "mercury",
        "status",
        "temperature"
      ],
      "unicode": "f491"
    },
    {
      "name": "think-peaks",
      "label": "Think Peaks",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f731"
    },
    {
      "name": "threads",
      "label": "Threads",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "social network"
      ],
      "unicode": "e618"
    },
    {
      "name": "thumbs-down",
      "label": "Thumbs Down",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "-1",
        "disagree",
        "disapprove",
        "dislike",
        "down",
        "hand",
        "social",
        "thumb",
        "thumbs down",
        "thumbs-o-down"
      ],
      "unicode": "f165"
    },
    {
      "name": "thumbs-up",
      "label": "Thumbs Up",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "+1",
        "agree",
        "approve",
        "favorite",
        "hand",
        "like",
        "ok",
        "okay",
        "social",
        "success",
        "thumb",
        "thumbs up",
        "thumbs-o-up",
        "up",
        "yes",
        "you got it dude"
      ],
      "unicode": "f164"
    },
    {
      "name": "thumbtack",
      "label": "Thumbtack",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Black Pushpin",
        "coordinates",
        "location",
        "marker",
        "pin",
        "pushpin",
        "thumb-tack"
      ],
      "unicode": "f08d"
    },
    {
      "name": "thumbtack-slash",
      "label": "Thumbtack Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Black Pushpin",
        "coordinates",
        "location",
        "marker",
        "pin",
        "pushpin",
        "thumb-tack",
        "unpin"
      ],
      "unicode": "e68f"
    },
    {
      "name": "ticket",
      "label": "Ticket",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "admission",
        "admission tickets",
        "coupon",
        "movie",
        "pass",
        "support",
        "ticket",
        "voucher"
      ],
      "unicode": "f145"
    },
    {
      "name": "ticket-simple",
      "label": "Ticket Simple",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "admission",
        "coupon",
        "movie",
        "pass",
        "support",
        "ticket",
        "voucher"
      ],
      "unicode": "f3ff"
    },
    {
      "name": "tiktok",
      "label": "TikTok",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e07b"
    },
    {
      "name": "timeline",
      "label": "Timeline",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "chronological",
        "deadline",
        "history",
        "linear"
      ],
      "unicode": "e29c"
    },
    {
      "name": "toggle-off",
      "label": "Toggle Off",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "button",
        "off",
        "on",
        "switch"
      ],
      "unicode": "f204"
    },
    {
      "name": "toggle-on",
      "label": "Toggle On",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "button",
        "off",
        "on",
        "switch"
      ],
      "unicode": "f205"
    },
    {
      "name": "toilet",
      "label": "Toilet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bathroom",
        "flush",
        "john",
        "loo",
        "pee",
        "plumbing",
        "poop",
        "porcelain",
        "potty",
        "restroom",
        "throne",
        "toile",
        "toilet",
        "washroom",
        "waste",
        "wc"
      ],
      "unicode": "f7d8"
    },
    {
      "name": "toilet-paper",
      "label": "Toilet Paper",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bathroom",
        "covid-19",
        "halloween",
        "holiday",
        "lavatory",
        "paper towels",
        "prank",
        "privy",
        "restroom",
        "roll",
        "roll of paper",
        "toilet",
        "toilet paper",
        "wipe"
      ],
      "unicode": "f71e"
    },
    {
      "name": "toilet-paper-slash",
      "label": "Toilet Paper Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bathroom",
        "covid-19",
        "disabled",
        "halloween",
        "holiday",
        "lavatory",
        "leaves",
        "prank",
        "privy",
        "restroom",
        "roll",
        "toilet",
        "trouble",
        "ut oh",
        "wipe"
      ],
      "unicode": "e072"
    },
    {
      "name": "toilet-portable",
      "label": "Toilet Portable",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "outhouse",
        "toilet"
      ],
      "unicode": "e583"
    },
    {
      "name": "toilets-portable",
      "label": "Toilets Portable",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "outhouse",
        "toilet"
      ],
      "unicode": "e584"
    },
    {
      "name": "toolbox",
      "label": "Toolbox",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "admin",
        "chest",
        "configuration",
        "container",
        "equipment",
        "fix",
        "maintenance",
        "mechanic",
        "modify",
        "repair",
        "settings",
        "tool",
        "toolbox",
        "tools"
      ],
      "unicode": "f552"
    },
    {
      "name": "tooth",
      "label": "Tooth",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bicuspid",
        "dental",
        "dentist",
        "molar",
        "mouth",
        "teeth",
        "tooth"
      ],
      "unicode": "f5c9"
    },
    {
      "name": "torii-gate",
      "label": "Torii Gate",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "religion",
        "shinto",
        "shinto shrine",
        "shintoism",
        "shrine"
      ],
      "unicode": "f6a1"
    },
    {
      "name": "tornado",
      "label": "Tornado",
      "styles": [
        "solid"
      ],
      "categories": [
        "Text & Formatting",
        "Weather"
      ],
      "search": [
        "cloud",
        "cyclone",
        "dorothy",
        "landspout",
        "tornado",
        "toto",
        "twister",
        "vortext",
        "waterspout",
        "weather",
        "whirlwind"
      ],
      "unicode": "f76f"
    },
    {
      "name": "tower-broadcast",
      "label": "Tower Broadcast",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "airwaves",
        "antenna",
        "communication",
        "emergency",
        "radio",
        "reception",
        "signal",
        "waves"
      ],
      "unicode": "f519"
    },
    {
      "name": "tower-cell",
      "label": "Tower Cell",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "airwaves",
        "antenna",
        "communication",
        "radio",
        "reception",
        "signal",
        "waves"
      ],
      "unicode": "e585"
    },
    {
      "name": "tower-observation",
      "label": "Tower Observation",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "fire tower",
        "view"
      ],
      "unicode": "e586"
    },
    {
      "name": "tractor",
      "label": "Tractor",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "agriculture",
        "farm",
        "tractor",
        "vehicle"
      ],
      "unicode": "f722"
    },
    {
      "name": "trade-federation",
      "label": "Trade Federation",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f513"
    },
    {
      "name": "trademark",
      "label": "Trademark",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "copyright",
        "mark",
        "register",
        "symbol",
        "tm",
        "trade mark",
        "trademark"
      ],
      "unicode": "f25c"
    },
    {
      "name": "traffic-light",
      "label": "Traffic Light",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Media"
      ],
      "search": [
        "direction",
        "go",
        "light",
        "road",
        "signal",
        "slow",
        "stop",
        "traffic",
        "travel",
        "vertical traffic light"
      ],
      "unicode": "f637"
    },
    {
      "name": "trailer",
      "label": "Trailer",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "carry",
        "haul",
        "moving",
        "travel"
      ],
      "unicode": "e041"
    },
    {
      "name": "train",
      "label": "Train",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation",
        "Weather"
      ],
      "search": [
        "bullet",
        "commute",
        "locomotive",
        "railway",
        "subway",
        "train"
      ],
      "unicode": "f238"
    },
    {
      "name": "train-subway",
      "label": "Train Subway",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation",
        "Weather"
      ],
      "search": [
        "machine",
        "railway",
        "train",
        "transportation",
        "vehicle"
      ],
      "unicode": "f239"
    },
    {
      "name": "train-tram",
      "label": "Train Tram",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation",
        "Weather"
      ],
      "search": [
        "crossing",
        "machine",
        "mountains",
        "seasonal",
        "tram",
        "transportation",
        "trolleybus"
      ],
      "unicode": "e5b4"
    },
    {
      "name": "transgender",
      "label": "Transgender",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "female",
        "gender",
        "intersex",
        "male",
        "transgender",
        "transgender symbol"
      ],
      "unicode": "f225"
    },
    {
      "name": "trash",
      "label": "Trash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Shopping"
      ],
      "search": [
        "delete",
        "garbage",
        "hide",
        "remove"
      ],
      "unicode": "f1f8"
    },
    {
      "name": "trash-arrow-up",
      "label": "Trash Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Shopping"
      ],
      "search": [
        "back",
        "control z",
        "delete",
        "garbage",
        "hide",
        "oops",
        "remove",
        "undo",
        "upgrade"
      ],
      "unicode": "f829"
    },
    {
      "name": "trash-can",
      "label": "Trash Can",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Actions",
        "Shopping"
      ],
      "search": [
        "delete",
        "garbage",
        "hide",
        "remove",
        "trash-o"
      ],
      "unicode": "f2ed"
    },
    {
      "name": "trash-can-arrow-up",
      "label": "Trash Can Arrow Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions",
        "Shopping"
      ],
      "search": [
        "back",
        "control z",
        "delete",
        "garbage",
        "hide",
        "oops",
        "remove",
        "undo",
        "upgrade"
      ],
      "unicode": "f82a"
    },
    {
      "name": "tree",
      "label": "Tree",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bark",
        "evergreen tree",
        "fall",
        "flora",
        "forest",
        "investment",
        "nature",
        "plant",
        "seasonal",
        "tree"
      ],
      "unicode": "f1bb"
    },
    {
      "name": "tree-city",
      "label": "Tree City",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business"
      ],
      "search": [
        "building",
        "city",
        "urban"
      ],
      "unicode": "e587"
    },
    {
      "name": "trello",
      "label": "Trello",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "atlassian"
      ],
      "unicode": "f181"
    },
    {
      "name": "triangle-exclamation",
      "label": "Triangle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Status & Alerts"
      ],
      "search": [
        "alert",
        "attention",
        "danger",
        "error",
        "failed",
        "important",
        "notice",
        "notification",
        "notify",
        "problem",
        "required",
        "warnin",
        "warning"
      ],
      "unicode": "f071"
    },
    {
      "name": "trophy",
      "label": "Trophy",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "achievement",
        "award",
        "cup",
        "game",
        "prize",
        "trophy",
        "winner"
      ],
      "unicode": "f091"
    },
    {
      "name": "trowel",
      "label": "Trowel",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "build",
        "construction",
        "equipment",
        "maintenance",
        "tool"
      ],
      "unicode": "e589"
    },
    {
      "name": "trowel-bricks",
      "label": "Trowel Bricks",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "build",
        "construction",
        "maintenance",
        "reconstruction",
        "tool"
      ],
      "unicode": "e58a"
    },
    {
      "name": "truck",
      "label": "Truck",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "Black Truck",
        "cargo",
        "delivery",
        "delivery truck",
        "shipping",
        "truck",
        "vehicle"
      ],
      "unicode": "f0d1"
    },
    {
      "name": "truck-arrow-right",
      "label": "Truck Arrow Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Transportation"
      ],
      "search": [
        "access",
        "fast",
        "shipping",
        "transport"
      ],
      "unicode": "e58b"
    },
    {
      "name": "truck-droplet",
      "label": "Truck Droplet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "blood",
        "thirst",
        "truck",
        "water",
        "water supply"
      ],
      "unicode": "e58c"
    },
    {
      "name": "truck-fast",
      "label": "Truck Fast",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Transportation"
      ],
      "search": [
        "express",
        "fedex",
        "mail",
        "overnight",
        "package",
        "quick",
        "ups"
      ],
      "unicode": "f48b"
    },
    {
      "name": "truck-field",
      "label": "Truck Field",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "supplies",
        "truck"
      ],
      "unicode": "e58d"
    },
    {
      "name": "truck-field-un",
      "label": "Truck Field Un",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "supplies",
        "truck",
        "united nations"
      ],
      "unicode": "e58e"
    },
    {
      "name": "truck-front",
      "label": "Truck Front",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "shuttle",
        "truck",
        "van"
      ],
      "unicode": "e2b7"
    },
    {
      "name": "truck-medical",
      "label": "Truck Medical",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "ambulance",
        "clinic",
        "covid-19",
        "emergency",
        "emt",
        "er",
        "help",
        "hospital",
        "mobile",
        "support",
        "vehicle"
      ],
      "unicode": "f0f9"
    },
    {
      "name": "truck-monster",
      "label": "Truck Monster",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "offroad",
        "vehicle",
        "wheel"
      ],
      "unicode": "f63b"
    },
    {
      "name": "truck-moving",
      "label": "Truck Moving",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "cargo",
        "inventory",
        "rental",
        "vehicle"
      ],
      "unicode": "f4df"
    },
    {
      "name": "truck-pickup",
      "label": "Truck Pickup",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "cargo",
        "maintenance",
        "pick-up",
        "pickup",
        "pickup truck",
        "truck",
        "vehicle"
      ],
      "unicode": "f63c"
    },
    {
      "name": "truck-plane",
      "label": "Truck Plane",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "airplane",
        "plane",
        "transportation",
        "truck",
        "vehicle"
      ],
      "unicode": "e58f"
    },
    {
      "name": "truck-ramp-box",
      "label": "Truck Ramp Box",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "box",
        "cargo",
        "delivery",
        "inventory",
        "moving",
        "rental",
        "vehicle"
      ],
      "unicode": "f4de"
    },
    {
      "name": "tty",
      "label": "Tty",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication",
        "Text & Formatting"
      ],
      "search": [
        "communication",
        "deaf",
        "telephone",
        "teletypewriter",
        "text"
      ],
      "unicode": "f1e4"
    },
    {
      "name": "tumblr",
      "label": "Tumblr",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f173"
    },
    {
      "name": "turkish-lira-sign",
      "label": "Turkish Lira Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Turkish Lira Sign",
        "currency"
      ],
      "unicode": "e2bb"
    },
    {
      "name": "turn-down",
      "label": "Turn Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "down",
        "level-down",
        "right arrow curving down"
      ],
      "unicode": "f3be"
    },
    {
      "name": "turn-up",
      "label": "Turn Up",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "level-up",
        "right arrow curving up"
      ],
      "unicode": "f3bf"
    },
    {
      "name": "tv",
      "label": "Tv",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "computer",
        "display",
        "monitor",
        "television"
      ],
      "unicode": "f26c"
    },
    {
      "name": "twitch",
      "label": "Twitch",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1e8"
    },
    {
      "name": "twitter",
      "label": "Twitter",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "social network",
        "tweet"
      ],
      "unicode": "f099"
    },
    {
      "name": "typo3",
      "label": "Typo3",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f42b"
    },
    {
      "name": "u",
      "label": "U",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter U",
        "Latin Small Letter U",
        "letter"
      ],
      "unicode": "55"
    },
    {
      "name": "uber",
      "label": "Uber",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f402"
    },
    {
      "name": "ubuntu",
      "label": "Ubuntu",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "linux",
        "operating system",
        "os"
      ],
      "unicode": "f7df"
    },
    {
      "name": "uikit",
      "label": "UIkit",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f403"
    },
    {
      "name": "umbraco",
      "label": "Umbraco",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f8e8"
    },
    {
      "name": "umbrella",
      "label": "Umbrella",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "protection",
        "rain",
        "storm",
        "wet"
      ],
      "unicode": "f0e9"
    },
    {
      "name": "umbrella-beach",
      "label": "Umbrella Beach",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "beach",
        "beach with umbrella",
        "protection",
        "recreation",
        "sand",
        "shade",
        "summer",
        "sun",
        "umbrella"
      ],
      "unicode": "f5ca"
    },
    {
      "name": "uncharted",
      "label": "Uncharted Software",
      "styles": [
        "brands"
      ],
      "categories": [
        "Business"
      ],
      "search": [],
      "unicode": "e084"
    },
    {
      "name": "underline",
      "label": "Underline",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Text & Formatting"
      ],
      "search": [
        "edit",
        "emphasis",
        "format",
        "modify",
        "text",
        "writing"
      ],
      "unicode": "f0cd"
    },
    {
      "name": "uniregistry",
      "label": "Uniregistry",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f404"
    },
    {
      "name": "unity",
      "label": "Unity 3D",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e049"
    },
    {
      "name": "universal-access",
      "label": "Universal Access",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "uer",
        "users-people"
      ],
      "unicode": "f29a"
    },
    {
      "name": "unlock",
      "label": "Unlock",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions",
        "Security"
      ],
      "search": [
        "admin",
        "lock",
        "open",
        "padlock",
        "password",
        "privacy",
        "private",
        "protect",
        "unlock",
        "unlocked"
      ],
      "unicode": "f09c"
    },
    {
      "name": "unlock-keyhole",
      "label": "Unlock Keyhole",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "admin",
        "lock",
        "padlock",
        "password",
        "privacy",
        "private",
        "protect"
      ],
      "unicode": "f13e"
    },
    {
      "name": "unsplash",
      "label": "Unsplash",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e07c"
    },
    {
      "name": "untappd",
      "label": "Untappd",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f405"
    },
    {
      "name": "up-down",
      "label": "Up Down",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "Up Down Black Arrow",
        "arrow",
        "arrows-v",
        "expand",
        "portrait",
        "resize",
        "tall",
        "up-down arrow",
        "vertical"
      ],
      "unicode": "f338"
    },
    {
      "name": "up-down-left-right",
      "label": "Up Down Left Right",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrow",
        "arrows",
        "bigger",
        "enlarge",
        "expand",
        "fullscreen",
        "move",
        "position",
        "reorder",
        "resize"
      ],
      "unicode": "f0b2"
    },
    {
      "name": "up-long",
      "label": "Up Long",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation",
        "Actions"
      ],
      "search": [
        "long-arrow-up",
        "upgrade",
        "upload"
      ],
      "unicode": "f30c"
    },
    {
      "name": "up-right-and-down-left-from-center",
      "label": "Up Right And Down Left From Center",
      "styles": [
        "solid"
      ],
      "categories": [
        "Navigation"
      ],
      "search": [
        "arrows",
        "bigger",
        "enlarge",
        "expand",
        "fullscreen",
        "maximize",
        "resize",
        "resize",
        "scale",
        "size"
      ],
      "unicode": "f424"
    },
    {
      "name": "up-right-from-square",
      "label": "Up Right From Square",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "external-link",
        "new",
        "open",
        "share",
        "upgrade"
      ],
      "unicode": "f35d"
    },
    {
      "name": "upload",
      "label": "Upload",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "hard drive",
        "import",
        "publish",
        "upgrade"
      ],
      "unicode": "f093"
    },
    {
      "name": "ups",
      "label": "UPS",
      "styles": [
        "brands"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "United Parcel Service",
        "package",
        "shipping"
      ],
      "unicode": "f7e0"
    },
    {
      "name": "upwork",
      "label": "Upwork",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e641"
    },
    {
      "name": "usb",
      "label": "USB",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f287"
    },
    {
      "name": "user",
      "label": "User",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "UI & Interface",
        "Files & Folders",
        "Transportation"
      ],
      "search": [
        "adult",
        "bust",
        "bust in silhouette",
        "default",
        "employee",
        "gender-neutral",
        "person",
        "profile",
        "silhouette",
        "uer",
        "unspecified gender",
        "username",
        "users-people"
      ],
      "unicode": "f007"
    },
    {
      "name": "user-astronaut",
      "label": "User Astronaut",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "avatar",
        "clothing",
        "cosmonaut",
        "nasa",
        "space",
        "suit",
        "uer"
      ],
      "unicode": "f4fb"
    },
    {
      "name": "user-check",
      "label": "User Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "employee",
        "enable",
        "uer",
        "users-people",
        "validate",
        "working"
      ],
      "unicode": "f4fc"
    },
    {
      "name": "user-clock",
      "label": "User Clock",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Business",
        "Security"
      ],
      "search": [
        "employee",
        "uer",
        "users-people"
      ],
      "unicode": "f4fd"
    },
    {
      "name": "user-doctor",
      "label": "User Doctor",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Files & Folders"
      ],
      "search": [
        "covid-19",
        "health",
        "job",
        "medical",
        "nurse",
        "occupation",
        "physician",
        "profile",
        "surgeon",
        "uer",
        "worker"
      ],
      "unicode": "f0f0"
    },
    {
      "name": "user-gear",
      "label": "User Gear",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "employee",
        "together",
        "uer",
        "users-people"
      ],
      "unicode": "f4fe"
    },
    {
      "name": "user-graduate",
      "label": "User Graduate",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "uer",
        "users-people"
      ],
      "unicode": "f501"
    },
    {
      "name": "user-group",
      "label": "User Group",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "bust",
        "busts in silhouette",
        "crowd",
        "employee",
        "silhouette",
        "together",
        "uer",
        "users-people"
      ],
      "unicode": "f500"
    },
    {
      "name": "user-injured",
      "label": "User Injured",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "employee",
        "uer",
        "users-people"
      ],
      "unicode": "f728"
    },
    {
      "name": "user-large",
      "label": "User Large",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "employee",
        "uer",
        "users-people"
      ],
      "unicode": "f406"
    },
    {
      "name": "user-large-slash",
      "label": "User Large Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "disabled",
        "disconnect",
        "employee",
        "uer",
        "users-people"
      ],
      "unicode": "f4fa"
    },
    {
      "name": "user-lock",
      "label": "User Lock",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "employee",
        "padlock",
        "privacy",
        "uer",
        "users-people"
      ],
      "unicode": "f502"
    },
    {
      "name": "user-minus",
      "label": "User Minus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "delete",
        "employee",
        "negative",
        "remove",
        "uer"
      ],
      "unicode": "f503"
    },
    {
      "name": "user-ninja",
      "label": "User Ninja",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "assassin",
        "avatar",
        "dangerous",
        "deadly",
        "fighter",
        "hidden",
        "ninja",
        "sneaky",
        "stealth",
        "uer"
      ],
      "unicode": "f504"
    },
    {
      "name": "user-nurse",
      "label": "User Nurse",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "covid-19",
        "doctor",
        "health",
        "md",
        "medical",
        "midwife",
        "physician",
        "practitioner",
        "surgeon",
        "uer",
        "worker"
      ],
      "unicode": "f82f"
    },
    {
      "name": "user-pen",
      "label": "User Pen",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "employee",
        "modify",
        "uer",
        "users-people"
      ],
      "unicode": "f4ff"
    },
    {
      "name": "user-plus",
      "label": "User Plus",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Actions"
      ],
      "search": [
        "add",
        "avatar",
        "employee",
        "follow",
        "positive",
        "sign up",
        "signup",
        "team",
        "uer"
      ],
      "unicode": "f234"
    },
    {
      "name": "user-secret",
      "label": "User Secret",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "detective",
        "sleuth",
        "spy",
        "uer",
        "users-people"
      ],
      "unicode": "f21b"
    },
    {
      "name": "user-shield",
      "label": "User Shield",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Security"
      ],
      "search": [
        "employee",
        "protect",
        "safety",
        "uer"
      ],
      "unicode": "f505"
    },
    {
      "name": "user-slash",
      "label": "User Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Actions"
      ],
      "search": [
        "ban",
        "delete",
        "deny",
        "disabled",
        "disconnect",
        "employee",
        "remove",
        "uer"
      ],
      "unicode": "f506"
    },
    {
      "name": "user-tag",
      "label": "User Tag",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Shopping"
      ],
      "search": [
        "employee",
        "uer",
        "users-people"
      ],
      "unicode": "f507"
    },
    {
      "name": "user-tie",
      "label": "User Tie",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Transportation"
      ],
      "search": [
        "administrator",
        "avatar",
        "business",
        "clothing",
        "employee",
        "formal",
        "offer",
        "portfolio",
        "professional",
        "suit",
        "uer"
      ],
      "unicode": "f508"
    },
    {
      "name": "user-xmark",
      "label": "User Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts",
        "Actions",
        "Files & Folders"
      ],
      "search": [
        "archive",
        "delete",
        "employee",
        "remove",
        "uer",
        "uncheck",
        "x"
      ],
      "unicode": "f235"
    },
    {
      "name": "users",
      "label": "Users",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "employee",
        "together",
        "uer",
        "users-people"
      ],
      "unicode": "f0c0"
    },
    {
      "name": "users-between-lines",
      "label": "Users Between Lines",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "covered",
        "crowd",
        "employee",
        "group",
        "people",
        "together",
        "uer"
      ],
      "unicode": "e591"
    },
    {
      "name": "users-gear",
      "label": "Users Gear",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "employee",
        "uer",
        "users-people"
      ],
      "unicode": "f509"
    },
    {
      "name": "users-line",
      "label": "Users Line",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "crowd",
        "employee",
        "group",
        "need",
        "people",
        "together",
        "uer"
      ],
      "unicode": "e592"
    },
    {
      "name": "users-rays",
      "label": "Users Rays",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "affected",
        "crowd",
        "employee",
        "focused",
        "group",
        "people",
        "uer"
      ],
      "unicode": "e593"
    },
    {
      "name": "users-rectangle",
      "label": "Users Rectangle",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Navigation"
      ],
      "search": [
        "crowd",
        "employee",
        "focus",
        "group",
        "people",
        "reached",
        "uer"
      ],
      "unicode": "e594"
    },
    {
      "name": "users-slash",
      "label": "Users Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "disabled",
        "disconnect",
        "employee",
        "together",
        "uer",
        "users-people"
      ],
      "unicode": "e073"
    },
    {
      "name": "users-viewfinder",
      "label": "Users Viewfinder",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "crowd",
        "focus",
        "group",
        "people",
        "targeted",
        "uer"
      ],
      "unicode": "e595"
    },
    {
      "name": "usps",
      "label": "United States Postal Service",
      "styles": [
        "brands"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "american",
        "package",
        "shipping",
        "usa"
      ],
      "unicode": "f7e1"
    },
    {
      "name": "ussunnah",
      "label": "us-Sunnah Foundation",
      "styles": [
        "brands"
      ],
      "categories": [
        "Weather"
      ],
      "search": [],
      "unicode": "f407"
    },
    {
      "name": "utensils",
      "label": "Utensils",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "cooking",
        "cutlery",
        "dining",
        "dinner",
        "eat",
        "food",
        "fork",
        "fork and knife",
        "knife",
        "restaurant"
      ],
      "unicode": "f2e7"
    },
    {
      "name": "v",
      "label": "V",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter V",
        "Latin Small Letter V",
        "letter"
      ],
      "unicode": "56"
    },
    {
      "name": "vaadin",
      "label": "Vaadin",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f408"
    },
    {
      "name": "van-shuttle",
      "label": "Van Shuttle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Transportation"
      ],
      "search": [
        "airport",
        "bus",
        "machine",
        "minibus",
        "public-transportation",
        "transportation",
        "travel",
        "vehicle"
      ],
      "unicode": "f5b6"
    },
    {
      "name": "vault",
      "label": "Vault",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Business",
        "Security"
      ],
      "search": [
        "bank",
        "important",
        "investment",
        "lock",
        "money",
        "premium",
        "privacy",
        "safe",
        "salary"
      ],
      "unicode": "e2c5"
    },
    {
      "name": "vector-square",
      "label": "Vector Square",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "anchors",
        "lines",
        "object",
        "render",
        "shape"
      ],
      "unicode": "f5cb"
    },
    {
      "name": "venus",
      "label": "Venus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "female",
        "female sign",
        "gender",
        "woman"
      ],
      "unicode": "f221"
    },
    {
      "name": "venus-double",
      "label": "Venus Double",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Doubled Female Sign",
        "female",
        "gender",
        "lesbian"
      ],
      "unicode": "f226"
    },
    {
      "name": "venus-mars",
      "label": "Venus Mars",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "Interlocked Female and Male Sign",
        "female",
        "gender",
        "heterosexual",
        "male"
      ],
      "unicode": "f228"
    },
    {
      "name": "vest",
      "label": "Vest",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "biker",
        "fashion",
        "style"
      ],
      "unicode": "e085"
    },
    {
      "name": "vest-patches",
      "label": "Vest Patches",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "biker",
        "fashion",
        "style"
      ],
      "unicode": "e086"
    },
    {
      "name": "viacoin",
      "label": "Viacoin",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f237"
    },
    {
      "name": "viadeo",
      "label": "Viadeo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2a9"
    },
    {
      "name": "vial",
      "label": "Vial",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ampule",
        "chemist",
        "chemistry",
        "experiment",
        "knowledge",
        "lab",
        "sample",
        "science",
        "test",
        "test tube"
      ],
      "unicode": "f492"
    },
    {
      "name": "vial-circle-check",
      "label": "Vial Circle Check",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "ampule",
        "chemist",
        "chemistry",
        "enable",
        "not affected",
        "ok",
        "okay",
        "success",
        "test tube",
        "tube",
        "vaccine",
        "validate",
        "working"
      ],
      "unicode": "e596"
    },
    {
      "name": "vial-virus",
      "label": "Vial Virus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ampule",
        "coronavirus",
        "covid-19",
        "flue",
        "infection",
        "lab",
        "laboratory",
        "pandemic",
        "test",
        "test tube",
        "vaccine"
      ],
      "unicode": "e597"
    },
    {
      "name": "vials",
      "label": "Vials",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ampule",
        "experiment",
        "knowledge",
        "lab",
        "sample",
        "science",
        "test",
        "test tube"
      ],
      "unicode": "f493"
    },
    {
      "name": "viber",
      "label": "Viber",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f409"
    },
    {
      "name": "video",
      "label": "Video",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "camera",
        "film",
        "movie",
        "record",
        "video-camera"
      ],
      "unicode": "f03d"
    },
    {
      "name": "video-slash",
      "label": "Video Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "add",
        "create",
        "disabled",
        "disconnect",
        "film",
        "new",
        "positive",
        "record",
        "video"
      ],
      "unicode": "f4e2"
    },
    {
      "name": "vihara",
      "label": "Vihara",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "buddhism",
        "buddhist",
        "building",
        "monastery"
      ],
      "unicode": "f6a7"
    },
    {
      "name": "vimeo",
      "label": "Vimeo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f40a"
    },
    {
      "name": "vimeo-v",
      "label": "Vimeo V",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "vimeo"
      ],
      "unicode": "f27d"
    },
    {
      "name": "vine",
      "label": "Vine",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1ca"
    },
    {
      "name": "virus",
      "label": "Virus",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bug",
        "coronavirus",
        "covid-19",
        "flu",
        "health",
        "infection",
        "pandemic",
        "sick",
        "vaccine",
        "viral"
      ],
      "unicode": "e074"
    },
    {
      "name": "virus-covid",
      "label": "Virus Covid",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bug",
        "covid-19",
        "flu",
        "health",
        "infection",
        "pandemic",
        "vaccine",
        "viral",
        "virus"
      ],
      "unicode": "e4a8"
    },
    {
      "name": "virus-covid-slash",
      "label": "Virus Covid Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bug",
        "covid-19",
        "disabled",
        "flu",
        "health",
        "infection",
        "pandemic",
        "vaccine",
        "viral",
        "virus"
      ],
      "unicode": "e4a9"
    },
    {
      "name": "virus-slash",
      "label": "Virus Slash",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bug",
        "coronavirus",
        "covid-19",
        "cure",
        "disabled",
        "eliminate",
        "flu",
        "health",
        "infection",
        "pandemic",
        "sick",
        "vaccine",
        "viral"
      ],
      "unicode": "e075"
    },
    {
      "name": "viruses",
      "label": "Viruses",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "bugs",
        "coronavirus",
        "covid-19",
        "flu",
        "health",
        "infection",
        "multiply",
        "pandemic",
        "sick",
        "spread",
        "vaccine",
        "viral"
      ],
      "unicode": "e076"
    },
    {
      "name": "vk",
      "label": "VK",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f189"
    },
    {
      "name": "vnv",
      "label": "VNV",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f40b"
    },
    {
      "name": "voicemail",
      "label": "Voicemail",
      "styles": [
        "solid"
      ],
      "categories": [
        "Communication"
      ],
      "search": [
        "answer",
        "inbox",
        "message",
        "phone"
      ],
      "unicode": "f897"
    },
    {
      "name": "volcano",
      "label": "Volcano",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "caldera",
        "eruption",
        "lava",
        "magma",
        "mountain",
        "smoke",
        "volcano"
      ],
      "unicode": "f770"
    },
    {
      "name": "volleyball",
      "label": "Volleyball",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ball",
        "beach",
        "game",
        "olympics",
        "sport",
        "volleyball"
      ],
      "unicode": "f45f"
    },
    {
      "name": "volume-high",
      "label": "Volume High",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "audio",
        "higher",
        "loud",
        "louder",
        "music",
        "sound",
        "speaker",
        "speaker high volume"
      ],
      "unicode": "f028"
    },
    {
      "name": "volume-low",
      "label": "Volume Low",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "audio",
        "lower",
        "music",
        "quieter",
        "soft",
        "sound",
        "speaker",
        "speaker low volume"
      ],
      "unicode": "f027"
    },
    {
      "name": "volume-off",
      "label": "Volume Off",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts",
        "Media"
      ],
      "search": [
        "audio",
        "ban",
        "music",
        "mute",
        "quiet",
        "silent",
        "sound"
      ],
      "unicode": "f026"
    },
    {
      "name": "volume-xmark",
      "label": "Volume Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "audio",
        "music",
        "quiet",
        "sound",
        "speaker"
      ],
      "unicode": "f6a9"
    },
    {
      "name": "vr-cardboard",
      "label": "Vr Cardboard",
      "styles": [
        "solid"
      ],
      "categories": [
        "Social & Brands",
        "Transportation"
      ],
      "search": [
        "3d",
        "augment",
        "google",
        "reality",
        "virtual"
      ],
      "unicode": "f729"
    },
    {
      "name": "vuejs",
      "label": "Vue.js",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f41f"
    },
    {
      "name": "w",
      "label": "W",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter W",
        "Latin Small Letter W",
        "letter"
      ],
      "unicode": "57"
    },
    {
      "name": "walkie-talkie",
      "label": "Walkie Talkie",
      "styles": [
        "solid"
      ],
      "categories": [
        "Actions"
      ],
      "search": [
        "communication",
        "copy",
        "intercom",
        "over",
        "portable",
        "radio",
        "two way radio"
      ],
      "unicode": "f8ef"
    },
    {
      "name": "wallet",
      "label": "Wallet",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "billfold",
        "cash",
        "currency",
        "money",
        "salary"
      ],
      "unicode": "f555"
    },
    {
      "name": "wand-magic",
      "label": "Wand Magic",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "autocomplete",
        "automatic",
        "mage",
        "magic",
        "spell",
        "wand",
        "witch",
        "wizard"
      ],
      "unicode": "f0d0"
    },
    {
      "name": "wand-magic-sparkles",
      "label": "Wand Magic Sparkles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "auto",
        "magic",
        "magic wand",
        "trick",
        "witch",
        "wizard"
      ],
      "unicode": "e2ca"
    },
    {
      "name": "wand-sparkles",
      "label": "Wand Sparkles",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "autocomplete",
        "automatic",
        "fantasy",
        "halloween",
        "holiday",
        "magic",
        "weapon",
        "witch",
        "wizard"
      ],
      "unicode": "f72b"
    },
    {
      "name": "warehouse",
      "label": "Warehouse",
      "styles": [
        "solid"
      ],
      "categories": [
        "Business"
      ],
      "search": [
        "building",
        "capacity",
        "garage",
        "inventory",
        "storage"
      ],
      "unicode": "f494"
    },
    {
      "name": "watchman-monitoring",
      "label": "Watchman Monitoring",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e087"
    },
    {
      "name": "water",
      "label": "Water",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "lake",
        "liquid",
        "ocean",
        "sea",
        "swim",
        "wet"
      ],
      "unicode": "f773"
    },
    {
      "name": "water-ladder",
      "label": "Water Ladder",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "ladder",
        "recreation",
        "swim",
        "water"
      ],
      "unicode": "f5c5"
    },
    {
      "name": "wave-square",
      "label": "Wave Square",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "frequency",
        "pulse",
        "signal"
      ],
      "unicode": "f83e"
    },
    {
      "name": "waze",
      "label": "Waze",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f83f"
    },
    {
      "name": "web-awesome",
      "label": "Web Awesome",
      "styles": [
        "solid",
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "awesome",
        "coding",
        "components",
        "crown",
        "web"
      ],
      "unicode": "e682"
    },
    {
      "name": "webflow",
      "label": "Webflow",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e65c"
    },
    {
      "name": "weebly",
      "label": "Weebly",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5cc"
    },
    {
      "name": "weibo",
      "label": "Weibo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f18a"
    },
    {
      "name": "weight-hanging",
      "label": "Weight Hanging",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "anvil",
        "heavy",
        "measurement"
      ],
      "unicode": "f5cd"
    },
    {
      "name": "weight-scale",
      "label": "Weight Scale",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "health",
        "measurement",
        "scale",
        "weight"
      ],
      "unicode": "f496"
    },
    {
      "name": "weixin",
      "label": "Weixin (WeChat)",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1d7"
    },
    {
      "name": "whatsapp",
      "label": "What's App",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f232"
    },
    {
      "name": "wheat-awn",
      "label": "Wheat Awn",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "agriculture",
        "autumn",
        "fall",
        "farming",
        "grain"
      ],
      "unicode": "e2cd"
    },
    {
      "name": "wheat-awn-circle-exclamation",
      "label": "Wheat Awn Circle Exclamation",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface",
        "Status & Alerts"
      ],
      "search": [
        "affected",
        "failed",
        "famine",
        "food",
        "gluten",
        "hunger",
        "starve",
        "straw"
      ],
      "unicode": "e598"
    },
    {
      "name": "wheelchair",
      "label": "Wheelchair",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "disabled",
        "uer",
        "users-people"
      ],
      "unicode": "f193"
    },
    {
      "name": "wheelchair-move",
      "label": "Wheelchair Move",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "access",
        "disabled",
        "handicap",
        "impairment",
        "physical",
        "uer",
        "wheelchair symbol"
      ],
      "unicode": "e2ce"
    },
    {
      "name": "whiskey-glass",
      "label": "Whiskey Glass",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "alcohol",
        "bar",
        "beverage",
        "bourbon",
        "drink",
        "glass",
        "liquor",
        "neat",
        "rye",
        "scotch",
        "shot",
        "tumbler",
        "tumbler glass",
        "whisky"
      ],
      "unicode": "f7a0"
    },
    {
      "name": "whmcs",
      "label": "WHMCS",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f40d"
    },
    {
      "name": "wifi",
      "label": "Wifi",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "connection",
        "hotspot",
        "internet",
        "network",
        "signal",
        "wireless",
        "www"
      ],
      "unicode": "f1eb"
    },
    {
      "name": "wikipedia-w",
      "label": "Wikipedia W",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f266"
    },
    {
      "name": "wind",
      "label": "Wind",
      "styles": [
        "solid"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "air",
        "blow",
        "breeze",
        "fall",
        "seasonal",
        "weather"
      ],
      "unicode": "f72e"
    },
    {
      "name": "window-maximize",
      "label": "Window Maximize",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "Maximize",
        "browser",
        "computer",
        "development",
        "expand"
      ],
      "unicode": "f2d0"
    },
    {
      "name": "window-minimize",
      "label": "Window Minimize",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Weather"
      ],
      "search": [
        "Minimize",
        "browser",
        "collapse",
        "computer",
        "development"
      ],
      "unicode": "f2d1"
    },
    {
      "name": "window-restore",
      "label": "Window Restore",
      "styles": [
        "solid",
        "regular"
      ],
      "categories": [
        "Shopping",
        "Weather"
      ],
      "search": [
        "browser",
        "computer",
        "development"
      ],
      "unicode": "f2d2"
    },
    {
      "name": "windows",
      "label": "Windows",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands",
        "Weather"
      ],
      "search": [
        "microsoft",
        "operating system",
        "os"
      ],
      "unicode": "f17a"
    },
    {
      "name": "wine-bottle",
      "label": "Wine Bottle",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "beverage",
        "cabernet",
        "drink",
        "glass",
        "grapes",
        "merlot",
        "sauvignon"
      ],
      "unicode": "f72f"
    },
    {
      "name": "wine-glass",
      "label": "Wine Glass",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "bar",
        "beverage",
        "cabernet",
        "drink",
        "glass",
        "grapes",
        "merlot",
        "sauvignon",
        "wine",
        "wine glass"
      ],
      "unicode": "f4e3"
    },
    {
      "name": "wine-glass-empty",
      "label": "Wine Glass Empty",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "alcohol",
        "beverage",
        "cabernet",
        "drink",
        "grapes",
        "merlot",
        "sauvignon"
      ],
      "unicode": "f5ce"
    },
    {
      "name": "wirsindhandwerk",
      "label": "wirsindhandwerk",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e2d0"
    },
    {
      "name": "wix",
      "label": "Wix",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f5cf"
    },
    {
      "name": "wizards-of-the-coast",
      "label": "Wizards of the Coast",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Dungeons & Dragons",
        "d&d",
        "dnd",
        "fantasy",
        "game",
        "gaming",
        "tabletop"
      ],
      "unicode": "f730"
    },
    {
      "name": "wodu",
      "label": "Wodu",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "e088"
    },
    {
      "name": "wolf-pack-battalion",
      "label": "Wolf Pack Battalion",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f514"
    },
    {
      "name": "won-sign",
      "label": "Won Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Won Sign",
        "currency"
      ],
      "unicode": "f159"
    },
    {
      "name": "wordpress",
      "label": "WordPress Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f19a"
    },
    {
      "name": "wordpress-simple",
      "label": "Wordpress Simple",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f411"
    },
    {
      "name": "worm",
      "label": "Worm",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "dirt",
        "garden",
        "worm",
        "wriggle"
      ],
      "unicode": "e599"
    },
    {
      "name": "wpbeginner",
      "label": "WPBeginner",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f297"
    },
    {
      "name": "wpexplorer",
      "label": "WPExplorer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2de"
    },
    {
      "name": "wpforms",
      "label": "WPForms",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f298"
    },
    {
      "name": "wpressr",
      "label": "wpressr",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "rendact"
      ],
      "unicode": "f3e4"
    },
    {
      "name": "wrench",
      "label": "Wrench",
      "styles": [
        "solid"
      ],
      "categories": [
        "UI & Interface"
      ],
      "search": [
        "configuration",
        "construction",
        "equipment",
        "fix",
        "mechanic",
        "modify",
        "plumbing",
        "settings",
        "spanner",
        "tool",
        "update",
        "wrench"
      ],
      "unicode": "f0ad"
    },
    {
      "name": "x",
      "label": "X",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Latin Capital Letter X",
        "Latin Small Letter X",
        "letter",
        "uncheck"
      ],
      "unicode": "58"
    },
    {
      "name": "x-ray",
      "label": "X Ray",
      "styles": [
        "solid"
      ],
      "categories": [
        "Media"
      ],
      "search": [
        "health",
        "medical",
        "radiological images",
        "radiology",
        "skeleton"
      ],
      "unicode": "f497"
    },
    {
      "name": "x-twitter",
      "label": "X Twitter",
      "styles": [
        "brands"
      ],
      "categories": [
        "Social & Brands"
      ],
      "search": [
        "elon",
        "twitter",
        "x"
      ],
      "unicode": "e61b"
    },
    {
      "name": "xbox",
      "label": "Xbox",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f412"
    },
    {
      "name": "xing",
      "label": "Xing",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f168"
    },
    {
      "name": "xmark",
      "label": "Xmark",
      "styles": [
        "solid"
      ],
      "categories": [
        "Status & Alerts"
      ],
      "search": [
        "Cancellation X",
        "Multiplication Sign",
        "Multiplication X",
        "cancel",
        "close",
        "cross",
        "cross mark",
        "error",
        "exit",
        "incorrect",
        "mark",
        "multiplication",
        "multiply",
        "notice",
        "notification",
        "notify",
        "problem",
        "sign",
        "uncheck",
        "wrong",
        "x",
        "×"
      ],
      "unicode": "f00d"
    },
    {
      "name": "xmarks-lines",
      "label": "Xmarks Lines",
      "styles": [
        "solid"
      ],
      "categories": [
        "Security"
      ],
      "search": [
        "barricade",
        "barrier",
        "fence",
        "poison",
        "roadblock"
      ],
      "unicode": "e59a"
    },
    {
      "name": "y",
      "label": "Y",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter Y",
        "Latin Small Letter Y",
        "letter",
        "yay",
        "yes"
      ],
      "unicode": "59"
    },
    {
      "name": "y-combinator",
      "label": "Y Combinator",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f23b"
    },
    {
      "name": "yahoo",
      "label": "Yahoo Logo",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f19e"
    },
    {
      "name": "yammer",
      "label": "Yammer",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f840"
    },
    {
      "name": "yandex",
      "label": "Yandex",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f413"
    },
    {
      "name": "yandex-international",
      "label": "Yandex International",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f414"
    },
    {
      "name": "yarn",
      "label": "Yarn",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f7e3"
    },
    {
      "name": "yelp",
      "label": "Yelp",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f1e9"
    },
    {
      "name": "yen-sign",
      "label": "Yen Sign",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Yen Sign",
        "currency"
      ],
      "unicode": "f157"
    },
    {
      "name": "yin-yang",
      "label": "Yin Yang",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "daoism",
        "opposites",
        "religion",
        "tao",
        "taoism",
        "taoist",
        "yang",
        "yin",
        "yin yang"
      ],
      "unicode": "f6ad"
    },
    {
      "name": "yoast",
      "label": "Yoast",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f2b1"
    },
    {
      "name": "youtube",
      "label": "YouTube",
      "styles": [
        "brands"
      ],
      "categories": [
        "UI & Interface",
        "Media",
        "Social & Brands"
      ],
      "search": [
        "film",
        "video",
        "youtube-play",
        "youtube-square"
      ],
      "unicode": "f167"
    },
    {
      "name": "z",
      "label": "Z",
      "styles": [
        "solid"
      ],
      "categories": [
        "Other"
      ],
      "search": [
        "Latin Capital Letter Z",
        "Latin Small Letter Z",
        "letter"
      ],
      "unicode": "5a"
    },
    {
      "name": "zhihu",
      "label": "Zhihu",
      "styles": [
        "brands"
      ],
      "categories": [
        "Other"
      ],
      "search": [],
      "unicode": "f63f"
    }
  ]
}